// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer reset, base, tokens, recipes, utilities;

@layer base{
  :root {
    --made-with-panda: '🐼';
}

  *,::before,::after,::backdrop {
    --blur: /*-*/ /*-*/;
    --brightness: /*-*/ /*-*/;
    --contrast: /*-*/ /*-*/;
    --grayscale: /*-*/ /*-*/;
    --hue-rotate: /*-*/ /*-*/;
    --invert: /*-*/ /*-*/;
    --saturate: /*-*/ /*-*/;
    --sepia: /*-*/ /*-*/;
    --drop-shadow: /*-*/ /*-*/;
    --backdrop-blur: /*-*/ /*-*/;
    --backdrop-brightness: /*-*/ /*-*/;
    --backdrop-contrast: /*-*/ /*-*/;
    --backdrop-grayscale: /*-*/ /*-*/;
    --backdrop-hue-rotate: /*-*/ /*-*/;
    --backdrop-invert: /*-*/ /*-*/;
    --backdrop-opacity: /*-*/ /*-*/;
    --backdrop-saturate: /*-*/ /*-*/;
    --backdrop-sepia: /*-*/ /*-*/;
    --gradient-from-position: /*-*/ /*-*/;
    --gradient-to-position: /*-*/ /*-*/;
    --gradient-via-position: /*-*/ /*-*/;
    --scroll-snap-strictness: proximity;
    --border-spacing-x: 0;
    --border-spacing-y: 0;
    --translate-x: 0;
    --translate-y: 0;
    --rotate: 0;
    --rotate-x: 0;
    --rotate-y: 0;
    --skew-x: 0;
    --skew-y: 0;
    --scale-x: 1;
    --scale-y: 1;
}
}

@layer tokens{
  :where(:root, :host) {
    --vui-colors-extra-dark-teal-10: rgba(3, 38, 41, 0.1);
    --vui-colors-extra-dark-teal-20: rgba(3, 38, 41, 0.2);
    --vui-colors-extra-dark-teal-30: rgba(3, 38, 41, 0.3);
    --vui-colors-extra-dark-teal-40: rgba(3, 38, 41, 0.4);
    --vui-colors-extra-dark-teal-50: rgba(3, 38, 41, 0.5);
    --vui-colors-extra-dark-teal-60: rgba(3, 38, 41, 0.6);
    --vui-colors-extra-dark-teal-70: rgba(3, 38, 41, 0.7);
    --vui-colors-extra-dark-teal-80: rgba(3, 38, 41, 0.8);
    --vui-colors-extra-dark-teal-90: rgba(3, 38, 41, 0.9);
    --vui-colors-extra-dark-teal-100: rgba(3, 38, 41, 1);
    --vui-colors-dark-teal-10: rgba(10, 50, 53, 0.1);
    --vui-colors-dark-teal-20: rgba(10, 50, 53, 0.2);
    --vui-colors-dark-teal-30: rgba(10, 50, 53, 0.3);
    --vui-colors-dark-teal-40: rgba(10, 50, 53, 0.4);
    --vui-colors-dark-teal-50: rgba(10, 50, 53, 0.5);
    --vui-colors-dark-teal-60: rgba(10, 50, 53, 0.6);
    --vui-colors-dark-teal-70: rgba(10, 50, 53, 0.7);
    --vui-colors-dark-teal-80: rgba(10, 50, 53, 0.8);
    --vui-colors-dark-teal-90: rgba(10, 50, 53, 0.9);
    --vui-colors-dark-teal-100: rgba(10, 50, 53, 1);
    --vui-colors-cream-10: rgba(250, 242, 233, 0.1);
    --vui-colors-cream-20: rgba(250, 242, 233, 0.2);
    --vui-colors-cream-30: rgba(250, 242, 233, 0.3);
    --vui-colors-cream-40: rgba(250, 242, 233, 0.4);
    --vui-colors-cream-50: rgba(250, 242, 233, 0.5);
    --vui-colors-cream-60: rgba(250, 242, 233, 0.6);
    --vui-colors-cream-70: rgba(250, 242, 233, 0.7);
    --vui-colors-cream-80: rgba(250, 242, 233, 0.8);
    --vui-colors-cream-90: rgba(250, 242, 233, 0.9);
    --vui-colors-cream-100: rgba(250, 242, 233, 1);
    --vui-colors-info-blue-20: rgba(212, 231, 252, 1);
    --vui-colors-info-blue-40: rgba(170, 207, 249, 1);
    --vui-colors-info-blue-60: rgba(127, 184, 245, 1);
    --vui-colors-info-blue-80: rgba(85, 160, 242, 1);
    --vui-colors-info-blue-100: rgba(42, 136, 239, 1);
    --vui-colors-error-red-20: rgba(255, 218, 218, 1);
    --vui-colors-error-red-40: rgba(254, 181, 181, 1);
    --vui-colors-error-red-60: rgba(254, 144, 143, 1);
    --vui-colors-error-red-80: rgba(253, 107, 106, 1);
    --vui-colors-error-red-100: rgba(253, 70, 69, 1);
    --vui-colors-success-green-20: rgba(221, 235, 215, 1);
    --vui-colors-success-green-40: rgba(187, 215, 174, 1);
    --vui-colors-success-green-60: rgba(152, 196, 134, 1);
    --vui-colors-success-green-80: rgba(118, 176, 93, 1);
    --vui-colors-success-green-100: rgba(84, 156, 53, 1);
    --vui-colors-warning-orange-20: rgba(255, 237, 210, 1);
    --vui-colors-warning-orange-40: rgba(255, 218, 164, 1);
    --vui-colors-warning-orange-60: rgba(255, 200, 119, 1);
    --vui-colors-warning-orange-80: rgba(255, 181, 73, 1);
    --vui-colors-warning-orange-100: rgba(255, 163, 28, 1);
    --vui-colors-teal-10: rgba(16, 82, 87, 0.1);
    --vui-colors-teal-20: rgba(16, 82, 87, 0.2);
    --vui-colors-teal-30: rgba(16, 82, 87, 0.3);
    --vui-colors-teal-40: rgba(16, 82, 87, 0.4);
    --vui-colors-teal-50: rgba(16, 82, 87, 0.5);
    --vui-colors-teal-60: rgba(16, 82, 87, 0.6);
    --vui-colors-teal-70: rgba(16, 82, 87, 0.7);
    --vui-colors-teal-80: rgba(16, 82, 87, 0.8);
    --vui-colors-teal-90: rgba(16, 82, 87, 0.9);
    --vui-colors-teal-100: rgba(16, 82, 87, 1);
    --vui-colors-pink-10: rgba(253, 238, 245, 1);
    --vui-colors-pink-20: rgba(252, 220, 235, 1);
    --vui-colors-pink-30: rgba(251, 203, 225, 1);
    --vui-colors-pink-40: rgba(249, 186, 215, 1);
    --vui-colors-pink-50: rgba(247, 168, 205, 1);
    --vui-colors-pink-60: rgba(246, 151, 196, 1);
    --vui-colors-pink-70: rgba(245, 134, 186, 1);
    --vui-colors-pink-80: rgba(243, 117, 176, 1);
    --vui-colors-pink-90: rgba(242, 99, 166, 1);
    --vui-colors-pink-100: rgba(240, 82, 156, 1);
    --vui-colors-purple-10: rgba(247, 232, 253, 1);
    --vui-colors-purple-20: rgba(239, 209, 250, 1);
    --vui-colors-purple-30: rgba(232, 187, 248, 1);
    --vui-colors-purple-40: rgba(224, 164, 246, 1);
    --vui-colors-purple-50: rgba(216, 141, 243, 1);
    --vui-colors-purple-60: rgba(208, 118, 241, 1);
    --vui-colors-purple-70: rgba(200, 95, 239, 1);
    --vui-colors-purple-80: rgba(193, 73, 237, 1);
    --vui-colors-purple-90: rgba(185, 50, 234, 1);
    --vui-colors-purple-100: rgba(177, 27, 232, 1);
    --vui-colors-green-10: rgba(231, 250, 243, 1);
    --vui-colors-green-20: rgba(207, 245, 232, 1);
    --vui-colors-green-30: rgba(183, 239, 221, 1);
    --vui-colors-green-40: rgba(159, 234, 209, 1);
    --vui-colors-green-50: rgba(135, 229, 197, 1);
    --vui-colors-green-60: rgba(111, 224, 186, 1);
    --vui-colors-green-70: rgba(87, 219, 175, 1);
    --vui-colors-green-80: rgba(63, 213, 163, 1);
    --vui-colors-green-90: rgba(39, 208, 156, 1);
    --vui-colors-green-100: rgba(15, 203, 140, 1);
    --vui-colors-gray-10: rgba(235, 235, 235, 1);
    --vui-colors-gray-20: rgba(214, 214, 214, 1);
    --vui-colors-gray-30: rgba(194, 194, 194, 1);
    --vui-colors-gray-40: rgba(174, 174, 174, 1);
    --vui-colors-gray-50: rgba(153, 153, 153, 1);
    --vui-colors-gray-60: rgba(133, 133, 133, 1);
    --vui-colors-gray-70: rgba(113, 113, 113, 1);
    --vui-colors-gray-80: rgba(93, 93, 93, 1);
    --vui-colors-gray-90: rgba(72, 72, 72, 1);
    --vui-colors-gray-100: rgba(52, 52, 52, 1);
    --vui-fonts-body: Manrope, Arial, sans-serif;
    --vui-fonts-heading: Telegraf, Manrope, Arial, sans-serif;
    --vui-fonts-monospace: 'Space Mono', monospace;
    --vui-font-sizes-4xl: 2.25rem;
    --vui-font-sizes-3xl: 2rem;
    --vui-font-sizes-2xl: 1.5rem;
    --vui-font-sizes-xl: 1.25rem;
    --vui-font-sizes-lg: 1.125rem;
    --vui-font-sizes-md: 1rem;
    --vui-font-sizes-sm: 0.875rem;
    --vui-font-weights-light: 300;
    --vui-font-weights-regular: 400;
    --vui-font-weights-medium: 500;
    --vui-font-weights-semi-bold: 600;
    --vui-font-weights-bold: 700;
    --vui-spacing-0: 0;
    --vui-spacing-1: .25rem;
    --vui-spacing-2: .5rem;
    --vui-spacing-3: .75rem;
    --vui-spacing-4: 1rem;
    --vui-spacing-5: 1.25rem;
    --vui-spacing-6: 1.5rem;
    --vui-spacing-7: 1.75rem;
    --vui-spacing-8: 2rem;
    --vui-radii-xs: 2px;
    --vui-radii-sm: 4px;
    --vui-radii-md: 8px;
    --vui-radii-lg: 12px;
    --vui-radii-xl: 16px;
    --vui-radii-full: 9999px;
    --vui-z-index-backdrop: 1300;
    --vui-z-index-drawer: 1400;
    --vui-z-index-snackbar: 1500;
    --vui-z-index-modal: 1600;
    --vui-breakpoints-xs: 0rem;
    --vui-breakpoints-sm: 37.5rem;
    --vui-breakpoints-md: 56.25rem;
    --vui-breakpoints-lg: 75rem;
    --vui-breakpoints-xl: 96rem;
    --vui-sizes-breakpoint-xs: 0rem;
    --vui-sizes-breakpoint-sm: 37.5rem;
    --vui-sizes-breakpoint-md: 56.25rem;
    --vui-sizes-breakpoint-lg: 75rem;
    --vui-sizes-breakpoint-xl: 96rem;
    --vui-colors-background: var(--vui-colors-cream-100);
    --vui-colors-background-reversed: var(--vui-colors-dark-teal-100);
    --vui-colors-text-primary: var(--vui-colors-dark-teal-100);
    --vui-colors-text-primary-reversed: var(--vui-colors-cream-100);
    --vui-colors-text-secondary: var(--vui-colors-extra-dark-teal-100);
    --vui-colors-text-secondary-reversed: var(--vui-colors-cream-100);
    --vui-colors-accent-primary: var(--vui-colors-pink-100);
    --vui-colors-accent-secondary: var(--vui-colors-green-100);
    --vui-colors-accent-tertiary: var(--vui-colors-purple-100);
    --vui-colors-alert-error: var(--vui-colors-error-red-100);
    --vui-colors-alert-warning: var(--vui-colors-warning-orange-100);
    --vui-colors-alert-confirmation: var(--vui-colors-success-green-100);
    --vui-colors-alert-information: var(--vui-colors-info-blue-100);
    --vui-colors-charting-categorical-dark--red: var(--vui-colors--r4);
    --vui-colors-charting-categorical-dark--orange: var(--vui-colors--o4);
    --vui-colors-charting-categorical-dark--aqua: var(--vui-colors--a3);
    --vui-colors-charting-categorical-dark--teal: var(--vui-colors--t3);
    --vui-colors-charting-categorical-dark--blue: var(--vui-colors--b3);
    --vui-colors-charting-categorical-dark--magenta: var(--vui-colors--m4);
    --vui-colors-charting-categorical-dark--purple: var(--vui-colors--p4);
    --vui-colors-charting-categorical-dark--green: var(--vui-colors--g4);
    --vui-colors-charting-categorical-light--red: var(--vui-colors--r10);
    --vui-colors-charting-categorical-light--orange: var(--vui-colors--o9);
    --vui-colors-charting-categorical-light--aqua: var(--vui-colors--a10);
    --vui-colors-charting-categorical-light--teal: var(--vui-colors--t8);
    --vui-colors-charting-categorical-light--blue: var(--vui-colors--b6);
    --vui-colors-charting-categorical-light--magenta: var(--vui-colors--m10);
    --vui-colors-charting-categorical-light--purple: var(--vui-colors--p8);
    --vui-colors-charting-categorical-light--green: var(--vui-colors--g10);
}

  :where(.dark, [data-color-mode=dark]) {
    --vui-colors-background: var(--vui-colors-dark-teal-100);
    --vui-colors-background-reversed: var(--vui-colors-cream-100);
    --vui-colors-text-primary: var(--vui-colors-cream-100);
    --vui-colors-text-primary-reversed: var(--vui-colors-dark-teal-100);
    --vui-colors-text-secondary: var(--vui-colors-gray-10);
    --vui-colors-text-secondary-reversed: var(--vui-colors-gray-80)
}

  @keyframes loading-spinner-rotate {
    0% {
      transform: rotate(0deg);
}

    100% {
      transform: rotate(360deg);
}
}

  @keyframes fadeIn {
    0% {
      opacity: 0;
}

    100% {
      opacity: 1;
}
}

  @keyframes fadeOut {
    0% {
      opacity: 1;
}

    100% {
      opacity: 0;
}
}

  @keyframes slideInLeft {
    from {
      transform: translateX(-100%);
      opacity: 0;
}

    to {
      transform: translateX(0);
      opacity: 1;
}
}

  @keyframes slideInRight {
    from {
      transform: translateX(100%);
      opacity: 0;
}

    to {
      transform: translateX(0);
      opacity: 1;
}
}

  @keyframes slideInTop {
    from {
      transform: translateY(-100%);
      opacity: 0;
}

    to {
      transform: translateY(0);
      opacity: 1;
}
}

  @keyframes slideInBottom {
    from {
      transform: translateY(100%);
      opacity: 0;
}

    to {
      transform: translateY(0);
      opacity: 1;
}
}
}

@layer utilities{
  @layer compositions{

    .vui-textStyle_inherit,.after\\:vui-textStyle_inherit::after {
      font: inherit;
      letter-spacing: inherit;
      text-decoration: inherit;
      text-transform: inherit;
      line-height: inherit;
}
}

  .vui-d_flex {
    display: flex;
}

  .vui-gap_1 {
    gap: var(--vui-spacing-1);
}

  .vui-bdr_sm {
    border-radius: var(--vui-radii-sm);
}

  .vui-p_\\[8px\\] {
    padding: 8px;
}

  .vui-w_\\[100\\%\\] {
    width: 100%;
}

  .vui-c_text\\.primary {
    color: var(--vui-colors-text-primary);
}

  .vui---alert-color_\\{colors\\.success-green\\.100\\} {
    --alert-color: var(--vui-colors-success-green-100);
}

  .vui---alert-color_\\{colors\\.info-blue\\.100\\} {
    --alert-color: var(--vui-colors-info-blue-100);
}

  .vui---alert-color_\\{colors\\.warning-orange\\.100\\} {
    --alert-color: var(--vui-colors-warning-orange-100);
}

  .vui---alert-color_\\{colors\\.error-red\\.100\\} {
    --alert-color: var(--vui-colors-error-red-100);
}

  .vui-bd_\\[1px_solid_var\\(--alert-color\\)\\] {
    border: 1px solid var(--alert-color);
}

  .vui-c_extra-dark-teal\\.100 {
    color: var(--vui-colors-extra-dark-teal-100);
}

  .vui-c_\\[white\\] {
    color: white;
}

  .vui-c_var\\(--alert-color\\) {
    color: var(--alert-color);
}

  .vui-c_\\[inherit\\] {
    color: inherit;
}

  .vui-m_0 {
    margin: var(--vui-spacing-0);
}

  .vui-ap_none {
    appearance: none;
    -webkit-appearance: none;
}

  .vui-bd_0 {
    border: 0;
}

  .vui-p_0 {
    padding: var(--vui-spacing-0);
}

  .vui-cursor_pointer {
    cursor: pointer;
}

  .vui-ov_hidden {
    overflow: hidden;
}

  .vui-ta_center {
    text-align: center;
}

  .vui-m_\\[5px\\] {
    margin: 5px;
}

  .vui-w_\\[32px\\] {
    width: 32px;
}

  .vui-h_\\[32px\\] {
    height: 32px;
}

  .vui-w_\\[40px\\] {
    width: 40px;
}

  .vui-h_\\[40px\\] {
    height: 40px;
}

  .vui-w_\\[56px\\] {
    width: 56px;
}

  .vui-h_\\[56px\\] {
    height: 56px;
}

  .vui-bdr_\\[0\\] {
    border-radius: 0;
}

  .vui-bdr_\\[50\\%\\] {
    border-radius: 50%;
}

  .vui-p_\\[0\\] {
    padding: var(--vui-spacing-0);
}

  .vui-p_\\[4px\\] {
    padding: 4px;
}

  .vui-h_\\[100\\%\\] {
    height: 100%;
}

  .vui-obj-f_cover {
    object-fit: cover;
}

  .vui-bdr_\\[20\\%\\] {
    border-radius: 20%;
}

  .vui-bx-s_border-box {
    box-sizing: border-box;
}

  .vui-gap_\\[5px\\] {
    gap: 5px;
}

  .vui-d_inline-flex {
    display: inline-flex;
}

  .vui-bd_none {
    border: none;
}

  .vui-trs_\\[background-color_250ms\\,_color_250ms\\,_opacity_250ms\\] {
    transition: background-color 250ms, color 250ms, opacity 250ms;
}

  .vui-c_var\\(--button-color\\) {
    color: var(--button-color);
}

  .vui---button-color_\\{colors\\.accent\\.primary\\} {
    --button-color: var(--vui-colors-accent-primary);
}

  .vui---button-color_\\{colors\\.accent\\.secondary\\} {
    --button-color: var(--vui-colors-accent-secondary);
}

  .vui---button-color_\\{colors\\.accent\\.tertiary\\} {
    --button-color: var(--vui-colors-accent-tertiary);
}

  .vui---button-color_\\{colors\\.alert\\.warning\\} {
    --button-color: var(--vui-colors-alert-warning);
}

  .vui---button-color_\\{colors\\.alert\\.error\\} {
    --button-color: var(--vui-colors-alert-error);
}

  .vui---button-color_\\{colors\\.alert\\.information\\} {
    --button-color: var(--vui-colors-alert-information);
}

  .vui---button-color_\\{colors\\.alert\\.confirmation\\} {
    --button-color: var(--vui-colors-alert-confirmation);
}

  .vui---button-color_\\{colors\\.teal\\.100\\} {
    --button-color: var(--vui-colors-teal-100);
}

  .vui---button-color_\\{colors\\.cream\\.100\\} {
    --button-color: var(--vui-colors-cream-100);
}

  .vui---button-color_\\{colors\\.dark-teal\\.100\\} {
    --button-color: var(--vui-colors-dark-teal-100);
}

  .vui---button-color_\\{colors\\.text\\.primary\\} {
    --button-color: var(--vui-colors-text-primary);
}

  .vui---button-color_\\{colors\\.text\\.primary\\.reversed\\} {
    --button-color: var(--vui-colors-text-primary-reversed);
}

  .vui-bd_\\[1px_solid_var\\(--button-color\\)\\] {
    border: 1px solid var(--button-color);
}

  .vui-p_\\[4px_10px\\] {
    padding: 4px 10px;
}

  .vui-p_\\[6px_16px\\] {
    padding: 6px 16px;
}

  .vui-p_\\[12px_24px\\] {
    padding: 12px 24px;
}

  .vui-c_cream\\.100 {
    color: var(--vui-colors-cream-100);
}

  .vui-c_text\\.primary\\.reversed {
    color: var(--vui-colors-text-primary-reversed);
}

  .vui-p_\\[3px_9px\\] {
    padding: 3px 9px;
}

  .vui-p_\\[5px_15px\\] {
    padding: 5px 15px;
}

  .vui-p_\\[11px_23px\\] {
    padding: 11px 23px;
}

  .vui-va_middle {
    vertical-align: middle;
}

  .vui-gap_\\[8px\\] {
    gap: 8px;
}

  .vui-w_\\[20px\\] {
    width: 20px;
}

  .vui-h_\\[20px\\] {
    height: 20px;
}

  .vui-bd_\\[1px_solid\\] {
    border: 1px solid;
}

  .vui-bdr_xs {
    border-radius: var(--vui-radii-xs);
}

  .vui-w_\\[0\\.75rem\\] {
    width: 0.75rem;
}

  .vui-h_\\[0\\.75rem\\] {
    height: 0.75rem;
}

  .vui-w_\\[0\\.875rem\\] {
    width: 0.875rem;
}

  .vui-h_\\[0\\.875rem\\] {
    height: 0.875rem;
}

  .vui-w_\\[1\\.25rem\\] {
    width: 1.25rem;
}

  .vui-h_\\[1\\.25rem\\] {
    height: 1.25rem;
}

  .vui-c_accent\\.primary {
    color: var(--vui-colors-accent-primary);
}

  .vui-c_accent\\.secondary {
    color: var(--vui-colors-accent-secondary);
}

  .vui-c_accent\\.tertiary {
    color: var(--vui-colors-accent-tertiary);
}

  .vui-c_teal\\.100 {
    color: var(--vui-colors-teal-100);
}

  .vui-w_\\[0\\.625rem\\] {
    width: 0.625rem;
}

  .vui-h_\\[auto\\] {
    height: auto;
}

  .vui-stk-w_\\[4px\\] {
    stroke-width: 4px;
}

  .vui-stk_\\[currentColor\\] {
    stroke: currentColor;
}

  .vui-c_\\[transparent\\] {
    color: transparent;
}

  .vui-gap_\\[2px\\] {
    gap: 2px;
}

  .vui-gap_\\[4px\\] {
    gap: 4px;
}

  .vui-bdr_\\[40px\\] {
    border-radius: 40px;
}

  .vui-p_\\[5px\\] {
    padding: 5px;
}

  .vui---chip-color_\\[white\\] {
    --chip-color: white;
}

  .vui-bdr_\\[4px\\] {
    border-radius: 4px;
}

  .vui---chip-color_\\{colors\\.accent\\.primary\\} {
    --chip-color: var(--vui-colors-accent-primary);
}

  .vui---chip-color_\\{colors\\.accent\\.secondary\\} {
    --chip-color: var(--vui-colors-accent-secondary);
}

  .vui---chip-color_\\{colors\\.accent\\.tertiary\\} {
    --chip-color: var(--vui-colors-accent-tertiary);
}

  .vui-p_\\[5px_12px\\] {
    padding: 5px 12px;
}

  .vui-h_\\[36px\\] {
    height: 36px;
}

  .vui-p_\\[8px_15px\\] {
    padding: 8px 15px;
}

  .vui-h_\\[48px\\] {
    height: 48px;
}

  .vui-p_\\[12px_20px\\] {
    padding: 12px 20px;
}

  .vui-bg_\\[none\\] {
    background: none;
}

  .vui-ring_none {
    outline: 2px solid transparent;
    outline-offset: 2px;
}

  .vui-flex_1 {
    flex: 1 1 0%;
}

  .vui-m_\\[0\\] {
    margin: var(--vui-spacing-0);
}

  .vui-gap_\\[16px\\] {
    gap: 16px;
}

  .vui-ov_auto {
    overflow: auto;
}

  .vui-bx-sh_\\[0_0_15px_rgba\\(0\\,_0\\,_0\\,_0\\.5\\)\\] {
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

  .vui-trs_\\[transform_0\\.3s_ease\\] {
    transition: transform 0.3s ease;
}

  .vui-w_\\[320px\\] {
    width: 320px;
}

  .vui-trf_\\[translateX\\(-100\\%\\)\\] {
    transform: translateX(-100%);
}

  .vui-trf_\\[translateX\\(100\\%\\)\\] {
    transform: translateX(100%);
}

  .vui-h_\\[320px\\] {
    height: 320px;
}

  .vui-trf_\\[translateY\\(-100\\%\\)\\] {
    transform: translateY(-100%);
}

  .vui-trf_\\[translateY\\(100\\%\\)\\] {
    transform: translateY(100%);
}

  .vui-trf_translate\\(0\\) {
    transform: translate(0);
}

  .vui-z_drawer {
    z-index: var(--vui-z-index-drawer);
}

  .vui-pos_fixed {
    position: fixed;
}

  .vui-pos_relative {
    position: relative;
}

  .vui-trf_none {
    transform: none;
}

  .vui-w_\\[20\\%\\] {
    width: 20%;
}

  .vui-order_999 {
    order: 999;
}

  .vui-anim_slideInLeft_250ms_ease-out_forwards {
    animation: slideInLeft 250ms ease-out forwards;
}

  .vui-anim_slideInRight_250ms_ease-out_forwards {
    animation: slideInRight 250ms ease-out forwards;
}

  .vui-anim_slideInTop_250ms_ease-out_forwards {
    animation: slideInTop 250ms ease-out forwards;
}

  .vui-anim_slideInBottom_250ms_ease-out_forwards {
    animation: slideInBottom 250ms ease-out forwards;
}

  .vui-bg_\\[rgba\\(0\\,_0\\,_0\\,_0\\.5\\)\\] {
    background: rgba(0, 0, 0, 0.5);
}

  .vui-trs_\\[opacity_0\\.3s_ease\\,_visibility_0\\.3s_ease\\] {
    transition: opacity 0.3s ease, visibility 0.3s ease;
}

  .vui-op_\\[0\\] {
    opacity: 0;
}

  .vui-vis_hidden {
    visibility: hidden;
}

  .vui-pointer-events_none {
    pointer-events: none;
}

  .vui-will-change_opacity {
    will-change: opacity;
}

  .vui-vis_visible {
    visibility: visible;
}

  .vui-op_1 {
    opacity: 1;
}

  .vui-pointer-events_auto {
    pointer-events: auto;
}

  .vui-z_backdrop {
    z-index: var(--vui-z-index-backdrop);
}

  .vui-trs_\\[opacity_0\\.3s_ease\\,_visibility_0s_0\\.3s\\] {
    transition: opacity 0.3s ease, visibility 0s 0.3s;
}

  .vui-d_none {
    display: none;
}

  .vui-h_\\[100vh\\] {
    height: 100vh;
}

  .vui-d_grid {
    display: grid;
}

  .vui-place-items_center {
    place-items: center;
}

  .vui-w_\\[750px\\] {
    width: 750px;
}

  .vui-m_auto {
    margin: auto;
}

  .vui-p_\\[16px\\] {
    padding: 16px;
}

  .vui-min-h_\\[50\\%\\] {
    min-height: 50%;
}

  .vui-max-h_\\[90\\%\\] {
    max-height: 90%;
}

  .vui-bd_2px_solid_red {
    border: 2px solid red;
}

  .vui-w_\\[fit-content\\] {
    width: fit-content;
}

  .vui-bd_\\[none\\] {
    border: none;
}

  .vui-p_\\[6px_12px\\] {
    padding: 6px 12px;
}

  .vui-p_\\[24px_36px\\] {
    padding: 24px 36px;
}

  .vui-c_primary {
    color: primary;
}

  .vui-c_dark-teal\\.100 {
    color: var(--vui-colors-dark-teal-100);
}

  .vui-gap_\\[0px\\] {
    gap: 0px;
}

  .vui-pos_sticky {
    position: sticky;
}

  .vui-bdr_\\[16px\\] {
    border-radius: 16px;
}

  .vui-bdr_full {
    border-radius: var(--vui-radii-full);
}

  .vui-white-space_nowrap {
    white-space: nowrap;
}

  .vui-p_\\[16px_32px\\] {
    padding: 16px 32px;
}

  .vui-p_\\[16px_24px\\] {
    padding: 16px 24px;
}

  .vui-gap_\\[12px\\] {
    gap: 12px;
}

  .vui-gap_\\[1rem\\] {
    gap: 1rem;
}

  .vui-asp_1 {
    aspect-ratio: 1;
}

  .vui-w_\\[1em\\] {
    width: 1em;
}

  .vui-c_cream {
    color: cream;
}

  .vui-max-h_\\[70vh\\] {
    max-height: 70vh;
}

  .vui-td_none {
    text-decoration: none;
}

  .vui-trf-o_center {
    transform-origin: center;
}

  .vui-anim_loading-spinner-rotate_0\\.75s_infinite_linear {
    animation: loading-spinner-rotate 0.75s infinite linear;
}

  .vui---spinner-color_\\{colors\\.dark-teal\\.100\\} {
    --spinner-color: var(--vui-colors-dark-teal-100);
}

  .vui-w_\\[16px\\] {
    width: 16px;
}

  .vui-h_\\[16px\\] {
    height: 16px;
}

  .vui-w_\\[64px\\] {
    width: 64px;
}

  .vui-h_\\[64px\\] {
    height: 64px;
}

  .vui---spinner-color_colors\\.accent\\.primary {
    --spinner-color: var(--vui-colors-accent-primary);
}

  .vui---spinner-color_colors\\.accent\\.secondary {
    --spinner-color: var(--vui-colors-accent-secondary);
}

  .vui---spinner-color_colors\\.accent\\.tertiary {
    --spinner-color: var(--vui-colors-accent-tertiary);
}

  .vui-asp_517\\/133 {
    aspect-ratio: 517/133;
}

  .vui-asp_756\\/240 {
    aspect-ratio: 756/240;
}

  .vui-asp_1119\\/133 {
    aspect-ratio: 1119/133;
}

  .vui-asp_1960\\/170 {
    aspect-ratio: 1960/170;
}

  .vui-asp_1485\\/173 {
    aspect-ratio: 1485/173;
}

  .vui-asp_1171\\/137 {
    aspect-ratio: 1171/137;
}

  .vui-asp_704\\/137 {
    aspect-ratio: 704/137;
}

  .vui-asp_1332\\/171 {
    aspect-ratio: 1332/171;
}

  .vui-asp_750\\/137 {
    aspect-ratio: 750/137;
}

  .vui-asp_780\\/133 {
    aspect-ratio: 780/133;
}

  .vui-asp_659\\/133 {
    aspect-ratio: 659/133;
}

  .vui-asp_773\\/133 {
    aspect-ratio: 773/133;
}

  .vui-asp_789\\/137 {
    aspect-ratio: 789/137;
}

  .vui-asp_690\\/130 {
    aspect-ratio: 690/130;
}

  .vui-asp_1130\\/173 {
    aspect-ratio: 1130/173;
}

  .vui-asp_1114\\/171 {
    aspect-ratio: 1114/171;
}

  .vui-asp_559\\/137 {
    aspect-ratio: 559/137;
}

  .vui-asp_507\\/137 {
    aspect-ratio: 507/137;
}

  .vui-asp_632\\/137 {
    aspect-ratio: 632/137;
}

  .vui-asp_1173\\/137 {
    aspect-ratio: 1173/137;
}

  .vui-asp_1034\\/137 {
    aspect-ratio: 1034/137;
}

  .vui-asp_797\\/137 {
    aspect-ratio: 797/137;
}

  .vui-ls_0 {
    letter-spacing: 0;
}

  .vui-max-w_\\[100\\%\\] {
    max-width: 100%;
}

  .vui-td_line-through {
    text-decoration: line-through;
}

  .vui-bd-cl_collapse {
    border-collapse: collapse;
}

  .vui-inset_\\[0\\] {
    inset: var(--vui-spacing-0);
}

  .vui-z_modal {
    z-index: var(--vui-z-index-modal);
}

  .vui---modal-margin_32px {
    --modal-margin: 32px;
}

  .vui-m_var\\(--modal-margin\\) {
    margin: var(--modal-margin);
}

  .vui-max-h_\\[calc\\(100\\%_-_var\\(--modal-margin\\)\\)\\] {
    max-height: calc(100% - var(--modal-margin));
}

  .vui-max-w_\\[300px\\] {
    max-width: 300px;
}

  .vui-max-w_\\[500px\\] {
    max-width: 500px;
}

  .vui-max-w_\\[800px\\] {
    max-width: 800px;
}

  .vui-p_\\[8px_16px\\] {
    padding: 8px 16px;
}

  .vui-px_\\[16px\\] {
    padding-inline: 16px;
}

  .vui-cursor_default {
    cursor: default;
}

  .vui-offset_0 {
    offset: 0;
}

  .vui-p_\\[8px_20px\\] {
    padding: 8px 20px;
}

  .vui-p_\\[8px_24px\\] {
    padding: 8px 24px;
}

  .vui-trs_\\[transform_250ms\\] {
    transition: transform 250ms;
}

  .vui-bdr_md {
    border-radius: var(--vui-radii-md);
}

  .vui-p_\\[8px_8px\\] {
    padding: 8px 8px;
}

  .vui-w_\\[24px\\] {
    width: 24px;
}

  .vui-h_\\[24px\\] {
    height: 24px;
}

  .vui-min-w_var\\(--trigger-width\\) {
    min-width: var(--trigger-width);
}

  .vui-ring-o_\\[0\\] {
    outline-offset: var(--vui-spacing-0);
}

  .vui---slider-control-size_\\[0\\.75rem\\] {
    --slider-control-size: 0.75rem;
}

  .vui---slider-track-size_\\[0\\.25rem\\] {
    --slider-track-size: 0.25rem;
}

  .vui---slider-control-size_\\[0\\.875rem\\] {
    --slider-control-size: 0.875rem;
}

  .vui---slider-control-size_\\[1\\.25rem\\] {
    --slider-control-size: 1.25rem;
}

  .vui---slider-track-size_\\[0\\.375rem\\] {
    --slider-track-size: 0.375rem;
}

  .vui-c_\\[currentColor\\] {
    color: currentColor;
}

  .vui-grid-c_\\[1_\\/_-1\\] {
    grid-column: 1 / -1;
}

  .vui-h_var\\(--slider-control-size\\) {
    height: var(--slider-control-size);
}

  .vui-w_var\\(--slider-control-size\\) {
    width: var(--slider-control-size);
}

  .vui-h_var\\(--slider-track-size\\) {
    height: var(--slider-track-size);
}

  .vui-w_var\\(--slider-track-size\\) {
    width: var(--slider-track-size);
}

  .vui-c_pink\\.80 {
    color: var(--vui-colors-pink-80);
}

  .vui-c_green\\.80 {
    color: var(--vui-colors-green-80);
}

  .vui-c_purple\\.80 {
    color: var(--vui-colors-purple-80);
}

  .vui-c_teal\\.80 {
    color: var(--vui-colors-teal-80);
}

  .vui-p_\\[16px_16px_16px_24px\\] {
    padding: 16px 16px 16px 24px;
}

  .vui-tov_ellipsis {
    text-overflow: ellipsis;
}

  .vui-anim_fadeIn_250ms_ease-out_forwards {
    animation: fadeIn 250ms ease-out forwards;
}

  .vui-z_\\[snackbar\\] {
    z-index: var(--vui-z-index-snackbar);
}

  .vui-trf_translateX\\(-50\\%\\) {
    transform: translateX(-50%);
}

  .vui-gap_0 {
    gap: var(--vui-spacing-0);
}

  .vui-gap_\\[1px\\] {
    gap: 1px;
}

  .vui-gap_\\[3px\\] {
    gap: 3px;
}

  .vui-gap_\\[6px\\] {
    gap: 6px;
}

  .vui-gap_\\[7px\\] {
    gap: 7px;
}

  .vui-gap_\\[9px\\] {
    gap: 9px;
}

  .vui-gap_\\[10px\\] {
    gap: 10px;
}

  .vui-gap_\\[11px\\] {
    gap: 11px;
}

  .vui-gap_\\[13px\\] {
    gap: 13px;
}

  .vui-gap_\\[14px\\] {
    gap: 14px;
}

  .vui-gap_\\[15px\\] {
    gap: 15px;
}

  .vui-gap_\\[17px\\] {
    gap: 17px;
}

  .vui-gap_\\[18px\\] {
    gap: 18px;
}

  .vui-gap_\\[19px\\] {
    gap: 19px;
}

  .vui-gap_\\[20px\\] {
    gap: 20px;
}

  .vui-gap_\\[21px\\] {
    gap: 21px;
}

  .vui-gap_\\[22px\\] {
    gap: 22px;
}

  .vui-gap_\\[23px\\] {
    gap: 23px;
}

  .vui-gap_\\[24px\\] {
    gap: 24px;
}

  .vui-gap_\\[25px\\] {
    gap: 25px;
}

  .vui-gap_\\[26px\\] {
    gap: 26px;
}

  .vui-gap_\\[27px\\] {
    gap: 27px;
}

  .vui-gap_\\[28px\\] {
    gap: 28px;
}

  .vui-gap_\\[29px\\] {
    gap: 29px;
}

  .vui-gap_\\[30px\\] {
    gap: 30px;
}

  .vui-gap_\\[31px\\] {
    gap: 31px;
}

  .vui-gap_\\[32px\\] {
    gap: 32px;
}

  .vui-gap_\\[33px\\] {
    gap: 33px;
}

  .vui-gap_\\[34px\\] {
    gap: 34px;
}

  .vui-gap_\\[35px\\] {
    gap: 35px;
}

  .vui-gap_\\[36px\\] {
    gap: 36px;
}

  .vui-gap_\\[37px\\] {
    gap: 37px;
}

  .vui-gap_\\[38px\\] {
    gap: 38px;
}

  .vui-gap_\\[39px\\] {
    gap: 39px;
}

  .vui-gap_\\[40px\\] {
    gap: 40px;
}

  .vui-gap_\\[41px\\] {
    gap: 41px;
}

  .vui-gap_\\[42px\\] {
    gap: 42px;
}

  .vui-gap_\\[43px\\] {
    gap: 43px;
}

  .vui-gap_\\[44px\\] {
    gap: 44px;
}

  .vui-gap_\\[45px\\] {
    gap: 45px;
}

  .vui-gap_\\[46px\\] {
    gap: 46px;
}

  .vui-gap_\\[47px\\] {
    gap: 47px;
}

  .vui-gap_\\[48px\\] {
    gap: 48px;
}

  .vui-gap_\\[49px\\] {
    gap: 49px;
}

  .vui-gap_\\[50px\\] {
    gap: 50px;
}

  .vui-gap_\\[51px\\] {
    gap: 51px;
}

  .vui-gap_\\[52px\\] {
    gap: 52px;
}

  .vui-gap_\\[53px\\] {
    gap: 53px;
}

  .vui-gap_\\[54px\\] {
    gap: 54px;
}

  .vui-gap_\\[55px\\] {
    gap: 55px;
}

  .vui-gap_\\[56px\\] {
    gap: 56px;
}

  .vui-gap_\\[57px\\] {
    gap: 57px;
}

  .vui-gap_\\[58px\\] {
    gap: 58px;
}

  .vui-gap_\\[59px\\] {
    gap: 59px;
}

  .vui-gap_\\[60px\\] {
    gap: 60px;
}

  .vui-gap_\\[61px\\] {
    gap: 61px;
}

  .vui-gap_\\[62px\\] {
    gap: 62px;
}

  .vui-gap_\\[63px\\] {
    gap: 63px;
}

  .vui-gap_\\[64px\\] {
    gap: 64px;
}

  .vui-gap_\\[65px\\] {
    gap: 65px;
}

  .vui-gap_\\[66px\\] {
    gap: 66px;
}

  .vui-gap_\\[67px\\] {
    gap: 67px;
}

  .vui-gap_\\[68px\\] {
    gap: 68px;
}

  .vui-gap_\\[69px\\] {
    gap: 69px;
}

  .vui-gap_\\[70px\\] {
    gap: 70px;
}

  .vui-gap_\\[71px\\] {
    gap: 71px;
}

  .vui-gap_\\[72px\\] {
    gap: 72px;
}

  .vui-gap_\\[73px\\] {
    gap: 73px;
}

  .vui-gap_\\[74px\\] {
    gap: 74px;
}

  .vui-gap_\\[75px\\] {
    gap: 75px;
}

  .vui-gap_\\[76px\\] {
    gap: 76px;
}

  .vui-gap_\\[77px\\] {
    gap: 77px;
}

  .vui-gap_\\[78px\\] {
    gap: 78px;
}

  .vui-gap_\\[79px\\] {
    gap: 79px;
}

  .vui-gap_\\[80px\\] {
    gap: 80px;
}

  .vui-gap_\\[81px\\] {
    gap: 81px;
}

  .vui-gap_\\[82px\\] {
    gap: 82px;
}

  .vui-gap_\\[83px\\] {
    gap: 83px;
}

  .vui-gap_\\[84px\\] {
    gap: 84px;
}

  .vui-gap_\\[85px\\] {
    gap: 85px;
}

  .vui-gap_\\[86px\\] {
    gap: 86px;
}

  .vui-gap_\\[87px\\] {
    gap: 87px;
}

  .vui-gap_\\[88px\\] {
    gap: 88px;
}

  .vui-gap_\\[89px\\] {
    gap: 89px;
}

  .vui-gap_\\[90px\\] {
    gap: 90px;
}

  .vui-gap_\\[91px\\] {
    gap: 91px;
}

  .vui-gap_\\[92px\\] {
    gap: 92px;
}

  .vui-gap_\\[93px\\] {
    gap: 93px;
}

  .vui-gap_\\[94px\\] {
    gap: 94px;
}

  .vui-gap_\\[95px\\] {
    gap: 95px;
}

  .vui-gap_\\[96px\\] {
    gap: 96px;
}

  .vui-gap_\\[97px\\] {
    gap: 97px;
}

  .vui-gap_\\[98px\\] {
    gap: 98px;
}

  .vui-gap_\\[99px\\] {
    gap: 99px;
}

  .vui-gap_\\[100px\\] {
    gap: 100px;
}

  .vui-p_\\[1px\\] {
    padding: 1px;
}

  .vui-w_\\[1\\.375rem\\] {
    width: 1.375rem;
}

  .vui-w_\\[1\\.625rem\\] {
    width: 1.625rem;
}

  .vui-w_\\[2\\.3125rem\\] {
    width: 2.3125rem;
}

  .vui-pos_absolute {
    position: absolute;
}

  .vui-d_block {
    display: block;
}

  .vui-trs_\\[right_0\\.2s_ease-in-out\\] {
    transition: right 0.2s ease-in-out;
}

  .vui-w_\\[0\\.5rem\\] {
    width: 0.5rem;
}

  .vui-bd-b_3px_solid_transparent {
    border-bottom: 3px solid transparent;
}

  .vui-bd-e_3px_solid_transparent {
    border-inline-end: 3px solid transparent;
}

  .vui-p_\\[10px\\] {
    padding: 10px;
}

  .vui-offset_10 {
    offset: 10px;
}

  .vui-bdr_\\[full\\] {
    border-radius: var(--vui-radii-full);
}

  .vui-c_background {
    color: var(--vui-colors-background);
}

  .vui-c_background\\.reversed {
    color: var(--vui-colors-background-reversed);
}

  .vui-c_alert\\.error {
    color: var(--vui-colors-alert-error);
}

  .vui-min-w_\\[0\\] {
    min-width: 0;
}

  .vui-p_\\[8px_12px\\] {
    padding: 8px 12px;
}

  .vui-p_\\[16px_16px\\] {
    padding: 16px 16px;
}

  .vui-p_\\[12px_12px\\] {
    padding: 12px 12px;
}

  .vui-bdr_\\[28px\\] {
    border-radius: 28px;
}

  .vui-grid-area_1_\\/_1_\\/_2_\\/_2 {
    grid-area: 1 / 1 / 2 / 2;
}

  .vui-resize_none {
    resize: none;
}

  .vui-scr-bar-g_\\[stable\\] {
    scrollbar-gutter: stable;
}

  .vui-scr-bar-c_\\[transparent_transparent\\] {
    scrollbar-color: transparent transparent;
}

  .vui-p_\\[4px_8px\\] {
    padding: 4px 8px;
}

  .vui-ai_flex-start {
    align-items: flex-start;
}

  .vui-bg-c_var\\(--alert-color\\) {
    background-color: var(--alert-color);
}

  .vui-fs_\\[22px\\] {
    font-size: 22px;
}

  .vui-lh_1 {
    line-height: 1;
}

  .vui-flex-g_1 {
    flex-grow: 1;
}

  .vui-fs_sm {
    font-size: var(--vui-font-sizes-sm);
}

  .vui-bg-c_\\[transparent\\] {
    background-color: transparent;
}

  .vui-jc_center {
    justify-content: center;
}

  .vui-ai_center {
    align-items: center;
}

  .vui-bg-c_accent\\.primary {
    background-color: var(--vui-colors-accent-primary);
}

  .vui-bg-c_accent\\.secondary {
    background-color: var(--vui-colors-accent-secondary);
}

  .vui-bg-c_cream\\.100 {
    background-color: var(--vui-colors-cream-100);
}

  .vui-ff_body {
    font-family: var(--vui-fonts-body);
}

  .vui-fw_medium {
    font-weight: var(--vui-font-weights-medium);
}

  .vui-bg-c_\\[var\\(--button-color\\)\\] {
    background-color: var(--button-color);
}

  .vui-lh_1\\.55 {
    line-height: 1.55;
}

  .vui-fs_md {
    font-size: var(--vui-font-sizes-md);
}

  .vui-lh_1\\.5 {
    line-height: 1.5;
}

  .vui-fs_\\[12px\\] {
    font-size: 12px;
}

  .vui-flex-sh_0 {
    flex-shrink: 0;
}

  .vui-bd-c_teal\\.80 {
    border-color: var(--vui-colors-teal-80);
}

  .vui-bg-c_\\[white\\] {
    background-color: white;
}

  .vui-bd-c_\\[transparent\\] {
    border-color: transparent;
}

  .vui-flex-d_column {
    flex-direction: column;
}

  .vui-bg-c_\\[var\\(--chip-color\\)\\] {
    background-color: var(--chip-color);
}

  .vui-bd-c_\\[var\\(--chip-color\\)\\] {
    border-color: var(--chip-color);
}

  .vui-bd-c_dark-teal\\.20 {
    border-color: var(--vui-colors-dark-teal-20);
}

  .vui-ml_\\[2px\\] {
    margin-left: 2px;
}

  .vui-flex-wrap_wrap {
    flex-wrap: wrap;
}

  .vui-fs_lg {
    font-size: var(--vui-font-sizes-lg);
}

  .vui-jc_end {
    justify-content: end;
}

  .vui-top_\\[0\\] {
    top: var(--vui-spacing-0);
}

  .vui-left_\\[0\\] {
    left: var(--vui-spacing-0);
}

  .vui-bg-c_background\\.reversed {
    background-color: var(--vui-colors-background-reversed);
}

  .vui-right_\\[0\\] {
    right: var(--vui-spacing-0);
}

  .vui-left_\\[unset\\] {
    left: unset;
}

  .vui-bottom_\\[0\\] {
    bottom: var(--vui-spacing-0);
}

  .vui-right_\\[unset\\] {
    right: unset;
}

  .vui-top_\\[unset\\] {
    top: unset;
}

  .vui-top_0 {
    top: var(--vui-spacing-0);
}

  .vui-left_0 {
    left: var(--vui-spacing-0);
}

  .vui-jc_space-between {
    justify-content: space-between;
}

  .vui-jc_flex-end {
    justify-content: flex-end;
}

  .vui-bg-c_extra-dark-teal\\.100 {
    background-color: var(--vui-colors-extra-dark-teal-100);
}

  .vui-ov-y_auto {
    overflow-y: auto;
}

  .vui-bd-c_\\[white\\] {
    border-color: white;
}

  .vui-fs_\\[14px\\] {
    font-size: 14px;
}

  .vui-fs_\\[16px\\] {
    font-size: 16px;
}

  .vui-jc_flex-start {
    justify-content: flex-start;
}

  .vui-ai_stretch {
    align-items: stretch;
}

  .vui-flex-d_row {
    flex-direction: row;
}

  .vui-flex-wrap_nowrap {
    flex-wrap: nowrap;
}

  .vui-as_center {
    align-self: center;
}

  .vui-fs_\\[24px\\] {
    font-size: 24px;
}

  .vui-fs_2xl {
    font-size: var(--vui-font-sizes-2xl);
}

  .vui-fw_semiBold {
    font-weight: var(--vui-font-weights-semi-bold);
}

  .vui-text-decoration-line_underline {
    text-decoration-line: underline;
}

  .vui-td-c_\\[currentColor\\/50\\] {
    --mix-textDecorationColor: color-mix(in srgb, currentColor 50%, transparent);
    text-decoration-color: var(--mix-textDecorationColor, currentColor);
}

  .vui-fs_\\[2\\.25rem\\] {
    font-size: 2.25rem;
}

  .vui-ff_\\[PP_Telegraf\\] {
    font-family: PP Telegraf;
}

  .vui-fw_\\[500\\] {
    font-weight: 500;
}

  .vui-font-style_normal {
    font-style: normal;
}

  .vui-lh_\\[43\\.2px\\] {
    line-height: 43.2px;
}

  .vui-fs_\\[2rem\\] {
    font-size: 2rem;
}

  .vui-lh_\\[38\\.4px\\] {
    line-height: 38.4px;
}

  .vui-fs_\\[1\\.5rem\\] {
    font-size: 1.5rem;
}

  .vui-lh_\\[28\\.8px\\] {
    line-height: 28.8px;
}

  .vui-fs_\\[1\\.25rem\\] {
    font-size: 1.25rem;
}

  .vui-lh_\\[24px\\] {
    line-height: 24px;
}

  .vui-fs_\\[1\\.125rem\\] {
    font-size: 1.125rem;
}

  .vui-lh_\\[21\\.6px\\] {
    line-height: 21.6px;
}

  .vui-fs_\\[1rem\\] {
    font-size: 1rem;
}

  .vui-lh_\\[20\\.8px\\] {
    line-height: 20.8px;
}

  .vui-fs_\\[0\\.875rem\\] {
    font-size: 0.875rem;
}

  .vui-ff_\\[Manrope\\] {
    font-family: Manrope;
}

  .vui-fw_\\[400\\] {
    font-weight: 400;
}

  .vui-lh_\\[21px\\] {
    line-height: 21px;
}

  .vui-li-t_revert {
    list-style-type: revert;
}

  .vui-mb_\\[16px\\] {
    margin-bottom: 16px;
}

  .vui-mb_0 {
    margin-bottom: var(--vui-spacing-0);
}

  .vui-font-style_italic {
    font-style: italic;
}

  .vui-bd-c_gray\\.60 {
    border-color: var(--vui-colors-gray-60);
}

  .vui-bg-c_\\[black\\/80\\] {
    --mix-backgroundColor: color-mix(in srgb, black 80%, transparent);
    background-color: var(--mix-backgroundColor, black);
}

  .vui-bg-c_background {
    background-color: var(--vui-colors-background);
}

  .vui-cg_\\[8px\\] {
    column-gap: 8px;
}

  .vui-ai_start {
    align-items: start;
}

  .vui-as_start {
    align-self: start;
}

  .vui-grid-tr_\\[1fr_auto_1fr\\] {
    grid-template-rows: 1fr auto 1fr;
}

  .vui-fs_\\[inherit\\] {
    font-size: inherit;
}

  .vui-bg-c_\\[inherit\\] {
    background-color: inherit;
}

  .vui-grid-tc_\\[24px_auto\\] {
    grid-template-columns: 24px auto;
}

  .vui-justify-self_center {
    justify-self: center;
}

  .vui-justify-self_start {
    justify-self: start;
}

  .vui-mt_0 {
    margin-top: var(--vui-spacing-0);
}

  .vui-outline-style_solid {
    outline-style: solid;
}

  .vui-ring-c_accent\\.tertiary {
    outline-color: var(--vui-colors-accent-tertiary);
}

  .vui-ring-w_0 {
    outline-width: 0;
}

  .vui-grid-tc_\\[1fr_auto\\] {
    grid-template-columns: 1fr auto;
}

  .vui-mb_\\[calc\\(var\\(--slider-control-size\\)_\\/_2\\)\\] {
    margin-bottom: calc(var(--slider-control-size) / 2);
}

  .vui-bg-c_teal\\.20 {
    background-color: var(--vui-colors-teal-20);
}

  .vui-bg-c_\\[currentColor\\] {
    background-color: currentColor;
}

  .vui-top_\\[50\\%\\] {
    top: 50%;
}

  .vui-left_\\[50\\%\\] {
    left: 50%;
}

  .vui-bg-c_alert\\.confirmation {
    background-color: var(--vui-colors-alert-confirmation);
}

  .vui-bg-c_alert\\.error {
    background-color: var(--vui-colors-alert-error);
}

  .vui-ml_auto {
    margin-left: auto;
}

  .vui-flex-d_column-reverse {
    flex-direction: column-reverse;
}

  .vui-top_\\[1rem\\] {
    top: 1rem;
}

  .vui-left_\\[1rem\\] {
    left: 1rem;
}

  .vui-right_\\[1rem\\] {
    right: 1rem;
}

  .vui-bottom_\\[1rem\\] {
    bottom: 1rem;
}

  .vui-ai_flex-end {
    align-items: flex-end;
}

  .vui-jc_space-around {
    justify-content: space-around;
}

  .vui-jc_space-evenly {
    justify-content: space-evenly;
}

  .vui-bg-c_dark-teal\\.100 {
    background-color: var(--vui-colors-dark-teal-100);
}

  .vui-bd-c_cream\\.100\\/60 {
    --mix-borderColor: color-mix(in srgb, var(--vui-colors-cream-100) 60%, transparent);
    border-color: var(--mix-borderColor, var(--vui-colors-cream-100));
}

  .vui-bg-c_teal\\.80 {
    background-color: var(--vui-colors-teal-80);
}

  .vui-right_\\[calc\\(100\\%_-_0\\.5rem_-_1px\\)\\] {
    right: calc(100% - 0.5rem - 1px);
}

  .vui-right_\\[calc\\(100\\%_-_0\\.625rem_-_1px\\)\\] {
    right: calc(100% - 0.625rem - 1px);
}

  .vui-right_\\[calc\\(100\\%_-_0\\.875rem_-_2px\\)\\] {
    right: calc(100% - 0.875rem - 2px);
}

  .vui-mt_\\[4px\\] {
    margin-top: 4px;
}

  .vui-ring-w_\\[0px\\] {
    outline-width: 0px;
}

  .vui-lh_\\[16px\\] {
    line-height: 16px;
}

  .vui-lh_\\[22px\\] {
    line-height: 22px;
}

  .vui-bd-w_\\[2px\\] {
    border-width: 2px;
}

  .vui-lh_\\[1rem\\] {
    line-height: 1rem;
}

  .vui-lh_\\[1\\.375rem\\] {
    line-height: 1.375rem;
}

  .vui-lh_1\\.5rem {
    line-height: 1.5rem;
}

  .disabled\\:vui-cursor_not-allowed:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    cursor: not-allowed;
}

  .disabled\\:vui-c_gray\\.60:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    color: var(--vui-colors-gray-60);
}

  .componentReadOnly\\:vui-cursor_default:is([data-readonly]) {
    cursor: default;
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:vui-c_gray\\.40 {
    color: var(--vui-colors-gray-40);
}

  .group:is([aria-invalid=true], [data-invalid], [data-state="invalid"]) .groupInvalid\\:vui-c_alert\\.error {
    color: var(--vui-colors-alert-error);
}

  .group:is([aria-selected=true], [data-selected], [data-state="selected"]) .groupSelected\\:vui-c_cream\\.100 {
    color: var(--vui-colors-cream-100);
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:vui-c_cream\\.100 {
    color: var(--vui-colors-cream-100);
}

  .group:is([aria-invalid=true], [data-invalid], [data-state="invalid"]) .groupInvalid\\:vui-c_cream\\.100 {
    color: var(--vui-colors-cream-100);
}

  .group:is([aria-selected=true], [data-selected], [data-state="selected"]) .groupSelected\\:vui-c_dark-teal\\.100 {
    color: var(--vui-colors-dark-teal-100);
}

  .group:is([aria-selected=true], [data-selected], [data-state="selected"]) .groupSelected\\:vui-c_teal\\.100 {
    color: var(--vui-colors-teal-100);
}

  .disabled\\:vui-c_text\\.primary:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    color: var(--vui-colors-text-primary);
}

  .dark\\:vui---chip-color_\\{colors\\.background\\}.dark,.dark .dark\\:vui---chip-color_\\{colors\\.background\\},[data-color-mode=dark] .dark\\:vui---chip-color_\\{colors\\.background\\} {
    --chip-color: var(--vui-colors-background);
}

  .\\[\\&\\[data-href\\]\\]\\:vui-cursor_pointer[data-href] {
    cursor: pointer;
}

  .\\[\\&\\[data-href\\]\\]\\:vui-td_underline[data-href] {
    text-decoration: underline;
}

  .dark\\:vui-c_text\\.primary.dark,.dark .dark\\:vui-c_text\\.primary,[data-color-mode=dark] .dark\\:vui-c_text\\.primary {
    color: var(--vui-colors-text-primary);
}

  .dark\\:vui-c_extra-dark-teal\\.100.dark,.dark .dark\\:vui-c_extra-dark-teal\\.100,[data-color-mode=dark] .dark\\:vui-c_extra-dark-teal\\.100 {
    color: var(--vui-colors-extra-dark-teal-100);
}

  .dark\\:vui---chip-color_\\{colors\\.accent\\.primary\\}.dark,.dark .dark\\:vui---chip-color_\\{colors\\.accent\\.primary\\},[data-color-mode=dark] .dark\\:vui---chip-color_\\{colors\\.accent\\.primary\\} {
    --chip-color: var(--vui-colors-accent-primary);
}

  .dark\\:vui---chip-color_\\{colors\\.accent\\.secondary\\}.dark,.dark .dark\\:vui---chip-color_\\{colors\\.accent\\.secondary\\},[data-color-mode=dark] .dark\\:vui---chip-color_\\{colors\\.accent\\.secondary\\} {
    --chip-color: var(--vui-colors-accent-secondary);
}

  .dark\\:vui-c_text\\.primary\\.reversed.dark,.dark .dark\\:vui-c_text\\.primary\\.reversed,[data-color-mode=dark] .dark\\:vui-c_text\\.primary\\.reversed {
    color: var(--vui-colors-text-primary-reversed);
}

  .dark\\:vui---chip-color_\\{colors\\.accent\\.tertiary\\}.dark,.dark .dark\\:vui---chip-color_\\{colors\\.accent\\.tertiary\\},[data-color-mode=dark] .dark\\:vui---chip-color_\\{colors\\.accent\\.tertiary\\} {
    --chip-color: var(--vui-colors-accent-tertiary);
}

  .dark\\:vui-c_accent\\.secondary.dark,.dark .dark\\:vui-c_accent\\.secondary,[data-color-mode=dark] .dark\\:vui-c_accent\\.secondary {
    color: var(--vui-colors-accent-secondary);
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:vui-c_dark-teal\\.100 {
    color: var(--vui-colors-dark-teal-100);
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:vui-stk_gray\\.80 {
    stroke: var(--vui-colors-gray-80);
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:vui-c_gray\\.80 {
    color: var(--vui-colors-gray-80);
}

  .\\[\\&_ul\\]\\:vui-p_0 ul {
    padding: var(--vui-spacing-0);
}

  .\\[\\&_ul\\]\\:vui-m_0 ul {
    margin: var(--vui-spacing-0);
}

  .\\[\\&_a\\]\\:vui-td_none a {
    text-decoration: none;
}

  .\\[\\&_label\\]\\:vui-c_\\[inherit\\] label {
    color: inherit;
}

  .\\[\\&_a\\]\\:vui-c_green\\.100 a {
    color: var(--vui-colors-green-100);
}

  .\\[\\&_a\\]\\:vui-c_accent\\.primary a {
    color: var(--vui-colors-accent-primary);
}

  .\\[\\&_ul\\]\\:vui-d_flex ul {
    display: flex;
}

  .\\[\\&_ul\\]\\:vui-gap_\\[32px\\] ul {
    gap: 32px;
}

  .\\[\\&_li\\:\\:marker\\]\\:vui-c_cream\\.10 li::marker {
    color: var(--vui-colors-cream-10);
}

  .\\[\\&_li\\:\\:marker\\]\\:vui-c_extra-dark-teal\\.10 li::marker {
    color: var(--vui-colors-extra-dark-teal-10);
}

  .disabled\\:vui-op_0\\.6:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    opacity: 0.6;
}

  .dark\\:vui-c_accent\\.primary.dark,.dark .dark\\:vui-c_accent\\.primary,[data-color-mode=dark] .dark\\:vui-c_accent\\.primary {
    color: var(--vui-colors-accent-primary);
}

  .disabled\\:vui-c_gray\\.40:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    color: var(--vui-colors-gray-40);
}

  .dark\\:vui---spinner-color_\\[white\\].dark,.dark .dark\\:vui---spinner-color_\\[white\\],[data-color-mode=dark] .dark\\:vui---spinner-color_\\[white\\] {
    --spinner-color: white;
}

  .dark\\:vui---spinner-color_colors\\.accent\\.primary.dark,.dark .dark\\:vui---spinner-color_colors\\.accent\\.primary,[data-color-mode=dark] .dark\\:vui---spinner-color_colors\\.accent\\.primary {
    --spinner-color: var(--vui-colors-accent-primary);
}

  .dark\\:vui---spinner-color_colors\\.accent\\.secondary.dark,.dark .dark\\:vui---spinner-color_colors\\.accent\\.secondary,[data-color-mode=dark] .dark\\:vui---spinner-color_colors\\.accent\\.secondary {
    --spinner-color: var(--vui-colors-accent-secondary);
}

  .dark\\:vui---spinner-color_colors\\.accent\\.tertiary.dark,.dark .dark\\:vui---spinner-color_colors\\.accent\\.tertiary,[data-color-mode=dark] .dark\\:vui---spinner-color_colors\\.accent\\.tertiary {
    --spinner-color: var(--vui-colors-accent-tertiary);
}

  .\\[\\&\\[src\\*\\=\\"\\#thumbnail\\"\\]\\]\\:vui-w_\\[64px\\][src*="#thumbnail"] {
    width: 64px;
}

  .\\[\\&_th\\,_\\&_td\\]\\:vui-bd_1px_solid th,.\\[\\&_th\\,_\\&_td\\]\\:vui-bd_1px_solid td {
    border: 1px solid;
}

  .\\[\\&_th\\,_\\&_td\\]\\:vui-ta_left th,.\\[\\&_th\\,_\\&_td\\]\\:vui-ta_left td {
    text-align: left;
}

  .\\[\\&_th\\,_\\&_td\\]\\:vui-p_\\[8px\\] th,.\\[\\&_th\\,_\\&_td\\]\\:vui-p_\\[8px\\] td {
    padding: 8px;
}

  .before\\:vui-d_block::before {
    display: block;
}

  .before\\:vui-asp_1::before {
    aspect-ratio: 1;
}

  .before\\:vui-bdr_full::before {
    border-radius: var(--vui-radii-full);
}

  .before\\:vui-w_\\[0\\.25rem\\]::before {
    width: 0.25rem;
}

  .before\\:vui-w_\\[0\\.375rem\\]::before {
    width: 0.375rem;
}

  .before\\:vui-w_\\[0\\.5rem\\]::before {
    width: 0.5rem;
}

  .\\[\\&_\\[data-empty-icon\\=\\"true\\"\\]\\]\\:vui-d_none [data-empty-icon="true"] {
    display: none;
}

  .disabled\\:vui-c_gray\\.80:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    color: var(--vui-colors-gray-80);
}

  .group:is([aria-invalid=true], [data-invalid], [data-state="invalid"]) .groupInvalid\\:vui-c_error-red\\.100 {
    color: var(--vui-colors-error-red-100);
}

  .group:is([open], [data-open]) .groupOpen\\:vui-trf_rotate\\(180deg\\) {
    transform: rotate(180deg);
}

  .\\[\\&_svg\\]\\:vui-w_\\[100\\%\\] svg {
    width: 100%;
}

  .\\[\\&_svg\\]\\:vui-h_\\[100\\%\\] svg {
    height: 100%;
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:vui-pointer-events_none {
    pointer-events: none;
}

  .disabled\\:vui-c_\\[inherit\\]:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    color: inherit;
}

  .dragging\\:vui-c_\\[inherit\\]:is([data-dragging]) {
    color: inherit;
}

  .dragging\\:vui-c_accent\\.tertiary:is([data-dragging]) {
    color: var(--vui-colors-accent-tertiary);
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:vui-c_\\[white\\] {
    color: white;
}

  .group:is([data-readonly]) .groupComponentReadOnly\\:vui---switch-hover-thumb-color_\\{colors\\.teal\\.80\\} {
    --switch-hover-thumb-color: var(--vui-colors-teal-80);
}

  .\\[\\&\\[data-orientation\\=\\"horizontal\\"\\]\\]\\:vui-bd-b_\\[1px_solid_gray\\][data-orientation="horizontal"] {
    border-bottom: 1px solid gray;
}

  .\\[\\&\\[data-orientation\\=vertical\\]\\]\\:vui-bd-e_\\[1px_solid_gray\\][data-orientation=vertical] {
    border-inline-end: 1px solid gray;
}

  .\\[\\&_svg\\]\\:vui-c_dark-teal\\.100 svg {
    color: var(--vui-colors-dark-teal-100);
}

  .\\[\\&\\[data-selected\\]\\]\\:vui-c_accent\\.primary[data-selected] {
    color: var(--vui-colors-accent-primary);
}

  .\\[\\&\\[data-selected\\]\\]\\:vui-cursor_pointer[data-selected] {
    cursor: pointer;
}

  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-cursor_pointer[data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-cursor_pointer) {
    cursor: pointer;
}

  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"horizontal\\"\\]_\\&\\)\\]\\:vui-cursor_pointer:not([data-selected]):is([data-orientation="horizontal"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"horizontal\\"\\]_\\&\\)\\]\\:vui-cursor_pointer) {
    cursor: pointer;
}

  .\\[\\&\\[data-disabled\\]\\]\\:vui-c_gray\\.60[data-disabled] {
    color: var(--vui-colors-gray-60);
}

  .\\[\\&\\[data-disabled\\]\\]\\:vui-cursor_not-allowed[data-disabled] {
    cursor: not-allowed;
}

  .\\[\\&\\[data-disabled\\]\\]\\:vui-bd-b_3px_solid_transparent[data-disabled] {
    border-bottom: 3px solid transparent;
}

  .\\[\\&\\[data-disabled\\]\\]\\:vui-bd-e_3px_solid_transparent[data-disabled] {
    border-inline-end: 3px solid transparent;
}

  .\\[\\&\\[data-entering\\]\\]\\:vui-anim_fadeIn_250ms_ease-out_forwards[data-entering] {
    animation: fadeIn 250ms ease-out forwards;
}

  .\\[\\&\\[data-exiting\\]\\]\\:vui-anim_fadeOut_250ms_ease-out_forwards[data-exiting] {
    animation: fadeOut 250ms ease-out forwards;
}

  .\\[\\&\\[data-placement\\=\\"left\\"\\]_svg\\]\\:vui-trf_rotate\\(-90deg\\)[data-placement="left"] svg {
    transform: rotate(-90deg);
}

  .\\[\\&\\[data-placement\\=\\"right\\"\\]_svg\\]\\:vui-trf_rotate\\(90deg\\)[data-placement="right"] svg {
    transform: rotate(90deg);
}

  .\\[\\&\\[data-placement\\=\\"bottom\\"\\]_svg\\]\\:vui-trf_rotate\\(180deg\\)[data-placement="bottom"] svg {
    transform: rotate(180deg);
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:vui-c_\\[\\#343434\\] {
    color: #343434;
}

  .invalid\\:vui-bd_\\[1px_solid\\]:is([aria-invalid=true], [data-invalid], [data-state="invalid"]) {
    border: 1px solid;
}

  .placeholder\\:vui-c_gray\\.50::placeholder,.placeholder\\:vui-c_gray\\.50[data-placeholder] {
    color: var(--vui-colors-gray-50);
}

  .after\\:vui-white-space_pre-wrap::after {
    white-space: pre-wrap;
}

  .after\\:vui-vis_hidden::after {
    visibility: hidden;
}

  .after\\:vui-bd_\\[none\\]::after {
    border: none;
}

  .after\\:vui-p_0::after {
    padding: var(--vui-spacing-0);
}

  .after\\:vui-grid-area_1_\\/_1_\\/_2_\\/_2::after {
    grid-area: 1 / 1 / 2 / 2;
}

  .after\\:vui-p_\\[4px_8px\\]::after {
    padding: 4px 8px;
}

  .disabled\\:vui-bg-c_gray\\.20:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-gray-20);
}

  .disabled\\:vui-bd-c_gray\\.40:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    border-color: var(--vui-colors-gray-40);
}

  .disabled\\:vui-bd-c_gray\\.10:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    border-color: var(--vui-colors-gray-10);
}

  .group:is([aria-selected=true], [data-selected], [data-state="selected"]) .groupSelected\\:vui-bg-c_\\[currentColor\\] {
    background-color: currentColor;
}

  .group:is([aria-invalid=true], [data-invalid], [data-state="invalid"]) .groupInvalid\\:vui-bd-c_\\[currentColor\\] {
    border-color: currentColor;
}

  .\\[\\&\\[data-selected\\]\\]\\:vui-bd-c_green\\.100[data-selected] {
    border-color: var(--vui-colors-green-100);
}

  .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_var\\(--chip-color\\)\\)\\].dark,.dark .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_var\\(--chip-color\\)\\)\\],[data-color-mode=dark] .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_var\\(--chip-color\\)\\)\\] {
    border-color: color-mix(in srgb, var(--vui-colors-cream-100) 20%, var(--chip-color));
}

  .dark\\:vui-bg-c_cream\\.100.dark,.dark .dark\\:vui-bg-c_cream\\.100,[data-color-mode=dark] .dark\\:vui-bg-c_cream\\.100 {
    background-color: var(--vui-colors-cream-100);
}

  .dark\\:vui-bg-c_background.dark,.dark .dark\\:vui-bg-c_background,[data-color-mode=dark] .dark\\:vui-bg-c_background {
    background-color: var(--vui-colors-background);
}

  .dark\\:vui-bd-c_background.dark,.dark .dark\\:vui-bd-c_background,[data-color-mode=dark] .dark\\:vui-bd-c_background {
    border-color: var(--vui-colors-background);
}

  .dark\\:vui-bg-c_\\[transparent\\].dark,.dark .dark\\:vui-bg-c_\\[transparent\\],[data-color-mode=dark] .dark\\:vui-bg-c_\\[transparent\\] {
    background-color: transparent;
}

  .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_\\{colors\\.background\\}\\)\\].dark,.dark .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_\\{colors\\.background\\}\\)\\],[data-color-mode=dark] .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_\\{colors\\.background\\}\\)\\] {
    border-color: color-mix(in srgb, var(--vui-colors-cream-100) 20%, var(--vui-colors-background));
}

  .\\[\\&_ul\\]\\:vui-li-t_none ul {
    list-style-type: none;
}

  .\\[\\&_label\\]\\:vui-fs_\\[20px\\] label {
    font-size: 20px;
}

  .\\[\\&_span\\]\\:vui-mr_\\[32px\\] span {
    margin-right: 32px;
}

  .\\[\\&_th\\,_\\&_td\\]\\:vui-bd-c_gray\\.60 th,.\\[\\&_th\\,_\\&_td\\]\\:vui-bd-c_gray\\.60 td {
    border-color: var(--vui-colors-gray-60);
}

  .before\\:vui-content_\\"\\"::before {
    content: "";
}

  .group:is([aria-invalid=true], [data-invalid], [data-state="invalid"]) .groupInvalid\\:vui-bd-c_error-red\\.100 {
    border-color: var(--vui-colors-error-red-100);
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:vui-bg-c_gray\\.20 {
    background-color: var(--vui-colors-gray-20);
}

  .group:is([aria-selected=true], [data-selected], [data-state="selected"]) .groupSelected\\:vui-right_\\[1px\\] {
    right: 1px;
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:vui-bg-c_gray\\.40 {
    background-color: var(--vui-colors-gray-40);
}

  .group:is([aria-selected=true], [data-selected], [data-state="selected"]) .groupSelected\\:vui-right_\\[2px\\] {
    right: 2px;
}

  .\\[\\&\\[data-orientation\\=horizontal\\]\\]\\:vui-flex-d_column[data-orientation=horizontal] {
    flex-direction: column;
}

  .\\[\\&\\[data-orientation\\=vertical\\]\\]\\:vui-flex-d_row[data-orientation=vertical] {
    flex-direction: row;
}

  .\\[\\&\\[data-orientation\\=vertical\\]\\]\\:vui-flex-d_column[data-orientation=vertical] {
    flex-direction: column;
}

  .\\[\\&\\[data-selected\\]\\]\\:vui-bd-t-c_\\[transparent\\][data-selected] {
    border-top-color: transparent;
}

  .\\[\\&\\[data-selected\\]\\]\\:vui-bd-l-c_\\[transparent\\][data-selected] {
    border-left-color: transparent;
}

  .\\[\\&\\[data-selected\\]\\]\\:vui-bd-r-c_\\[transparent\\][data-selected] {
    border-right-color: transparent;
}

  .\\[\\&\\[data-selected\\]\\]\\:vui-bd-b-c_accent\\.primary[data-selected] {
    border-bottom-color: var(--vui-colors-accent-primary);
}

  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-e-c_accent\\.primary[data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-e-c_accent\\.primary) {
    border-inline-end-color: var(--vui-colors-accent-primary);
}

  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\][data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\]) {
    border-bottom-color: transparent;
}

  .\\[\\&\\[data-placement\\=\\"top\\"\\]_svg\\]\\:vui-mt_\\[-1px\\][data-placement="top"] svg {
    margin-top: -1px;
}

  .\\[\\&\\[data-placement\\=\\"left\\"\\]_svg\\]\\:vui-ml_\\[-4px\\][data-placement="left"] svg {
    margin-left: -4px;
}

  .\\[\\&\\[data-placement\\=\\"right\\"\\]_svg\\]\\:vui-mr_\\[-4px\\][data-placement="right"] svg {
    margin-right: -4px;
}

  .\\[\\&\\[data-placement\\=\\"bottom\\"\\]_svg\\]\\:vui-mb_\\[-1px\\][data-placement="bottom"] svg {
    margin-bottom: -1px;
}

  .invalid\\:vui-bd-c_error-red\\.100:is([aria-invalid=true], [data-invalid], [data-state="invalid"]) {
    border-color: var(--vui-colors-error-red-100);
}

  .after\\:vui-content_attr\\(data-replicated-value\\)_\\"_\\"::after {
    content: attr(data-replicated-value) " ";
}

  .disabled\\:vui-bg-c_\\[inherit\\]:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: inherit;
}

  .group:focus-within .groupFocusWithin\\:vui-ring-w_2px {
    outline-width: 2px;
}

  .focus\\:vui-ring_2px_solid:is(:focus, [data-focus], [data-focused=true]) {
    outline: 2px solid;
}

  .hoverOrFocus\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.dark-teal\\.100\\}_50\\%\\,_white\\)_transparent\\]:is(:hover, [data-hover], [data-hovered]),.hoverOrFocus\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.dark-teal\\.100\\}_50\\%\\,_white\\)_transparent\\]:is(:focus, [data-focus], [data-focused=true]) {
    scrollbar-color: color-mix(in srgb, var(--vui-colors-dark-teal-100) 50%, white) transparent;
}

  .focus\\:vui-ring-c_\\[currentColor\\]:is(:focus, [data-focus], [data-focused=true]) {
    outline-color: currentColor;
}

  .focusVisible\\:vui-ring-w_2px:is(:focus-visible, [data-focus-visible]) {
    outline-width: 2px;
}

  .group:is(:focus-visible, [data-focus-visible]) .groupFocusVisible\\:vui-ring-w_2px {
    outline-width: 2px;
}

  .peer:is(:focus-visible, [data-focus-visible]) ~ .peerFocusVisible\\:vui-ring-w_2px {
    outline-width: 2px;
}

  .hover\\:vui-c_\\[inherit\\]:is(:hover, [data-hover], [data-hovered]) {
    color: inherit;
}

  .hover\\:vui-c_accent\\.primary:is(:hover, [data-hover], [data-hovered]) {
    color: var(--vui-colors-accent-primary);
}

  .hover\\:vui-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]) {
    color: var(--vui-colors-accent-secondary);
}

  .hover\\:vui-c_accent\\.tertiary:is(:hover, [data-hover], [data-hovered]) {
    color: var(--vui-colors-accent-tertiary);
}

  .hover\\:vui-c_teal\\.100:is(:hover, [data-hover], [data-hovered]) {
    color: var(--vui-colors-teal-100);
}

  .hover\\:vui-c_cream\\.100:is(:hover, [data-hover], [data-hovered]) {
    color: var(--vui-colors-cream-100);
}

  .hover\\:vui-cursor_pointer:is(:hover, [data-hover], [data-hovered]) {
    cursor: pointer;
}

  .group:is(:hover, [data-hover], [data-hovered]) .groupHover\\:vui-bd-c_teal\\.100 {
    border-color: var(--vui-colors-teal-100);
}

  .hover\\:vui-bg-c_dark-teal\\.10:is(:hover, [data-hover], [data-hovered]) {
    background-color: var(--vui-colors-dark-teal-10);
}

  .hover\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]) {
    background-color: var(--vui-colors-cream-10);
}

  .hover\\:vui-bg-c_extra-dark-teal\\.10:is(:hover, [data-hover], [data-hovered]) {
    background-color: var(--vui-colors-extra-dark-teal-10);
}

  .group:is(:hover, [data-hover], [data-hovered]) .groupHover\\:vui-bd-c_cream\\.100 {
    border-color: var(--vui-colors-cream-100);
}

  .group:is(:hover, [data-hover], [data-hovered]) .groupHover\\:vui-bg-c_var\\(--switch-hover-thumb-color\\,_\\{colors\\.teal\\.100\\}\\) {
    background-color: var(--switch-hover-thumb-color, var(--vui-colors-teal-100));
}

  .group:is(:hover, [data-hover], [data-hovered]) .groupHover\\:vui-bg-c_var\\(--switch-hover-thumb-color\\,_\\{colors\\.cream\\.100\\}\\) {
    background-color: var(--switch-hover-thumb-color, var(--vui-colors-cream-100));
}

  .hover\\:vui-bd-b-c_accent\\.primary:is(:hover, [data-hover], [data-hovered]) {
    border-bottom-color: var(--vui-colors-accent-primary);
}

  .active\\:vui-bg-c_cream\\.100:is(:active, [data-active], [data-state="active"]) {
    background-color: var(--vui-colors-cream-100);
}

  .dark\\:disabled\\:vui-c_text\\.primary\\.reversed.dark:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]),.dark .dark\\:disabled\\:vui-c_text\\.primary\\.reversed:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]),[data-color-mode=dark] .dark\\:disabled\\:vui-c_text\\.primary\\.reversed:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    color: var(--vui-colors-text-primary-reversed);
}

  .dark\\:disabled\\:vui-cursor_not-allowed.dark:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]),.dark .dark\\:disabled\\:vui-cursor_not-allowed:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]),[data-color-mode=dark] .dark\\:disabled\\:vui-cursor_not-allowed:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    cursor: not-allowed;
}

  .\\[\\&_ul\\]\\:\\[\\&_li\\:first-child\\]\\:vui-li-s_\\[none\\] ul li:first-child {
    list-style: none;
}

  .group:is([aria-invalid=true], [data-invalid], [data-state="invalid"]) .groupInvalid\\:dark\\:vui-c_error-red\\.60.dark,.group:is([aria-invalid=true], [data-invalid], [data-state="invalid"]) .dark .groupInvalid\\:dark\\:vui-c_error-red\\.60,.group:is([aria-invalid=true], [data-invalid], [data-state="invalid"]) [data-color-mode=dark] .groupInvalid\\:dark\\:vui-c_error-red\\.60 {
    color: var(--vui-colors-error-red-60);
}

  .dark\\:disabled\\:vui-c_gray\\.80.dark:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]),.dark .dark\\:disabled\\:vui-c_gray\\.80:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]),[data-color-mode=dark] .dark\\:disabled\\:vui-c_gray\\.80:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    color: var(--vui-colors-gray-80);
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:\\[\\&\\]\\:vui---switch-hover-thumb-color_\\{colors\\.gray\\.40\\} {
    --switch-hover-thumb-color: var(--vui-colors-gray-40);
}

  .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-cursor_pointer.dark[data-selected],.dark .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-cursor_pointer[data-selected],[data-color-mode=dark] .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-cursor_pointer[data-selected] {
    cursor: pointer;
}

  .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-c_accent\\.secondary.dark[data-selected],.dark .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-c_accent\\.secondary[data-selected],[data-color-mode=dark] .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-c_accent\\.secondary[data-selected] {
    color: var(--vui-colors-accent-secondary);
}

  .dark\\:hover\\:vui-cursor_pointer.dark:is(:hover, [data-hover], [data-hovered]),.dark .dark\\:hover\\:vui-cursor_pointer:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .dark\\:hover\\:vui-cursor_pointer:is(:hover, [data-hover], [data-hovered]) {
    cursor: pointer;
}

  .dark\\:\\[\\&_svg\\]\\:vui-c_cream\\.100.dark svg,.dark .dark\\:\\[\\&_svg\\]\\:vui-c_cream\\.100 svg,[data-color-mode=dark] .dark\\:\\[\\&_svg\\]\\:vui-c_cream\\.100 svg {
    color: var(--vui-colors-cream-100);
}

  .\\[\\&\\[data-selected\\]\\]\\:\\[\\&_svg\\]\\:vui-c_accent\\.primary[data-selected] svg {
    color: var(--vui-colors-accent-primary);
}

  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer[data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer).dark,.dark .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer[data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer),[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer[data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer) {
    cursor: pointer;
}

  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:vui-cursor_pointer:not([data-selected]):is([data-orientation="vertical"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:vui-cursor_pointer):is(:hover, [data-hover], [data-hovered]) {
    cursor: pointer;
}

  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&_svg\\]\\:vui-c_\\[gray\\.60\\][data-disabled] svg {
    color: var(--vui-colors-gray-60);
}

  .\\[\\&\\[data-disabled\\]\\]\\:hover\\:vui-cursor_not-allowed[data-disabled]:is(:hover, [data-hover], [data-hovered]) {
    cursor: not-allowed;
}

  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-cursor_not-allowed[data-disabled][data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-cursor_not-allowed[data-disabled]) {
    cursor: not-allowed;
}

  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"horizontal\\"\\]_\\&\\)\\]\\:vui-cursor_not-allowed[data-disabled]:not([data-selected]):is([data-orientation="horizontal"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"horizontal\\"\\]_\\&\\)\\]\\:vui-cursor_not-allowed[data-disabled]) {
    cursor: not-allowed;
}

  .invalid\\:placeholder\\:vui-c_error-red\\.100:is([aria-invalid=true], [data-invalid], [data-state="invalid"])::placeholder,.invalid\\:placeholder\\:vui-c_error-red\\.100:is([aria-invalid=true], [data-invalid], [data-state="invalid"])[data-placeholder] {
    color: var(--vui-colors-error-red-100);
}

  .dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\].dark::placeholder,.dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\].dark[data-placeholder],.dark .dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\]::placeholder,.dark .dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\][data-placeholder],[data-color-mode=dark] .dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\]::placeholder,[data-color-mode=dark] .dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\][data-placeholder] {
    color: calc(text.primary/50);
}

  .group:is([aria-selected=true], [data-selected], [data-state="selected"]) .groupSelected\\:\\[\\&\\]\\:vui-bd-c_\\[transparent\\] {
    border-color: transparent;
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:\\[\\&\\]\\:vui-bd-c_\\[currentColor\\] {
    border-color: currentColor;
}

  .dark\\:disabled\\:vui-bg-c_gray\\.20.dark:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]),.dark .dark\\:disabled\\:vui-bg-c_gray\\.20:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]),[data-color-mode=dark] .dark\\:disabled\\:vui-bg-c_gray\\.20:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-gray-20);
}

  .dark\\:disabled\\:vui-bd-c_gray\\.40.dark:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]),.dark .dark\\:disabled\\:vui-bd-c_gray\\.40:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]),[data-color-mode=dark] .dark\\:disabled\\:vui-bd-c_gray\\.40:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    border-color: var(--vui-colors-gray-40);
}

  .group:is([aria-selected=true], [data-selected], [data-state="selected"]) .groupSelected\\:before\\:vui-bg-c_\\[white\\]::before {
    background-color: white;
}

  .group:is(:disabled, [disabled], [data-disabled], [data-state="disabled"]) .groupDisabled\\:before\\:vui-bg-c_\\[white\\]::before {
    background-color: white;
}

  .group:is([aria-invalid=true], [data-invalid], [data-state="invalid"]) .groupInvalid\\:before\\:vui-bg-c_\\[white\\]::before {
    background-color: white;
}

  .group:is([aria-selected=true], [data-selected], [data-state="selected"]) .groupSelected\\:before\\:vui-bg-c_dark-teal\\.100::before {
    background-color: var(--vui-colors-dark-teal-100);
}

  .group:is([aria-selected=true], [data-selected], [data-state="selected"]) .groupSelected\\:\\[\\&\\]\\:vui-bd-c_\\[currentColor\\] {
    border-color: currentColor;
}

  .group:is([aria-selected=true], [data-selected], [data-state="selected"]) .groupSelected\\:\\[\\&\\]\\:vui-bg-c_\\[currentColor\\] {
    background-color: currentColor;
}

  .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-bd-c_accent\\.secondary.dark[data-selected],.dark .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-bd-c_accent\\.secondary[data-selected],[data-color-mode=dark] .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-bd-c_accent\\.secondary[data-selected] {
    border-color: var(--vui-colors-accent-secondary);
}

  .dark\\:hover\\:vui-bd-e-c_accent\\.secondary.dark:is(:hover, [data-hover], [data-hovered]),.dark .dark\\:hover\\:vui-bd-e-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .dark\\:hover\\:vui-bd-e-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]) {
    border-inline-end-color: var(--vui-colors-accent-secondary);
}

  .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-t-c_\\[transparent\\][data-selected].dark,.dark .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-t-c_\\[transparent\\][data-selected],[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-t-c_\\[transparent\\][data-selected] {
    border-top-color: transparent;
}

  .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-l-c_\\[transparent\\][data-selected].dark,.dark .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-l-c_\\[transparent\\][data-selected],[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-l-c_\\[transparent\\][data-selected] {
    border-left-color: transparent;
}

  .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-r-c_\\[transparent\\][data-selected].dark,.dark .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-r-c_\\[transparent\\][data-selected],[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-r-c_\\[transparent\\][data-selected] {
    border-right-color: transparent;
}

  .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_accent\\.secondary[data-selected].dark,.dark .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_accent\\.secondary[data-selected],[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_accent\\.secondary[data-selected] {
    border-bottom-color: var(--vui-colors-accent-secondary);
}

  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary[data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary).dark,.dark .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary[data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary),[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary[data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary) {
    border-inline-end-color: var(--vui-colors-accent-secondary);
}

  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\][data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\]).dark,.dark .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\][data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\]),[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\][data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\]) {
    border-bottom-color: transparent;
}

  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-e-c_accent\\.primary:not([data-selected]):is([data-orientation="vertical"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-e-c_accent\\.primary):is(:hover, [data-hover], [data-hovered]) {
    border-inline-end-color: var(--vui-colors-accent-primary);
}

  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-b-c_\\[transparent\\]:not([data-selected]):is([data-orientation="vertical"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-b-c_\\[transparent\\]):is(:hover, [data-hover], [data-hovered]) {
    border-bottom-color: transparent;
}

  .\\[\\&\\[data-disabled\\]\\]\\:dark\\:vui-bd-c_\\[transparent\\][data-disabled].dark,.dark .\\[\\&\\[data-disabled\\]\\]\\:dark\\:vui-bd-c_\\[transparent\\][data-disabled],[data-color-mode=dark] .\\[\\&\\[data-disabled\\]\\]\\:dark\\:vui-bd-c_\\[transparent\\][data-disabled] {
    border-color: transparent;
}

  .\\[\\&\\[data-disabled\\]\\]\\:hover\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered]) {
    border-bottom-color: transparent;
}

  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:vui-bd-b-c_gray\\.30[data-disabled][data-selected] {
    border-bottom-color: var(--vui-colors-gray-30);
}

  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-e-c_gray\\.30[data-disabled][data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-e-c_gray\\.30[data-disabled]) {
    border-inline-end-color: var(--vui-colors-gray-30);
}

  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\][data-disabled][data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\][data-disabled]) {
    border-bottom-color: transparent;
}

  .hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:hover, [data-hover], [data-hovered]).dark,.dark .hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:hover, [data-hover], [data-hovered]),.hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:focus, [data-focus], [data-focused=true]).dark,.dark .hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:focus, [data-focus], [data-focused=true]),[data-color-mode=dark] .hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:focus, [data-focus], [data-focused=true]) {
    scrollbar-color: color-mix(in srgb, background 50%, white) transparent;
}

  .hover\\:notDisabled\\:vui-bg-c_pink\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-pink-10);
}

  .hover\\:notDisabled\\:vui-bg-c_green\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-green-10);
}

  .hover\\:notDisabled\\:vui-bg-c_purple\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-purple-10);
}

  .hover\\:notDisabled\\:vui-bg-c_warning-orange\\.20:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-warning-orange-20);
}

  .hover\\:notDisabled\\:vui-bg-c_error-red\\.20:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-error-red-20);
}

  .hover\\:notDisabled\\:vui-bg-c_info-blue\\.20:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-info-blue-20);
}

  .hover\\:notDisabled\\:vui-bg-c_success-green\\.20:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-success-green-20);
}

  .hover\\:notDisabled\\:vui-bg-c_teal\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-teal-10);
}

  .hover\\:notDisabled\\:vui-bg-c_dark-teal\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-dark-teal-10);
}

  .hover\\:notDisabled\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-cream-10);
}

  .hover\\:notDisabled\\:vui-bg-c_pink\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-pink-80);
}

  .hover\\:notDisabled\\:vui-bg-c_green\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-green-80);
}

  .hover\\:notDisabled\\:vui-bg-c_purple\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-purple-80);
}

  .hover\\:notDisabled\\:vui-bg-c_info-blue\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-info-blue-80);
}

  .hover\\:notDisabled\\:vui-bg-c_success-green\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-success-green-80);
}

  .hover\\:notDisabled\\:vui-bg-c_warning-orange\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-warning-orange-80);
}

  .hover\\:notDisabled\\:vui-bg-c_error-red\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-error-red-80);
}

  .hover\\:notDisabled\\:vui-bg-c_cream\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-cream-80);
}

  .hover\\:notDisabled\\:vui-bg-c_teal\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-teal-80);
}

  .hover\\:notDisabled\\:vui-bg-c_dark-teal\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-dark-teal-80);
}

  .hover\\:notDisabled\\:vui-bd-c_green\\.100:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    border-color: var(--vui-colors-green-100);
}

  .hover\\:notDisabled\\:vui-td-c_\\[inherit\\]:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    text-decoration-color: inherit;
}

  .hover\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]).dark,.dark .hover\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .hover\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]) {
    background-color: var(--vui-colors-cream-10);
}

  .hover\\:dark\\:vui-bg-c_extra-dark-teal\\.10:is(:hover, [data-hover], [data-hovered]).dark,.dark .hover\\:dark\\:vui-bg-c_extra-dark-teal\\.10:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .hover\\:dark\\:vui-bg-c_extra-dark-teal\\.10:is(:hover, [data-hover], [data-hovered]) {
    background-color: var(--vui-colors-extra-dark-teal-10);
}

  .hover\\:dark\\:vui-bd-b-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]).dark,.dark .hover\\:dark\\:vui-bd-b-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .hover\\:dark\\:vui-bd-b-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]) {
    border-bottom-color: var(--vui-colors-accent-secondary);
}

  .hover\\:dark\\:vui-bd-r-c_\\[transparent\\]:is(:hover, [data-hover], [data-hovered]).dark,.dark .hover\\:dark\\:vui-bd-r-c_\\[transparent\\]:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .hover\\:dark\\:vui-bd-r-c_\\[transparent\\]:is(:hover, [data-hover], [data-hovered]) {
    border-right-color: transparent;
}

  .active\\:dark\\:vui-bg-c_extra-dark-teal\\.100:is(:active, [data-active], [data-state="active"]).dark,.dark .active\\:dark\\:vui-bg-c_extra-dark-teal\\.100:is(:active, [data-active], [data-state="active"]),[data-color-mode=dark] .active\\:dark\\:vui-bg-c_extra-dark-teal\\.100:is(:active, [data-active], [data-state="active"]) {
    background-color: var(--vui-colors-extra-dark-teal-100);
}

  .\\[\\&\\[data-selected\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_accent\\.secondary[data-selected].dark svg,.dark .\\[\\&\\[data-selected\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_accent\\.secondary[data-selected] svg,[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_accent\\.secondary[data-selected] svg {
    color: var(--vui-colors-accent-secondary);
}

  .\\[\\&\\[data-disabled\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_\\[gray\\.60\\][data-disabled].dark svg,.dark .\\[\\&\\[data-disabled\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_\\[gray\\.60\\][data-disabled] svg,[data-color-mode=dark] .\\[\\&\\[data-disabled\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_\\[gray\\.60\\][data-disabled] svg,.\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-c_gray\\.60[data-disabled][data-selected].dark,.dark .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-c_gray\\.60[data-disabled][data-selected],[data-color-mode=dark] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-c_gray\\.60[data-disabled][data-selected] {
    color: var(--vui-colors-gray-60);
}

  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:vui-cursor_not-allowed[data-disabled]:not([data-selected]):is([data-orientation="vertical"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:vui-cursor_not-allowed[data-disabled]):is(:hover, [data-hover], [data-hovered]) {
    cursor: not-allowed;
}

  .invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state="invalid"]).dark::placeholder,.invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state="invalid"]).dark[data-placeholder],.dark .invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state="invalid"])::placeholder,.dark .invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state="invalid"])[data-placeholder],[data-color-mode=dark] .invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state="invalid"])::placeholder,[data-color-mode=dark] .invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state="invalid"])[data-placeholder] {
    color: var(--vui-colors-error-red-60);
}

  .\\[\\&\\[aria-selected\\=false\\]\\]\\:hover\\:notDisabled\\:vui-bd-c_green\\.40[aria-selected=false]:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    border-color: var(--vui-colors-green-40);
}

  .\\[\\&\\[data-selected\\]\\]\\:hover\\:notDisabled\\:vui-bd-c_green\\.40[data-selected]:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    border-color: var(--vui-colors-green-40);
}

  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary:not([data-selected]):is([data-orientation="vertical"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary):is(:hover, [data-hover], [data-hovered]).dark,.dark .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary:not([data-selected]):is([data-orientation="vertical"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary):is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary:not([data-selected]):is([data-orientation="vertical"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary):is(:hover, [data-hover], [data-hovered]) {
    border-inline-end-color: var(--vui-colors-accent-secondary);
}

  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]:not([data-selected]):is([data-orientation="vertical"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]):is(:hover, [data-hover], [data-hovered]).dark,.dark .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]:not([data-selected]):is([data-orientation="vertical"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]):is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]:not([data-selected]):is([data-orientation="vertical"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]):is(:hover, [data-hover], [data-hovered]) {
    border-bottom-color: transparent;
}

  .\\[\\&\\[data-disabled\\]\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered]).dark,.dark .\\[\\&\\[data-disabled\\]\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .\\[\\&\\[data-disabled\\]\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered]) {
    border-bottom-color: transparent;
}

  :is(.\\[\\&\\[data-disabled\\]\\]\\:hover\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-e-c_gray\\.30[data-disabled]:is(:hover, [data-hover], [data-hovered]))[data-selected]:is([data-orientation="vertical"] :is(.\\[\\&\\[data-disabled\\]\\]\\:hover\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-e-c_gray\\.30[data-disabled]:is(:hover, [data-hover], [data-hovered]))) {
    border-inline-end-color: var(--vui-colors-gray-30);
}

  .\\[\\&\\[data-disabled\\]\\]\\:hover\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered])[data-selected]:is([data-orientation="vertical"] .\\[\\&\\[data-disabled\\]\\]\\:hover\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered])) {
    border-bottom-color: transparent;
}

  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_gray\\.30[data-disabled][data-selected].dark,.dark .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_gray\\.30[data-disabled][data-selected],[data-color-mode=dark] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_gray\\.30[data-disabled][data-selected] {
    border-bottom-color: var(--vui-colors-gray-30);
}

  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-c_\\[transparent\\][data-disabled]:not([data-selected]):is([data-orientation="vertical"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\"vertical\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-c_\\[transparent\\][data-disabled]):is(:hover, [data-hover], [data-hovered]) {
    border-color: transparent;
}

  .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]).dark,.dark .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]),[data-color-mode=dark] .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-cream-10);
}

  .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]).dark,.dark .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]),[data-color-mode=dark] .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-dark-teal-10);
}

  .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]).dark,.dark .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]),[data-color-mode=dark] .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-cream-80);
}

  .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]).dark,.dark .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]),[data-color-mode=dark] .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state="disabled"]) {
    background-color: var(--vui-colors-dark-teal-80);
}

  @media screen and (min-width: 37.5rem) {
    .sm\\:vui-w_\\[100\\%\\] {
      width: 100%;
}
    .sm\\:vui-h_\\[100\\%\\] {
      height: 100%;
}
}

  @media screen and (min-width: 37.5rem) and (max-width: 56.2475rem) {
    .smOnly\\:vui-bdr_\\[8px\\] {
      border-radius: 8px;
}
    .smOnly\\:vui-p_\\[16px\\] {
      padding: 16px;
}
    .smOnly\\:vui-p_\\[16px_24px\\] {
      padding: 16px 24px;
}
}

  @media screen and (min-width: 56.25rem) {
    .md\\:vui-w_\\[320px\\] {
      width: 320px;
}
    .md\\:vui-h_\\[100\\%\\] {
      height: 100%;
}
    .md\\:vui-w_\\[100\\%\\] {
      width: 100%;
}
    .md\\:vui-h_\\[320px\\] {
      height: 320px;
}
    .md\\:vui-d_grid {
      display: grid;
}
    .md\\:vui-gap_\\[16px\\] {
      gap: 16px;
}
    .md\\:vui-grid-tc_repeat\\(2\\,_1fr\\) {
      grid-template-columns: repeat(2, 1fr);
}
}

  @media screen and (min-width: 75rem) {
    .lg\\:vui-w_\\[320px\\] {
      width: 320px;
}
    .lg\\:vui-h_\\[100\\%\\] {
      height: 100%;
}
    .lg\\:vui-w_\\[100\\%\\] {
      width: 100%;
}
    .lg\\:vui-h_\\[320px\\] {
      height: 320px;
}
    .lg\\:vui-gap_\\[16px\\] {
      gap: 16px;
}
    .lg\\:vui-grid-tc_\\[repeat\\(4\\,_1fr\\)\\] {
      grid-template-columns: repeat(4, 1fr);
}
    .lg\\:vui-jc_space-between {
      justify-content: space-between;
}
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@allenai/varnish-ui/dist/styles.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE;IACE,uBAAuB;AAC3B;;EAEE;IACE,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;IAClC,gCAAgC;IAChC,iCAAiC;IACjC,kCAAkC;IAClC,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;IAChC,6BAA6B;IAC7B,qCAAqC;IACrC,mCAAmC;IACnC,oCAAoC;IACpC,mCAAmC;IACnC,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,aAAa;IACb,WAAW;IACX,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;AACA;;AAEA;EACE;IACE,qDAAqD;IACrD,qDAAqD;IACrD,qDAAqD;IACrD,qDAAqD;IACrD,qDAAqD;IACrD,qDAAqD;IACrD,qDAAqD;IACrD,qDAAqD;IACrD,qDAAqD;IACrD,oDAAoD;IACpD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,+CAA+C;IAC/C,8CAA8C;IAC9C,iDAAiD;IACjD,iDAAiD;IACjD,iDAAiD;IACjD,gDAAgD;IAChD,iDAAiD;IACjD,iDAAiD;IACjD,iDAAiD;IACjD,iDAAiD;IACjD,iDAAiD;IACjD,gDAAgD;IAChD,qDAAqD;IACrD,qDAAqD;IACrD,qDAAqD;IACrD,oDAAoD;IACpD,oDAAoD;IACpD,sDAAsD;IACtD,sDAAsD;IACtD,sDAAsD;IACtD,qDAAqD;IACrD,sDAAsD;IACtD,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,0CAA0C;IAC1C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,8CAA8C;IAC9C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,6CAA6C;IAC7C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,yCAAyC;IACzC,yCAAyC;IACzC,0CAA0C;IAC1C,4CAA4C;IAC5C,yDAAyD;IACzD,8CAA8C;IAC9C,6BAA6B;IAC7B,0BAA0B;IAC1B,4BAA4B;IAC5B,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,6BAA6B;IAC7B,+BAA+B;IAC/B,8BAA8B;IAC9B,iCAAiC;IACjC,4BAA4B;IAC5B,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,wBAAwB;IACxB,4BAA4B;IAC5B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,0BAA0B;IAC1B,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;IAC3B,2BAA2B;IAC3B,+BAA+B;IAC/B,kCAAkC;IAClC,mCAAmC;IACnC,gCAAgC;IAChC,gCAAgC;IAChC,oDAAoD;IACpD,iEAAiE;IACjE,0DAA0D;IAC1D,+DAA+D;IAC/D,kEAAkE;IAClE,iEAAiE;IACjE,uDAAuD;IACvD,0DAA0D;IAC1D,0DAA0D;IAC1D,yDAAyD;IACzD,gEAAgE;IAChE,oEAAoE;IACpE,+DAA+D;IAC/D,kEAAkE;IAClE,qEAAqE;IACrE,mEAAmE;IACnE,mEAAmE;IACnE,mEAAmE;IACnE,sEAAsE;IACtE,qEAAqE;IACrE,oEAAoE;IACpE,oEAAoE;IACpE,sEAAsE;IACtE,qEAAqE;IACrE,oEAAoE;IACpE,oEAAoE;IACpE,wEAAwE;IACxE,sEAAsE;IACtE,sEAAsE;AAC1E;;EAEE;IACE,wDAAwD;IACxD,6DAA6D;IAC7D,sDAAsD;IACtD,mEAAmE;IACnE,sDAAsD;IACtD;AACJ;;EAEE;IACE;MACE,uBAAuB;AAC7B;;IAEI;MACE,yBAAyB;AAC/B;AACA;;EAEE;IACE;MACE,UAAU;AAChB;;IAEI;MACE,UAAU;AAChB;AACA;;EAEE;IACE;MACE,UAAU;AAChB;;IAEI;MACE,UAAU;AAChB;AACA;;EAEE;IACE;MACE,4BAA4B;MAC5B,UAAU;AAChB;;IAEI;MACE,wBAAwB;MACxB,UAAU;AAChB;AACA;;EAEE;IACE;MACE,2BAA2B;MAC3B,UAAU;AAChB;;IAEI;MACE,wBAAwB;MACxB,UAAU;AAChB;AACA;;EAEE;IACE;MACE,4BAA4B;MAC5B,UAAU;AAChB;;IAEI;MACE,wBAAwB;MACxB,UAAU;AAChB;AACA;;EAEE;IACE;MACE,2BAA2B;MAC3B,UAAU;AAChB;;IAEI;MACE,wBAAwB;MACxB,UAAU;AAChB;AACA;AACA;;AAEA;EACE;;IAEE;MACE,aAAa;MACb,uBAAuB;MACvB,wBAAwB;MACxB,uBAAuB;MACvB,oBAAoB;AAC1B;AACA;;EAEE;IACE,aAAa;AACjB;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,qCAAqC;AACzC;;EAEE;IACE,kDAAkD;AACtD;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,mDAAmD;AACvD;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,4BAA4B;AAChC;;EAEE;IACE,gBAAgB;IAChB,wBAAwB;AAC5B;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,QAAQ;AACZ;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,8DAA8D;AAClE;;EAEE;IACE,0BAA0B;AAC9B;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,kDAAkD;AACtD;;EAEE;IACE,iDAAiD;AACrD;;EAEE;IACE,+CAA+C;AACnD;;EAEE;IACE,6CAA6C;AACjD;;EAEE;IACE,mDAAmD;AACvD;;EAEE;IACE,oDAAoD;AACxD;;EAEE;IACE,0CAA0C;AAC9C;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,+CAA+C;AACnD;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,uDAAuD;AAC3D;;EAEE;IACE,qCAAqC;AACzC;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,QAAQ;AACZ;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,yCAAyC;AAC7C;;EAEE;IACE,wCAAwC;AAC5C;;EAEE;IACE,iCAAiC;AACrC;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,QAAQ;AACZ;;EAEE;IACE,QAAQ;AACZ;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,+CAA+C;AACnD;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,8BAA8B;IAC9B,mBAAmB;AACvB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,4BAA4B;AAChC;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,+BAA+B;AACnC;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,4BAA4B;AAChC;;EAEE;IACE,2BAA2B;AAC/B;;EAEE;IACE,aAAa;AACjB;;EAEE;IACE,4BAA4B;AAChC;;EAEE;IACE,2BAA2B;AAC/B;;EAEE;IACE,uBAAuB;AAC3B;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,UAAU;AACd;;EAEE;IACE,UAAU;AACd;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,+CAA+C;AACnD;;EAEE;IACE,6CAA6C;AACjD;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,8BAA8B;AAClC;;EAEE;IACE,mDAAmD;AACvD;;EAEE;IACE,UAAU;AACd;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,UAAU;AACd;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,iDAAiD;AACrD;;EAEE;IACE,aAAa;AACjB;;EAEE;IACE,aAAa;AACjB;;EAEE;IACE,aAAa;AACjB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,aAAa;AACjB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,sCAAsC;AAC1C;;EAEE;IACE,QAAQ;AACZ;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,UAAU;AACd;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,wBAAwB;AAC5B;;EAEE;IACE,uDAAuD;AAC3D;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,iDAAiD;AACrD;;EAEE;IACE,mDAAmD;AACvD;;EAEE;IACE,kDAAkD;AACtD;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,2BAA2B;AAC/B;;EAEE;IACE,iCAAiC;AACrC;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,2BAA2B;AAC/B;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,2BAA2B;AAC/B;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,+BAA+B;AACnC;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,8BAA8B;AAClC;;EAEE;IACE,4BAA4B;AAChC;;EAEE;IACE,+BAA+B;AACnC;;EAEE;IACE,8BAA8B;AAClC;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,iCAAiC;AACrC;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,+BAA+B;AACnC;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,iCAAiC;AACrC;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,4BAA4B;AAChC;;EAEE;IACE,uBAAuB;AAC3B;;EAEE;IACE,yCAAyC;AAC7C;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,2BAA2B;AAC/B;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,QAAQ;AACZ;;EAEE;IACE,QAAQ;AACZ;;EAEE;IACE,QAAQ;AACZ;;EAEE;IACE,QAAQ;AACZ;;EAEE;IACE,QAAQ;AACZ;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,UAAU;AACd;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,aAAa;AACjB;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,wCAAwC;AAC5C;;EAEE;IACE,aAAa;AACjB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,mCAAmC;AACvC;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,wBAAwB;AAC5B;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,wBAAwB;AAC5B;;EAEE;IACE,wCAAwC;AAC5C;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,uBAAuB;AAC3B;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,mCAAmC;AACvC;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,uBAAuB;AAC3B;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,kDAAkD;AACtD;;EAEE;IACE,oDAAoD;AACxD;;EAEE;IACE,6CAA6C;AACjD;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,qCAAqC;AACzC;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,mCAAmC;AACvC;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,uBAAuB;AAC3B;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,mCAAmC;AACvC;;EAEE;IACE,+BAA+B;AACnC;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,mCAAmC;AACvC;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,0BAA0B;AAC9B;;EAEE;IACE,uDAAuD;AAC3D;;EAEE;IACE,2BAA2B;AAC/B;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,4BAA4B;AAChC;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,UAAU;AACd;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,0BAA0B;AAC9B;;EAEE;IACE,8BAA8B;AAClC;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,uDAAuD;AAC3D;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,2BAA2B;AAC/B;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,+BAA+B;AACnC;;EAEE;IACE,4EAA4E;IAC5E,mEAAmE;AACvE;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,wBAAwB;AAC5B;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,uBAAuB;AAC3B;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,mCAAmC;AACvC;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,iEAAiE;IACjE,mDAAmD;AACvD;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,+BAA+B;AACnC;;EAEE;IACE,mDAAmD;AACvD;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,8BAA8B;AAClC;;EAEE;IACE,QAAQ;AACZ;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,sDAAsD;AAC1D;;EAEE;IACE,+CAA+C;AACnD;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,8BAA8B;AAClC;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,UAAU;AACd;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,iDAAiD;AACrD;;EAEE;IACE,mFAAmF;IACnF,iEAAiE;AACrE;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,sCAAsC;AAC1C;;EAEE;IACE,iCAAiC;AACrC;;EAEE;IACE,qCAAqC;AACzC;;EAEE;IACE,0CAA0C;AAC9C;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,0BAA0B;AAC9B;;EAEE;IACE,qCAAqC;AACzC;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,+CAA+C;AACnD;;EAEE;IACE,yCAAyC;AAC7C;;EAEE;IACE,sCAAsC;AAC1C;;EAEE;IACE,iCAAiC;AACrC;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,4BAA4B;AAChC;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,aAAa;AACjB;;EAEE;IACE,SAAS;AACb;;EAEE;IACE,iCAAiC;AACrC;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,iDAAiD;AACrD;;EAEE;IACE,mDAAmD;AACvD;;EAEE;IACE,kDAAkD;AACtD;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,aAAa;AACjB;;EAEE;IACE,aAAa;AACjB;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,sCAAsC;AAC1C;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,oBAAoB;AACxB;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,wCAAwC;AAC5C;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,qDAAqD;AACzD;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,iCAAiC;AACrC;;EAEE;IACE,sCAAsC;AAC1C;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,oCAAoC;AACxC;;EAEE;IACE,wCAAwC;AAC5C;;EAEE;IACE,yCAAyC;AAC7C;;EAEE;IACE,0CAA0C;AAC9C;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,wBAAwB;AAC5B;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,YAAY;AAChB;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,wBAAwB;AAC5B;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,8BAA8B;AAClC;;EAEE;IACE,0BAA0B;AAC9B;;EAEE;IACE,yCAAyC;AAC7C;;EAEE;IACE,oFAAoF;AACxF;;EAEE;IACE,6CAA6C;AACjD;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,0CAA0C;AAC9C;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,+FAA+F;AACnG;;EAEE;IACE,qBAAqB;AACzB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,WAAW;AACf;;EAEE;IACE,6CAA6C;AACjD;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,UAAU;AACd;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,UAAU;AACd;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,sBAAsB;AAC1B;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,8BAA8B;AAClC;;EAEE;IACE,+BAA+B;AACnC;;EAEE;IACE,qDAAqD;AACzD;;EAEE;IACE,yDAAyD;AAC7D;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,iBAAiB;AACrB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,6CAA6C;AACjD;;EAEE;IACE,wCAAwC;AAC5C;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,2FAA2F;AAC/F;;EAEE;IACE,2BAA2B;AAC/B;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,kBAAkB;AACtB;;EAEE;IACE,cAAc;AAClB;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,yCAAyC;AAC7C;;EAEE;IACE,wCAAwC;AAC5C;;EAEE;IACE,iCAAiC;AACrC;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,wCAAwC;AAC5C;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,sDAAsD;AAC1D;;EAEE;IACE,yCAAyC;AAC7C;;EAEE;IACE,6EAA6E;AACjF;;EAEE;IACE,8EAA8E;AAClF;;EAEE;IACE,qDAAqD;AACzD;;EAEE;IACE,6CAA6C;AACjD;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,gBAAgB;AACpB;;EAEE;IACE,qCAAqC;AACzC;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,qDAAqD;AACzD;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,yCAAyC;AAC7C;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,kCAAkC;AACtC;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,eAAe;AACnB;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,sCAAsC;AAC1C;;EAEE;IACE,4BAA4B;AAChC;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,0BAA0B;AAC9B;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,uCAAuC;AAC3C;;EAEE;IACE,uBAAuB;AAC3B;;EAEE;IACE,uBAAuB;AAC3B;;EAEE;IACE,uBAAuB;AAC3B;;EAEE;IACE,iDAAiD;AACrD;;EAEE;IACE,0BAA0B;AAC9B;;EAEE;IACE,8BAA8B;AAClC;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,2DAA2D;AAC/D;;EAEE;IACE,6BAA6B;AACjC;;EAEE;IACE,8BAA8B;AAClC;;EAEE;IACE,+BAA+B;AACnC;;EAEE;IACE,uDAAuD;AAC3D;;EAEE;IACE,2DAA2D;AAC/D;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,yDAAyD;AAC7D;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,kDAAkD;AACtD;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,sEAAsE;AAC1E;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,6CAA6C;AACjD;;EAEE;IACE,qDAAqD;AACzD;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,oDAAoD;AACxD;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,6CAA6C;AACjD;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,oDAAoD;AACxD;;EAEE;IACE,qDAAqD;AACzD;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,2CAA2C;AAC/C;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,yCAAyC;AAC7C;;EAEE;IACE,8BAA8B;AAClC;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,sDAAsD;AAC1D;;EAEE;IACE,uDAAuD;AAC3D;;EAEE;IACE,+BAA+B;AACnC;;EAEE;IACE,uDAAuD;AAC3D;;EAEE;IACE,yCAAyC;AAC7C;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,mBAAmB;AACvB;;EAEE;IACE,qCAAqC;AACzC;;EAEE;IACE,wCAAwC;AAC5C;;EAEE;IACE,wCAAwC;AAC5C;;EAEE;IACE,2DAA2D;AAC/D;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,kDAAkD;AACtD;;EAEE;IACE,gCAAgC;AACpC;;EAEE;IACE,8CAA8C;AAClD;;EAEE;IACE,yBAAyB;AAC7B;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE,4CAA4C;AAChD;;EAEE;IACE,gDAAgD;AACpD;;EAEE;IACE;MACE,WAAW;AACjB;IACI;MACE,YAAY;AAClB;AACA;;EAEE;IACE;MACE,kBAAkB;AACxB;IACI;MACE,aAAa;AACnB;IACI;MACE,kBAAkB;AACxB;AACA;;EAEE;IACE;MACE,YAAY;AAClB;IACI;MACE,YAAY;AAClB;IACI;MACE,WAAW;AACjB;IACI;MACE,aAAa;AACnB;IACI;MACE,aAAa;AACnB;IACI;MACE,SAAS;AACf;IACI;MACE,qCAAqC;AAC3C;AACA;;EAEE;IACE;MACE,YAAY;AAClB;IACI;MACE,YAAY;AAClB;IACI;MACE,WAAW;AACjB;IACI;MACE,aAAa;AACnB;IACI;MACE,SAAS;AACf;IACI;MACE,qCAAqC;AAC3C;IACI;MACE,8BAA8B;AACpC;AACA;AACA","sourcesContent":["@layer reset, base, tokens, recipes, utilities;\n\n@layer base{\n  :root {\n    --made-with-panda: '🐼';\n}\n\n  *,::before,::after,::backdrop {\n    --blur: /*-*/ /*-*/;\n    --brightness: /*-*/ /*-*/;\n    --contrast: /*-*/ /*-*/;\n    --grayscale: /*-*/ /*-*/;\n    --hue-rotate: /*-*/ /*-*/;\n    --invert: /*-*/ /*-*/;\n    --saturate: /*-*/ /*-*/;\n    --sepia: /*-*/ /*-*/;\n    --drop-shadow: /*-*/ /*-*/;\n    --backdrop-blur: /*-*/ /*-*/;\n    --backdrop-brightness: /*-*/ /*-*/;\n    --backdrop-contrast: /*-*/ /*-*/;\n    --backdrop-grayscale: /*-*/ /*-*/;\n    --backdrop-hue-rotate: /*-*/ /*-*/;\n    --backdrop-invert: /*-*/ /*-*/;\n    --backdrop-opacity: /*-*/ /*-*/;\n    --backdrop-saturate: /*-*/ /*-*/;\n    --backdrop-sepia: /*-*/ /*-*/;\n    --gradient-from-position: /*-*/ /*-*/;\n    --gradient-to-position: /*-*/ /*-*/;\n    --gradient-via-position: /*-*/ /*-*/;\n    --scroll-snap-strictness: proximity;\n    --border-spacing-x: 0;\n    --border-spacing-y: 0;\n    --translate-x: 0;\n    --translate-y: 0;\n    --rotate: 0;\n    --rotate-x: 0;\n    --rotate-y: 0;\n    --skew-x: 0;\n    --skew-y: 0;\n    --scale-x: 1;\n    --scale-y: 1;\n}\n}\n\n@layer tokens{\n  :where(:root, :host) {\n    --vui-colors-extra-dark-teal-10: rgba(3, 38, 41, 0.1);\n    --vui-colors-extra-dark-teal-20: rgba(3, 38, 41, 0.2);\n    --vui-colors-extra-dark-teal-30: rgba(3, 38, 41, 0.3);\n    --vui-colors-extra-dark-teal-40: rgba(3, 38, 41, 0.4);\n    --vui-colors-extra-dark-teal-50: rgba(3, 38, 41, 0.5);\n    --vui-colors-extra-dark-teal-60: rgba(3, 38, 41, 0.6);\n    --vui-colors-extra-dark-teal-70: rgba(3, 38, 41, 0.7);\n    --vui-colors-extra-dark-teal-80: rgba(3, 38, 41, 0.8);\n    --vui-colors-extra-dark-teal-90: rgba(3, 38, 41, 0.9);\n    --vui-colors-extra-dark-teal-100: rgba(3, 38, 41, 1);\n    --vui-colors-dark-teal-10: rgba(10, 50, 53, 0.1);\n    --vui-colors-dark-teal-20: rgba(10, 50, 53, 0.2);\n    --vui-colors-dark-teal-30: rgba(10, 50, 53, 0.3);\n    --vui-colors-dark-teal-40: rgba(10, 50, 53, 0.4);\n    --vui-colors-dark-teal-50: rgba(10, 50, 53, 0.5);\n    --vui-colors-dark-teal-60: rgba(10, 50, 53, 0.6);\n    --vui-colors-dark-teal-70: rgba(10, 50, 53, 0.7);\n    --vui-colors-dark-teal-80: rgba(10, 50, 53, 0.8);\n    --vui-colors-dark-teal-90: rgba(10, 50, 53, 0.9);\n    --vui-colors-dark-teal-100: rgba(10, 50, 53, 1);\n    --vui-colors-cream-10: rgba(250, 242, 233, 0.1);\n    --vui-colors-cream-20: rgba(250, 242, 233, 0.2);\n    --vui-colors-cream-30: rgba(250, 242, 233, 0.3);\n    --vui-colors-cream-40: rgba(250, 242, 233, 0.4);\n    --vui-colors-cream-50: rgba(250, 242, 233, 0.5);\n    --vui-colors-cream-60: rgba(250, 242, 233, 0.6);\n    --vui-colors-cream-70: rgba(250, 242, 233, 0.7);\n    --vui-colors-cream-80: rgba(250, 242, 233, 0.8);\n    --vui-colors-cream-90: rgba(250, 242, 233, 0.9);\n    --vui-colors-cream-100: rgba(250, 242, 233, 1);\n    --vui-colors-info-blue-20: rgba(212, 231, 252, 1);\n    --vui-colors-info-blue-40: rgba(170, 207, 249, 1);\n    --vui-colors-info-blue-60: rgba(127, 184, 245, 1);\n    --vui-colors-info-blue-80: rgba(85, 160, 242, 1);\n    --vui-colors-info-blue-100: rgba(42, 136, 239, 1);\n    --vui-colors-error-red-20: rgba(255, 218, 218, 1);\n    --vui-colors-error-red-40: rgba(254, 181, 181, 1);\n    --vui-colors-error-red-60: rgba(254, 144, 143, 1);\n    --vui-colors-error-red-80: rgba(253, 107, 106, 1);\n    --vui-colors-error-red-100: rgba(253, 70, 69, 1);\n    --vui-colors-success-green-20: rgba(221, 235, 215, 1);\n    --vui-colors-success-green-40: rgba(187, 215, 174, 1);\n    --vui-colors-success-green-60: rgba(152, 196, 134, 1);\n    --vui-colors-success-green-80: rgba(118, 176, 93, 1);\n    --vui-colors-success-green-100: rgba(84, 156, 53, 1);\n    --vui-colors-warning-orange-20: rgba(255, 237, 210, 1);\n    --vui-colors-warning-orange-40: rgba(255, 218, 164, 1);\n    --vui-colors-warning-orange-60: rgba(255, 200, 119, 1);\n    --vui-colors-warning-orange-80: rgba(255, 181, 73, 1);\n    --vui-colors-warning-orange-100: rgba(255, 163, 28, 1);\n    --vui-colors-teal-10: rgba(16, 82, 87, 0.1);\n    --vui-colors-teal-20: rgba(16, 82, 87, 0.2);\n    --vui-colors-teal-30: rgba(16, 82, 87, 0.3);\n    --vui-colors-teal-40: rgba(16, 82, 87, 0.4);\n    --vui-colors-teal-50: rgba(16, 82, 87, 0.5);\n    --vui-colors-teal-60: rgba(16, 82, 87, 0.6);\n    --vui-colors-teal-70: rgba(16, 82, 87, 0.7);\n    --vui-colors-teal-80: rgba(16, 82, 87, 0.8);\n    --vui-colors-teal-90: rgba(16, 82, 87, 0.9);\n    --vui-colors-teal-100: rgba(16, 82, 87, 1);\n    --vui-colors-pink-10: rgba(253, 238, 245, 1);\n    --vui-colors-pink-20: rgba(252, 220, 235, 1);\n    --vui-colors-pink-30: rgba(251, 203, 225, 1);\n    --vui-colors-pink-40: rgba(249, 186, 215, 1);\n    --vui-colors-pink-50: rgba(247, 168, 205, 1);\n    --vui-colors-pink-60: rgba(246, 151, 196, 1);\n    --vui-colors-pink-70: rgba(245, 134, 186, 1);\n    --vui-colors-pink-80: rgba(243, 117, 176, 1);\n    --vui-colors-pink-90: rgba(242, 99, 166, 1);\n    --vui-colors-pink-100: rgba(240, 82, 156, 1);\n    --vui-colors-purple-10: rgba(247, 232, 253, 1);\n    --vui-colors-purple-20: rgba(239, 209, 250, 1);\n    --vui-colors-purple-30: rgba(232, 187, 248, 1);\n    --vui-colors-purple-40: rgba(224, 164, 246, 1);\n    --vui-colors-purple-50: rgba(216, 141, 243, 1);\n    --vui-colors-purple-60: rgba(208, 118, 241, 1);\n    --vui-colors-purple-70: rgba(200, 95, 239, 1);\n    --vui-colors-purple-80: rgba(193, 73, 237, 1);\n    --vui-colors-purple-90: rgba(185, 50, 234, 1);\n    --vui-colors-purple-100: rgba(177, 27, 232, 1);\n    --vui-colors-green-10: rgba(231, 250, 243, 1);\n    --vui-colors-green-20: rgba(207, 245, 232, 1);\n    --vui-colors-green-30: rgba(183, 239, 221, 1);\n    --vui-colors-green-40: rgba(159, 234, 209, 1);\n    --vui-colors-green-50: rgba(135, 229, 197, 1);\n    --vui-colors-green-60: rgba(111, 224, 186, 1);\n    --vui-colors-green-70: rgba(87, 219, 175, 1);\n    --vui-colors-green-80: rgba(63, 213, 163, 1);\n    --vui-colors-green-90: rgba(39, 208, 156, 1);\n    --vui-colors-green-100: rgba(15, 203, 140, 1);\n    --vui-colors-gray-10: rgba(235, 235, 235, 1);\n    --vui-colors-gray-20: rgba(214, 214, 214, 1);\n    --vui-colors-gray-30: rgba(194, 194, 194, 1);\n    --vui-colors-gray-40: rgba(174, 174, 174, 1);\n    --vui-colors-gray-50: rgba(153, 153, 153, 1);\n    --vui-colors-gray-60: rgba(133, 133, 133, 1);\n    --vui-colors-gray-70: rgba(113, 113, 113, 1);\n    --vui-colors-gray-80: rgba(93, 93, 93, 1);\n    --vui-colors-gray-90: rgba(72, 72, 72, 1);\n    --vui-colors-gray-100: rgba(52, 52, 52, 1);\n    --vui-fonts-body: Manrope, Arial, sans-serif;\n    --vui-fonts-heading: Telegraf, Manrope, Arial, sans-serif;\n    --vui-fonts-monospace: 'Space Mono', monospace;\n    --vui-font-sizes-4xl: 2.25rem;\n    --vui-font-sizes-3xl: 2rem;\n    --vui-font-sizes-2xl: 1.5rem;\n    --vui-font-sizes-xl: 1.25rem;\n    --vui-font-sizes-lg: 1.125rem;\n    --vui-font-sizes-md: 1rem;\n    --vui-font-sizes-sm: 0.875rem;\n    --vui-font-weights-light: 300;\n    --vui-font-weights-regular: 400;\n    --vui-font-weights-medium: 500;\n    --vui-font-weights-semi-bold: 600;\n    --vui-font-weights-bold: 700;\n    --vui-spacing-0: 0;\n    --vui-spacing-1: .25rem;\n    --vui-spacing-2: .5rem;\n    --vui-spacing-3: .75rem;\n    --vui-spacing-4: 1rem;\n    --vui-spacing-5: 1.25rem;\n    --vui-spacing-6: 1.5rem;\n    --vui-spacing-7: 1.75rem;\n    --vui-spacing-8: 2rem;\n    --vui-radii-xs: 2px;\n    --vui-radii-sm: 4px;\n    --vui-radii-md: 8px;\n    --vui-radii-lg: 12px;\n    --vui-radii-xl: 16px;\n    --vui-radii-full: 9999px;\n    --vui-z-index-backdrop: 1300;\n    --vui-z-index-drawer: 1400;\n    --vui-z-index-snackbar: 1500;\n    --vui-z-index-modal: 1600;\n    --vui-breakpoints-xs: 0rem;\n    --vui-breakpoints-sm: 37.5rem;\n    --vui-breakpoints-md: 56.25rem;\n    --vui-breakpoints-lg: 75rem;\n    --vui-breakpoints-xl: 96rem;\n    --vui-sizes-breakpoint-xs: 0rem;\n    --vui-sizes-breakpoint-sm: 37.5rem;\n    --vui-sizes-breakpoint-md: 56.25rem;\n    --vui-sizes-breakpoint-lg: 75rem;\n    --vui-sizes-breakpoint-xl: 96rem;\n    --vui-colors-background: var(--vui-colors-cream-100);\n    --vui-colors-background-reversed: var(--vui-colors-dark-teal-100);\n    --vui-colors-text-primary: var(--vui-colors-dark-teal-100);\n    --vui-colors-text-primary-reversed: var(--vui-colors-cream-100);\n    --vui-colors-text-secondary: var(--vui-colors-extra-dark-teal-100);\n    --vui-colors-text-secondary-reversed: var(--vui-colors-cream-100);\n    --vui-colors-accent-primary: var(--vui-colors-pink-100);\n    --vui-colors-accent-secondary: var(--vui-colors-green-100);\n    --vui-colors-accent-tertiary: var(--vui-colors-purple-100);\n    --vui-colors-alert-error: var(--vui-colors-error-red-100);\n    --vui-colors-alert-warning: var(--vui-colors-warning-orange-100);\n    --vui-colors-alert-confirmation: var(--vui-colors-success-green-100);\n    --vui-colors-alert-information: var(--vui-colors-info-blue-100);\n    --vui-colors-charting-categorical-dark--red: var(--vui-colors--r4);\n    --vui-colors-charting-categorical-dark--orange: var(--vui-colors--o4);\n    --vui-colors-charting-categorical-dark--aqua: var(--vui-colors--a3);\n    --vui-colors-charting-categorical-dark--teal: var(--vui-colors--t3);\n    --vui-colors-charting-categorical-dark--blue: var(--vui-colors--b3);\n    --vui-colors-charting-categorical-dark--magenta: var(--vui-colors--m4);\n    --vui-colors-charting-categorical-dark--purple: var(--vui-colors--p4);\n    --vui-colors-charting-categorical-dark--green: var(--vui-colors--g4);\n    --vui-colors-charting-categorical-light--red: var(--vui-colors--r10);\n    --vui-colors-charting-categorical-light--orange: var(--vui-colors--o9);\n    --vui-colors-charting-categorical-light--aqua: var(--vui-colors--a10);\n    --vui-colors-charting-categorical-light--teal: var(--vui-colors--t8);\n    --vui-colors-charting-categorical-light--blue: var(--vui-colors--b6);\n    --vui-colors-charting-categorical-light--magenta: var(--vui-colors--m10);\n    --vui-colors-charting-categorical-light--purple: var(--vui-colors--p8);\n    --vui-colors-charting-categorical-light--green: var(--vui-colors--g10);\n}\n\n  :where(.dark, [data-color-mode=dark]) {\n    --vui-colors-background: var(--vui-colors-dark-teal-100);\n    --vui-colors-background-reversed: var(--vui-colors-cream-100);\n    --vui-colors-text-primary: var(--vui-colors-cream-100);\n    --vui-colors-text-primary-reversed: var(--vui-colors-dark-teal-100);\n    --vui-colors-text-secondary: var(--vui-colors-gray-10);\n    --vui-colors-text-secondary-reversed: var(--vui-colors-gray-80)\n}\n\n  @keyframes loading-spinner-rotate {\n    0% {\n      transform: rotate(0deg);\n}\n\n    100% {\n      transform: rotate(360deg);\n}\n}\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n}\n\n    100% {\n      opacity: 1;\n}\n}\n\n  @keyframes fadeOut {\n    0% {\n      opacity: 1;\n}\n\n    100% {\n      opacity: 0;\n}\n}\n\n  @keyframes slideInLeft {\n    from {\n      transform: translateX(-100%);\n      opacity: 0;\n}\n\n    to {\n      transform: translateX(0);\n      opacity: 1;\n}\n}\n\n  @keyframes slideInRight {\n    from {\n      transform: translateX(100%);\n      opacity: 0;\n}\n\n    to {\n      transform: translateX(0);\n      opacity: 1;\n}\n}\n\n  @keyframes slideInTop {\n    from {\n      transform: translateY(-100%);\n      opacity: 0;\n}\n\n    to {\n      transform: translateY(0);\n      opacity: 1;\n}\n}\n\n  @keyframes slideInBottom {\n    from {\n      transform: translateY(100%);\n      opacity: 0;\n}\n\n    to {\n      transform: translateY(0);\n      opacity: 1;\n}\n}\n}\n\n@layer utilities{\n  @layer compositions{\n\n    .vui-textStyle_inherit,.after\\:vui-textStyle_inherit::after {\n      font: inherit;\n      letter-spacing: inherit;\n      text-decoration: inherit;\n      text-transform: inherit;\n      line-height: inherit;\n}\n}\n\n  .vui-d_flex {\n    display: flex;\n}\n\n  .vui-gap_1 {\n    gap: var(--vui-spacing-1);\n}\n\n  .vui-bdr_sm {\n    border-radius: var(--vui-radii-sm);\n}\n\n  .vui-p_\\[8px\\] {\n    padding: 8px;\n}\n\n  .vui-w_\\[100\\%\\] {\n    width: 100%;\n}\n\n  .vui-c_text\\.primary {\n    color: var(--vui-colors-text-primary);\n}\n\n  .vui---alert-color_\\{colors\\.success-green\\.100\\} {\n    --alert-color: var(--vui-colors-success-green-100);\n}\n\n  .vui---alert-color_\\{colors\\.info-blue\\.100\\} {\n    --alert-color: var(--vui-colors-info-blue-100);\n}\n\n  .vui---alert-color_\\{colors\\.warning-orange\\.100\\} {\n    --alert-color: var(--vui-colors-warning-orange-100);\n}\n\n  .vui---alert-color_\\{colors\\.error-red\\.100\\} {\n    --alert-color: var(--vui-colors-error-red-100);\n}\n\n  .vui-bd_\\[1px_solid_var\\(--alert-color\\)\\] {\n    border: 1px solid var(--alert-color);\n}\n\n  .vui-c_extra-dark-teal\\.100 {\n    color: var(--vui-colors-extra-dark-teal-100);\n}\n\n  .vui-c_\\[white\\] {\n    color: white;\n}\n\n  .vui-c_var\\(--alert-color\\) {\n    color: var(--alert-color);\n}\n\n  .vui-c_\\[inherit\\] {\n    color: inherit;\n}\n\n  .vui-m_0 {\n    margin: var(--vui-spacing-0);\n}\n\n  .vui-ap_none {\n    appearance: none;\n    -webkit-appearance: none;\n}\n\n  .vui-bd_0 {\n    border: 0;\n}\n\n  .vui-p_0 {\n    padding: var(--vui-spacing-0);\n}\n\n  .vui-cursor_pointer {\n    cursor: pointer;\n}\n\n  .vui-ov_hidden {\n    overflow: hidden;\n}\n\n  .vui-ta_center {\n    text-align: center;\n}\n\n  .vui-m_\\[5px\\] {\n    margin: 5px;\n}\n\n  .vui-w_\\[32px\\] {\n    width: 32px;\n}\n\n  .vui-h_\\[32px\\] {\n    height: 32px;\n}\n\n  .vui-w_\\[40px\\] {\n    width: 40px;\n}\n\n  .vui-h_\\[40px\\] {\n    height: 40px;\n}\n\n  .vui-w_\\[56px\\] {\n    width: 56px;\n}\n\n  .vui-h_\\[56px\\] {\n    height: 56px;\n}\n\n  .vui-bdr_\\[0\\] {\n    border-radius: 0;\n}\n\n  .vui-bdr_\\[50\\%\\] {\n    border-radius: 50%;\n}\n\n  .vui-p_\\[0\\] {\n    padding: var(--vui-spacing-0);\n}\n\n  .vui-p_\\[4px\\] {\n    padding: 4px;\n}\n\n  .vui-h_\\[100\\%\\] {\n    height: 100%;\n}\n\n  .vui-obj-f_cover {\n    object-fit: cover;\n}\n\n  .vui-bdr_\\[20\\%\\] {\n    border-radius: 20%;\n}\n\n  .vui-bx-s_border-box {\n    box-sizing: border-box;\n}\n\n  .vui-gap_\\[5px\\] {\n    gap: 5px;\n}\n\n  .vui-d_inline-flex {\n    display: inline-flex;\n}\n\n  .vui-bd_none {\n    border: none;\n}\n\n  .vui-trs_\\[background-color_250ms\\,_color_250ms\\,_opacity_250ms\\] {\n    transition: background-color 250ms, color 250ms, opacity 250ms;\n}\n\n  .vui-c_var\\(--button-color\\) {\n    color: var(--button-color);\n}\n\n  .vui---button-color_\\{colors\\.accent\\.primary\\} {\n    --button-color: var(--vui-colors-accent-primary);\n}\n\n  .vui---button-color_\\{colors\\.accent\\.secondary\\} {\n    --button-color: var(--vui-colors-accent-secondary);\n}\n\n  .vui---button-color_\\{colors\\.accent\\.tertiary\\} {\n    --button-color: var(--vui-colors-accent-tertiary);\n}\n\n  .vui---button-color_\\{colors\\.alert\\.warning\\} {\n    --button-color: var(--vui-colors-alert-warning);\n}\n\n  .vui---button-color_\\{colors\\.alert\\.error\\} {\n    --button-color: var(--vui-colors-alert-error);\n}\n\n  .vui---button-color_\\{colors\\.alert\\.information\\} {\n    --button-color: var(--vui-colors-alert-information);\n}\n\n  .vui---button-color_\\{colors\\.alert\\.confirmation\\} {\n    --button-color: var(--vui-colors-alert-confirmation);\n}\n\n  .vui---button-color_\\{colors\\.teal\\.100\\} {\n    --button-color: var(--vui-colors-teal-100);\n}\n\n  .vui---button-color_\\{colors\\.cream\\.100\\} {\n    --button-color: var(--vui-colors-cream-100);\n}\n\n  .vui---button-color_\\{colors\\.dark-teal\\.100\\} {\n    --button-color: var(--vui-colors-dark-teal-100);\n}\n\n  .vui---button-color_\\{colors\\.text\\.primary\\} {\n    --button-color: var(--vui-colors-text-primary);\n}\n\n  .vui---button-color_\\{colors\\.text\\.primary\\.reversed\\} {\n    --button-color: var(--vui-colors-text-primary-reversed);\n}\n\n  .vui-bd_\\[1px_solid_var\\(--button-color\\)\\] {\n    border: 1px solid var(--button-color);\n}\n\n  .vui-p_\\[4px_10px\\] {\n    padding: 4px 10px;\n}\n\n  .vui-p_\\[6px_16px\\] {\n    padding: 6px 16px;\n}\n\n  .vui-p_\\[12px_24px\\] {\n    padding: 12px 24px;\n}\n\n  .vui-c_cream\\.100 {\n    color: var(--vui-colors-cream-100);\n}\n\n  .vui-c_text\\.primary\\.reversed {\n    color: var(--vui-colors-text-primary-reversed);\n}\n\n  .vui-p_\\[3px_9px\\] {\n    padding: 3px 9px;\n}\n\n  .vui-p_\\[5px_15px\\] {\n    padding: 5px 15px;\n}\n\n  .vui-p_\\[11px_23px\\] {\n    padding: 11px 23px;\n}\n\n  .vui-va_middle {\n    vertical-align: middle;\n}\n\n  .vui-gap_\\[8px\\] {\n    gap: 8px;\n}\n\n  .vui-w_\\[20px\\] {\n    width: 20px;\n}\n\n  .vui-h_\\[20px\\] {\n    height: 20px;\n}\n\n  .vui-bd_\\[1px_solid\\] {\n    border: 1px solid;\n}\n\n  .vui-bdr_xs {\n    border-radius: var(--vui-radii-xs);\n}\n\n  .vui-w_\\[0\\.75rem\\] {\n    width: 0.75rem;\n}\n\n  .vui-h_\\[0\\.75rem\\] {\n    height: 0.75rem;\n}\n\n  .vui-w_\\[0\\.875rem\\] {\n    width: 0.875rem;\n}\n\n  .vui-h_\\[0\\.875rem\\] {\n    height: 0.875rem;\n}\n\n  .vui-w_\\[1\\.25rem\\] {\n    width: 1.25rem;\n}\n\n  .vui-h_\\[1\\.25rem\\] {\n    height: 1.25rem;\n}\n\n  .vui-c_accent\\.primary {\n    color: var(--vui-colors-accent-primary);\n}\n\n  .vui-c_accent\\.secondary {\n    color: var(--vui-colors-accent-secondary);\n}\n\n  .vui-c_accent\\.tertiary {\n    color: var(--vui-colors-accent-tertiary);\n}\n\n  .vui-c_teal\\.100 {\n    color: var(--vui-colors-teal-100);\n}\n\n  .vui-w_\\[0\\.625rem\\] {\n    width: 0.625rem;\n}\n\n  .vui-h_\\[auto\\] {\n    height: auto;\n}\n\n  .vui-stk-w_\\[4px\\] {\n    stroke-width: 4px;\n}\n\n  .vui-stk_\\[currentColor\\] {\n    stroke: currentColor;\n}\n\n  .vui-c_\\[transparent\\] {\n    color: transparent;\n}\n\n  .vui-gap_\\[2px\\] {\n    gap: 2px;\n}\n\n  .vui-gap_\\[4px\\] {\n    gap: 4px;\n}\n\n  .vui-bdr_\\[40px\\] {\n    border-radius: 40px;\n}\n\n  .vui-p_\\[5px\\] {\n    padding: 5px;\n}\n\n  .vui---chip-color_\\[white\\] {\n    --chip-color: white;\n}\n\n  .vui-bdr_\\[4px\\] {\n    border-radius: 4px;\n}\n\n  .vui---chip-color_\\{colors\\.accent\\.primary\\} {\n    --chip-color: var(--vui-colors-accent-primary);\n}\n\n  .vui---chip-color_\\{colors\\.accent\\.secondary\\} {\n    --chip-color: var(--vui-colors-accent-secondary);\n}\n\n  .vui---chip-color_\\{colors\\.accent\\.tertiary\\} {\n    --chip-color: var(--vui-colors-accent-tertiary);\n}\n\n  .vui-p_\\[5px_12px\\] {\n    padding: 5px 12px;\n}\n\n  .vui-h_\\[36px\\] {\n    height: 36px;\n}\n\n  .vui-p_\\[8px_15px\\] {\n    padding: 8px 15px;\n}\n\n  .vui-h_\\[48px\\] {\n    height: 48px;\n}\n\n  .vui-p_\\[12px_20px\\] {\n    padding: 12px 20px;\n}\n\n  .vui-bg_\\[none\\] {\n    background: none;\n}\n\n  .vui-ring_none {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n}\n\n  .vui-flex_1 {\n    flex: 1 1 0%;\n}\n\n  .vui-m_\\[0\\] {\n    margin: var(--vui-spacing-0);\n}\n\n  .vui-gap_\\[16px\\] {\n    gap: 16px;\n}\n\n  .vui-ov_auto {\n    overflow: auto;\n}\n\n  .vui-bx-sh_\\[0_0_15px_rgba\\(0\\,_0\\,_0\\,_0\\.5\\)\\] {\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n}\n\n  .vui-trs_\\[transform_0\\.3s_ease\\] {\n    transition: transform 0.3s ease;\n}\n\n  .vui-w_\\[320px\\] {\n    width: 320px;\n}\n\n  .vui-trf_\\[translateX\\(-100\\%\\)\\] {\n    transform: translateX(-100%);\n}\n\n  .vui-trf_\\[translateX\\(100\\%\\)\\] {\n    transform: translateX(100%);\n}\n\n  .vui-h_\\[320px\\] {\n    height: 320px;\n}\n\n  .vui-trf_\\[translateY\\(-100\\%\\)\\] {\n    transform: translateY(-100%);\n}\n\n  .vui-trf_\\[translateY\\(100\\%\\)\\] {\n    transform: translateY(100%);\n}\n\n  .vui-trf_translate\\(0\\) {\n    transform: translate(0);\n}\n\n  .vui-z_drawer {\n    z-index: var(--vui-z-index-drawer);\n}\n\n  .vui-pos_fixed {\n    position: fixed;\n}\n\n  .vui-pos_relative {\n    position: relative;\n}\n\n  .vui-trf_none {\n    transform: none;\n}\n\n  .vui-w_\\[20\\%\\] {\n    width: 20%;\n}\n\n  .vui-order_999 {\n    order: 999;\n}\n\n  .vui-anim_slideInLeft_250ms_ease-out_forwards {\n    animation: slideInLeft 250ms ease-out forwards;\n}\n\n  .vui-anim_slideInRight_250ms_ease-out_forwards {\n    animation: slideInRight 250ms ease-out forwards;\n}\n\n  .vui-anim_slideInTop_250ms_ease-out_forwards {\n    animation: slideInTop 250ms ease-out forwards;\n}\n\n  .vui-anim_slideInBottom_250ms_ease-out_forwards {\n    animation: slideInBottom 250ms ease-out forwards;\n}\n\n  .vui-bg_\\[rgba\\(0\\,_0\\,_0\\,_0\\.5\\)\\] {\n    background: rgba(0, 0, 0, 0.5);\n}\n\n  .vui-trs_\\[opacity_0\\.3s_ease\\,_visibility_0\\.3s_ease\\] {\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\n  .vui-op_\\[0\\] {\n    opacity: 0;\n}\n\n  .vui-vis_hidden {\n    visibility: hidden;\n}\n\n  .vui-pointer-events_none {\n    pointer-events: none;\n}\n\n  .vui-will-change_opacity {\n    will-change: opacity;\n}\n\n  .vui-vis_visible {\n    visibility: visible;\n}\n\n  .vui-op_1 {\n    opacity: 1;\n}\n\n  .vui-pointer-events_auto {\n    pointer-events: auto;\n}\n\n  .vui-z_backdrop {\n    z-index: var(--vui-z-index-backdrop);\n}\n\n  .vui-trs_\\[opacity_0\\.3s_ease\\,_visibility_0s_0\\.3s\\] {\n    transition: opacity 0.3s ease, visibility 0s 0.3s;\n}\n\n  .vui-d_none {\n    display: none;\n}\n\n  .vui-h_\\[100vh\\] {\n    height: 100vh;\n}\n\n  .vui-d_grid {\n    display: grid;\n}\n\n  .vui-place-items_center {\n    place-items: center;\n}\n\n  .vui-w_\\[750px\\] {\n    width: 750px;\n}\n\n  .vui-m_auto {\n    margin: auto;\n}\n\n  .vui-p_\\[16px\\] {\n    padding: 16px;\n}\n\n  .vui-min-h_\\[50\\%\\] {\n    min-height: 50%;\n}\n\n  .vui-max-h_\\[90\\%\\] {\n    max-height: 90%;\n}\n\n  .vui-bd_2px_solid_red {\n    border: 2px solid red;\n}\n\n  .vui-w_\\[fit-content\\] {\n    width: fit-content;\n}\n\n  .vui-bd_\\[none\\] {\n    border: none;\n}\n\n  .vui-p_\\[6px_12px\\] {\n    padding: 6px 12px;\n}\n\n  .vui-p_\\[24px_36px\\] {\n    padding: 24px 36px;\n}\n\n  .vui-c_primary {\n    color: primary;\n}\n\n  .vui-c_dark-teal\\.100 {\n    color: var(--vui-colors-dark-teal-100);\n}\n\n  .vui-gap_\\[0px\\] {\n    gap: 0px;\n}\n\n  .vui-pos_sticky {\n    position: sticky;\n}\n\n  .vui-bdr_\\[16px\\] {\n    border-radius: 16px;\n}\n\n  .vui-bdr_full {\n    border-radius: var(--vui-radii-full);\n}\n\n  .vui-white-space_nowrap {\n    white-space: nowrap;\n}\n\n  .vui-p_\\[16px_32px\\] {\n    padding: 16px 32px;\n}\n\n  .vui-p_\\[16px_24px\\] {\n    padding: 16px 24px;\n}\n\n  .vui-gap_\\[12px\\] {\n    gap: 12px;\n}\n\n  .vui-gap_\\[1rem\\] {\n    gap: 1rem;\n}\n\n  .vui-asp_1 {\n    aspect-ratio: 1;\n}\n\n  .vui-w_\\[1em\\] {\n    width: 1em;\n}\n\n  .vui-c_cream {\n    color: cream;\n}\n\n  .vui-max-h_\\[70vh\\] {\n    max-height: 70vh;\n}\n\n  .vui-td_none {\n    text-decoration: none;\n}\n\n  .vui-trf-o_center {\n    transform-origin: center;\n}\n\n  .vui-anim_loading-spinner-rotate_0\\.75s_infinite_linear {\n    animation: loading-spinner-rotate 0.75s infinite linear;\n}\n\n  .vui---spinner-color_\\{colors\\.dark-teal\\.100\\} {\n    --spinner-color: var(--vui-colors-dark-teal-100);\n}\n\n  .vui-w_\\[16px\\] {\n    width: 16px;\n}\n\n  .vui-h_\\[16px\\] {\n    height: 16px;\n}\n\n  .vui-w_\\[64px\\] {\n    width: 64px;\n}\n\n  .vui-h_\\[64px\\] {\n    height: 64px;\n}\n\n  .vui---spinner-color_colors\\.accent\\.primary {\n    --spinner-color: var(--vui-colors-accent-primary);\n}\n\n  .vui---spinner-color_colors\\.accent\\.secondary {\n    --spinner-color: var(--vui-colors-accent-secondary);\n}\n\n  .vui---spinner-color_colors\\.accent\\.tertiary {\n    --spinner-color: var(--vui-colors-accent-tertiary);\n}\n\n  .vui-asp_517\\/133 {\n    aspect-ratio: 517/133;\n}\n\n  .vui-asp_756\\/240 {\n    aspect-ratio: 756/240;\n}\n\n  .vui-asp_1119\\/133 {\n    aspect-ratio: 1119/133;\n}\n\n  .vui-asp_1960\\/170 {\n    aspect-ratio: 1960/170;\n}\n\n  .vui-asp_1485\\/173 {\n    aspect-ratio: 1485/173;\n}\n\n  .vui-asp_1171\\/137 {\n    aspect-ratio: 1171/137;\n}\n\n  .vui-asp_704\\/137 {\n    aspect-ratio: 704/137;\n}\n\n  .vui-asp_1332\\/171 {\n    aspect-ratio: 1332/171;\n}\n\n  .vui-asp_750\\/137 {\n    aspect-ratio: 750/137;\n}\n\n  .vui-asp_780\\/133 {\n    aspect-ratio: 780/133;\n}\n\n  .vui-asp_659\\/133 {\n    aspect-ratio: 659/133;\n}\n\n  .vui-asp_773\\/133 {\n    aspect-ratio: 773/133;\n}\n\n  .vui-asp_789\\/137 {\n    aspect-ratio: 789/137;\n}\n\n  .vui-asp_690\\/130 {\n    aspect-ratio: 690/130;\n}\n\n  .vui-asp_1130\\/173 {\n    aspect-ratio: 1130/173;\n}\n\n  .vui-asp_1114\\/171 {\n    aspect-ratio: 1114/171;\n}\n\n  .vui-asp_559\\/137 {\n    aspect-ratio: 559/137;\n}\n\n  .vui-asp_507\\/137 {\n    aspect-ratio: 507/137;\n}\n\n  .vui-asp_632\\/137 {\n    aspect-ratio: 632/137;\n}\n\n  .vui-asp_1173\\/137 {\n    aspect-ratio: 1173/137;\n}\n\n  .vui-asp_1034\\/137 {\n    aspect-ratio: 1034/137;\n}\n\n  .vui-asp_797\\/137 {\n    aspect-ratio: 797/137;\n}\n\n  .vui-ls_0 {\n    letter-spacing: 0;\n}\n\n  .vui-max-w_\\[100\\%\\] {\n    max-width: 100%;\n}\n\n  .vui-td_line-through {\n    text-decoration: line-through;\n}\n\n  .vui-bd-cl_collapse {\n    border-collapse: collapse;\n}\n\n  .vui-inset_\\[0\\] {\n    inset: var(--vui-spacing-0);\n}\n\n  .vui-z_modal {\n    z-index: var(--vui-z-index-modal);\n}\n\n  .vui---modal-margin_32px {\n    --modal-margin: 32px;\n}\n\n  .vui-m_var\\(--modal-margin\\) {\n    margin: var(--modal-margin);\n}\n\n  .vui-max-h_\\[calc\\(100\\%_-_var\\(--modal-margin\\)\\)\\] {\n    max-height: calc(100% - var(--modal-margin));\n}\n\n  .vui-max-w_\\[300px\\] {\n    max-width: 300px;\n}\n\n  .vui-max-w_\\[500px\\] {\n    max-width: 500px;\n}\n\n  .vui-max-w_\\[800px\\] {\n    max-width: 800px;\n}\n\n  .vui-p_\\[8px_16px\\] {\n    padding: 8px 16px;\n}\n\n  .vui-px_\\[16px\\] {\n    padding-inline: 16px;\n}\n\n  .vui-cursor_default {\n    cursor: default;\n}\n\n  .vui-offset_0 {\n    offset: 0;\n}\n\n  .vui-p_\\[8px_20px\\] {\n    padding: 8px 20px;\n}\n\n  .vui-p_\\[8px_24px\\] {\n    padding: 8px 24px;\n}\n\n  .vui-trs_\\[transform_250ms\\] {\n    transition: transform 250ms;\n}\n\n  .vui-bdr_md {\n    border-radius: var(--vui-radii-md);\n}\n\n  .vui-p_\\[8px_8px\\] {\n    padding: 8px 8px;\n}\n\n  .vui-w_\\[24px\\] {\n    width: 24px;\n}\n\n  .vui-h_\\[24px\\] {\n    height: 24px;\n}\n\n  .vui-min-w_var\\(--trigger-width\\) {\n    min-width: var(--trigger-width);\n}\n\n  .vui-ring-o_\\[0\\] {\n    outline-offset: var(--vui-spacing-0);\n}\n\n  .vui---slider-control-size_\\[0\\.75rem\\] {\n    --slider-control-size: 0.75rem;\n}\n\n  .vui---slider-track-size_\\[0\\.25rem\\] {\n    --slider-track-size: 0.25rem;\n}\n\n  .vui---slider-control-size_\\[0\\.875rem\\] {\n    --slider-control-size: 0.875rem;\n}\n\n  .vui---slider-control-size_\\[1\\.25rem\\] {\n    --slider-control-size: 1.25rem;\n}\n\n  .vui---slider-track-size_\\[0\\.375rem\\] {\n    --slider-track-size: 0.375rem;\n}\n\n  .vui-c_\\[currentColor\\] {\n    color: currentColor;\n}\n\n  .vui-grid-c_\\[1_\\/_-1\\] {\n    grid-column: 1 / -1;\n}\n\n  .vui-h_var\\(--slider-control-size\\) {\n    height: var(--slider-control-size);\n}\n\n  .vui-w_var\\(--slider-control-size\\) {\n    width: var(--slider-control-size);\n}\n\n  .vui-h_var\\(--slider-track-size\\) {\n    height: var(--slider-track-size);\n}\n\n  .vui-w_var\\(--slider-track-size\\) {\n    width: var(--slider-track-size);\n}\n\n  .vui-c_pink\\.80 {\n    color: var(--vui-colors-pink-80);\n}\n\n  .vui-c_green\\.80 {\n    color: var(--vui-colors-green-80);\n}\n\n  .vui-c_purple\\.80 {\n    color: var(--vui-colors-purple-80);\n}\n\n  .vui-c_teal\\.80 {\n    color: var(--vui-colors-teal-80);\n}\n\n  .vui-p_\\[16px_16px_16px_24px\\] {\n    padding: 16px 16px 16px 24px;\n}\n\n  .vui-tov_ellipsis {\n    text-overflow: ellipsis;\n}\n\n  .vui-anim_fadeIn_250ms_ease-out_forwards {\n    animation: fadeIn 250ms ease-out forwards;\n}\n\n  .vui-z_\\[snackbar\\] {\n    z-index: var(--vui-z-index-snackbar);\n}\n\n  .vui-trf_translateX\\(-50\\%\\) {\n    transform: translateX(-50%);\n}\n\n  .vui-gap_0 {\n    gap: var(--vui-spacing-0);\n}\n\n  .vui-gap_\\[1px\\] {\n    gap: 1px;\n}\n\n  .vui-gap_\\[3px\\] {\n    gap: 3px;\n}\n\n  .vui-gap_\\[6px\\] {\n    gap: 6px;\n}\n\n  .vui-gap_\\[7px\\] {\n    gap: 7px;\n}\n\n  .vui-gap_\\[9px\\] {\n    gap: 9px;\n}\n\n  .vui-gap_\\[10px\\] {\n    gap: 10px;\n}\n\n  .vui-gap_\\[11px\\] {\n    gap: 11px;\n}\n\n  .vui-gap_\\[13px\\] {\n    gap: 13px;\n}\n\n  .vui-gap_\\[14px\\] {\n    gap: 14px;\n}\n\n  .vui-gap_\\[15px\\] {\n    gap: 15px;\n}\n\n  .vui-gap_\\[17px\\] {\n    gap: 17px;\n}\n\n  .vui-gap_\\[18px\\] {\n    gap: 18px;\n}\n\n  .vui-gap_\\[19px\\] {\n    gap: 19px;\n}\n\n  .vui-gap_\\[20px\\] {\n    gap: 20px;\n}\n\n  .vui-gap_\\[21px\\] {\n    gap: 21px;\n}\n\n  .vui-gap_\\[22px\\] {\n    gap: 22px;\n}\n\n  .vui-gap_\\[23px\\] {\n    gap: 23px;\n}\n\n  .vui-gap_\\[24px\\] {\n    gap: 24px;\n}\n\n  .vui-gap_\\[25px\\] {\n    gap: 25px;\n}\n\n  .vui-gap_\\[26px\\] {\n    gap: 26px;\n}\n\n  .vui-gap_\\[27px\\] {\n    gap: 27px;\n}\n\n  .vui-gap_\\[28px\\] {\n    gap: 28px;\n}\n\n  .vui-gap_\\[29px\\] {\n    gap: 29px;\n}\n\n  .vui-gap_\\[30px\\] {\n    gap: 30px;\n}\n\n  .vui-gap_\\[31px\\] {\n    gap: 31px;\n}\n\n  .vui-gap_\\[32px\\] {\n    gap: 32px;\n}\n\n  .vui-gap_\\[33px\\] {\n    gap: 33px;\n}\n\n  .vui-gap_\\[34px\\] {\n    gap: 34px;\n}\n\n  .vui-gap_\\[35px\\] {\n    gap: 35px;\n}\n\n  .vui-gap_\\[36px\\] {\n    gap: 36px;\n}\n\n  .vui-gap_\\[37px\\] {\n    gap: 37px;\n}\n\n  .vui-gap_\\[38px\\] {\n    gap: 38px;\n}\n\n  .vui-gap_\\[39px\\] {\n    gap: 39px;\n}\n\n  .vui-gap_\\[40px\\] {\n    gap: 40px;\n}\n\n  .vui-gap_\\[41px\\] {\n    gap: 41px;\n}\n\n  .vui-gap_\\[42px\\] {\n    gap: 42px;\n}\n\n  .vui-gap_\\[43px\\] {\n    gap: 43px;\n}\n\n  .vui-gap_\\[44px\\] {\n    gap: 44px;\n}\n\n  .vui-gap_\\[45px\\] {\n    gap: 45px;\n}\n\n  .vui-gap_\\[46px\\] {\n    gap: 46px;\n}\n\n  .vui-gap_\\[47px\\] {\n    gap: 47px;\n}\n\n  .vui-gap_\\[48px\\] {\n    gap: 48px;\n}\n\n  .vui-gap_\\[49px\\] {\n    gap: 49px;\n}\n\n  .vui-gap_\\[50px\\] {\n    gap: 50px;\n}\n\n  .vui-gap_\\[51px\\] {\n    gap: 51px;\n}\n\n  .vui-gap_\\[52px\\] {\n    gap: 52px;\n}\n\n  .vui-gap_\\[53px\\] {\n    gap: 53px;\n}\n\n  .vui-gap_\\[54px\\] {\n    gap: 54px;\n}\n\n  .vui-gap_\\[55px\\] {\n    gap: 55px;\n}\n\n  .vui-gap_\\[56px\\] {\n    gap: 56px;\n}\n\n  .vui-gap_\\[57px\\] {\n    gap: 57px;\n}\n\n  .vui-gap_\\[58px\\] {\n    gap: 58px;\n}\n\n  .vui-gap_\\[59px\\] {\n    gap: 59px;\n}\n\n  .vui-gap_\\[60px\\] {\n    gap: 60px;\n}\n\n  .vui-gap_\\[61px\\] {\n    gap: 61px;\n}\n\n  .vui-gap_\\[62px\\] {\n    gap: 62px;\n}\n\n  .vui-gap_\\[63px\\] {\n    gap: 63px;\n}\n\n  .vui-gap_\\[64px\\] {\n    gap: 64px;\n}\n\n  .vui-gap_\\[65px\\] {\n    gap: 65px;\n}\n\n  .vui-gap_\\[66px\\] {\n    gap: 66px;\n}\n\n  .vui-gap_\\[67px\\] {\n    gap: 67px;\n}\n\n  .vui-gap_\\[68px\\] {\n    gap: 68px;\n}\n\n  .vui-gap_\\[69px\\] {\n    gap: 69px;\n}\n\n  .vui-gap_\\[70px\\] {\n    gap: 70px;\n}\n\n  .vui-gap_\\[71px\\] {\n    gap: 71px;\n}\n\n  .vui-gap_\\[72px\\] {\n    gap: 72px;\n}\n\n  .vui-gap_\\[73px\\] {\n    gap: 73px;\n}\n\n  .vui-gap_\\[74px\\] {\n    gap: 74px;\n}\n\n  .vui-gap_\\[75px\\] {\n    gap: 75px;\n}\n\n  .vui-gap_\\[76px\\] {\n    gap: 76px;\n}\n\n  .vui-gap_\\[77px\\] {\n    gap: 77px;\n}\n\n  .vui-gap_\\[78px\\] {\n    gap: 78px;\n}\n\n  .vui-gap_\\[79px\\] {\n    gap: 79px;\n}\n\n  .vui-gap_\\[80px\\] {\n    gap: 80px;\n}\n\n  .vui-gap_\\[81px\\] {\n    gap: 81px;\n}\n\n  .vui-gap_\\[82px\\] {\n    gap: 82px;\n}\n\n  .vui-gap_\\[83px\\] {\n    gap: 83px;\n}\n\n  .vui-gap_\\[84px\\] {\n    gap: 84px;\n}\n\n  .vui-gap_\\[85px\\] {\n    gap: 85px;\n}\n\n  .vui-gap_\\[86px\\] {\n    gap: 86px;\n}\n\n  .vui-gap_\\[87px\\] {\n    gap: 87px;\n}\n\n  .vui-gap_\\[88px\\] {\n    gap: 88px;\n}\n\n  .vui-gap_\\[89px\\] {\n    gap: 89px;\n}\n\n  .vui-gap_\\[90px\\] {\n    gap: 90px;\n}\n\n  .vui-gap_\\[91px\\] {\n    gap: 91px;\n}\n\n  .vui-gap_\\[92px\\] {\n    gap: 92px;\n}\n\n  .vui-gap_\\[93px\\] {\n    gap: 93px;\n}\n\n  .vui-gap_\\[94px\\] {\n    gap: 94px;\n}\n\n  .vui-gap_\\[95px\\] {\n    gap: 95px;\n}\n\n  .vui-gap_\\[96px\\] {\n    gap: 96px;\n}\n\n  .vui-gap_\\[97px\\] {\n    gap: 97px;\n}\n\n  .vui-gap_\\[98px\\] {\n    gap: 98px;\n}\n\n  .vui-gap_\\[99px\\] {\n    gap: 99px;\n}\n\n  .vui-gap_\\[100px\\] {\n    gap: 100px;\n}\n\n  .vui-p_\\[1px\\] {\n    padding: 1px;\n}\n\n  .vui-w_\\[1\\.375rem\\] {\n    width: 1.375rem;\n}\n\n  .vui-w_\\[1\\.625rem\\] {\n    width: 1.625rem;\n}\n\n  .vui-w_\\[2\\.3125rem\\] {\n    width: 2.3125rem;\n}\n\n  .vui-pos_absolute {\n    position: absolute;\n}\n\n  .vui-d_block {\n    display: block;\n}\n\n  .vui-trs_\\[right_0\\.2s_ease-in-out\\] {\n    transition: right 0.2s ease-in-out;\n}\n\n  .vui-w_\\[0\\.5rem\\] {\n    width: 0.5rem;\n}\n\n  .vui-bd-b_3px_solid_transparent {\n    border-bottom: 3px solid transparent;\n}\n\n  .vui-bd-e_3px_solid_transparent {\n    border-inline-end: 3px solid transparent;\n}\n\n  .vui-p_\\[10px\\] {\n    padding: 10px;\n}\n\n  .vui-offset_10 {\n    offset: 10px;\n}\n\n  .vui-bdr_\\[full\\] {\n    border-radius: var(--vui-radii-full);\n}\n\n  .vui-c_background {\n    color: var(--vui-colors-background);\n}\n\n  .vui-c_background\\.reversed {\n    color: var(--vui-colors-background-reversed);\n}\n\n  .vui-c_alert\\.error {\n    color: var(--vui-colors-alert-error);\n}\n\n  .vui-min-w_\\[0\\] {\n    min-width: 0;\n}\n\n  .vui-p_\\[8px_12px\\] {\n    padding: 8px 12px;\n}\n\n  .vui-p_\\[16px_16px\\] {\n    padding: 16px 16px;\n}\n\n  .vui-p_\\[12px_12px\\] {\n    padding: 12px 12px;\n}\n\n  .vui-bdr_\\[28px\\] {\n    border-radius: 28px;\n}\n\n  .vui-grid-area_1_\\/_1_\\/_2_\\/_2 {\n    grid-area: 1 / 1 / 2 / 2;\n}\n\n  .vui-resize_none {\n    resize: none;\n}\n\n  .vui-scr-bar-g_\\[stable\\] {\n    scrollbar-gutter: stable;\n}\n\n  .vui-scr-bar-c_\\[transparent_transparent\\] {\n    scrollbar-color: transparent transparent;\n}\n\n  .vui-p_\\[4px_8px\\] {\n    padding: 4px 8px;\n}\n\n  .vui-ai_flex-start {\n    align-items: flex-start;\n}\n\n  .vui-bg-c_var\\(--alert-color\\) {\n    background-color: var(--alert-color);\n}\n\n  .vui-fs_\\[22px\\] {\n    font-size: 22px;\n}\n\n  .vui-lh_1 {\n    line-height: 1;\n}\n\n  .vui-flex-g_1 {\n    flex-grow: 1;\n}\n\n  .vui-fs_sm {\n    font-size: var(--vui-font-sizes-sm);\n}\n\n  .vui-bg-c_\\[transparent\\] {\n    background-color: transparent;\n}\n\n  .vui-jc_center {\n    justify-content: center;\n}\n\n  .vui-ai_center {\n    align-items: center;\n}\n\n  .vui-bg-c_accent\\.primary {\n    background-color: var(--vui-colors-accent-primary);\n}\n\n  .vui-bg-c_accent\\.secondary {\n    background-color: var(--vui-colors-accent-secondary);\n}\n\n  .vui-bg-c_cream\\.100 {\n    background-color: var(--vui-colors-cream-100);\n}\n\n  .vui-ff_body {\n    font-family: var(--vui-fonts-body);\n}\n\n  .vui-fw_medium {\n    font-weight: var(--vui-font-weights-medium);\n}\n\n  .vui-bg-c_\\[var\\(--button-color\\)\\] {\n    background-color: var(--button-color);\n}\n\n  .vui-lh_1\\.55 {\n    line-height: 1.55;\n}\n\n  .vui-fs_md {\n    font-size: var(--vui-font-sizes-md);\n}\n\n  .vui-lh_1\\.5 {\n    line-height: 1.5;\n}\n\n  .vui-fs_\\[12px\\] {\n    font-size: 12px;\n}\n\n  .vui-flex-sh_0 {\n    flex-shrink: 0;\n}\n\n  .vui-bd-c_teal\\.80 {\n    border-color: var(--vui-colors-teal-80);\n}\n\n  .vui-bg-c_\\[white\\] {\n    background-color: white;\n}\n\n  .vui-bd-c_\\[transparent\\] {\n    border-color: transparent;\n}\n\n  .vui-flex-d_column {\n    flex-direction: column;\n}\n\n  .vui-bg-c_\\[var\\(--chip-color\\)\\] {\n    background-color: var(--chip-color);\n}\n\n  .vui-bd-c_\\[var\\(--chip-color\\)\\] {\n    border-color: var(--chip-color);\n}\n\n  .vui-bd-c_dark-teal\\.20 {\n    border-color: var(--vui-colors-dark-teal-20);\n}\n\n  .vui-ml_\\[2px\\] {\n    margin-left: 2px;\n}\n\n  .vui-flex-wrap_wrap {\n    flex-wrap: wrap;\n}\n\n  .vui-fs_lg {\n    font-size: var(--vui-font-sizes-lg);\n}\n\n  .vui-jc_end {\n    justify-content: end;\n}\n\n  .vui-top_\\[0\\] {\n    top: var(--vui-spacing-0);\n}\n\n  .vui-left_\\[0\\] {\n    left: var(--vui-spacing-0);\n}\n\n  .vui-bg-c_background\\.reversed {\n    background-color: var(--vui-colors-background-reversed);\n}\n\n  .vui-right_\\[0\\] {\n    right: var(--vui-spacing-0);\n}\n\n  .vui-left_\\[unset\\] {\n    left: unset;\n}\n\n  .vui-bottom_\\[0\\] {\n    bottom: var(--vui-spacing-0);\n}\n\n  .vui-right_\\[unset\\] {\n    right: unset;\n}\n\n  .vui-top_\\[unset\\] {\n    top: unset;\n}\n\n  .vui-top_0 {\n    top: var(--vui-spacing-0);\n}\n\n  .vui-left_0 {\n    left: var(--vui-spacing-0);\n}\n\n  .vui-jc_space-between {\n    justify-content: space-between;\n}\n\n  .vui-jc_flex-end {\n    justify-content: flex-end;\n}\n\n  .vui-bg-c_extra-dark-teal\\.100 {\n    background-color: var(--vui-colors-extra-dark-teal-100);\n}\n\n  .vui-ov-y_auto {\n    overflow-y: auto;\n}\n\n  .vui-bd-c_\\[white\\] {\n    border-color: white;\n}\n\n  .vui-fs_\\[14px\\] {\n    font-size: 14px;\n}\n\n  .vui-fs_\\[16px\\] {\n    font-size: 16px;\n}\n\n  .vui-jc_flex-start {\n    justify-content: flex-start;\n}\n\n  .vui-ai_stretch {\n    align-items: stretch;\n}\n\n  .vui-flex-d_row {\n    flex-direction: row;\n}\n\n  .vui-flex-wrap_nowrap {\n    flex-wrap: nowrap;\n}\n\n  .vui-as_center {\n    align-self: center;\n}\n\n  .vui-fs_\\[24px\\] {\n    font-size: 24px;\n}\n\n  .vui-fs_2xl {\n    font-size: var(--vui-font-sizes-2xl);\n}\n\n  .vui-fw_semiBold {\n    font-weight: var(--vui-font-weights-semi-bold);\n}\n\n  .vui-text-decoration-line_underline {\n    text-decoration-line: underline;\n}\n\n  .vui-td-c_\\[currentColor\\/50\\] {\n    --mix-textDecorationColor: color-mix(in srgb, currentColor 50%, transparent);\n    text-decoration-color: var(--mix-textDecorationColor, currentColor);\n}\n\n  .vui-fs_\\[2\\.25rem\\] {\n    font-size: 2.25rem;\n}\n\n  .vui-ff_\\[PP_Telegraf\\] {\n    font-family: PP Telegraf;\n}\n\n  .vui-fw_\\[500\\] {\n    font-weight: 500;\n}\n\n  .vui-font-style_normal {\n    font-style: normal;\n}\n\n  .vui-lh_\\[43\\.2px\\] {\n    line-height: 43.2px;\n}\n\n  .vui-fs_\\[2rem\\] {\n    font-size: 2rem;\n}\n\n  .vui-lh_\\[38\\.4px\\] {\n    line-height: 38.4px;\n}\n\n  .vui-fs_\\[1\\.5rem\\] {\n    font-size: 1.5rem;\n}\n\n  .vui-lh_\\[28\\.8px\\] {\n    line-height: 28.8px;\n}\n\n  .vui-fs_\\[1\\.25rem\\] {\n    font-size: 1.25rem;\n}\n\n  .vui-lh_\\[24px\\] {\n    line-height: 24px;\n}\n\n  .vui-fs_\\[1\\.125rem\\] {\n    font-size: 1.125rem;\n}\n\n  .vui-lh_\\[21\\.6px\\] {\n    line-height: 21.6px;\n}\n\n  .vui-fs_\\[1rem\\] {\n    font-size: 1rem;\n}\n\n  .vui-lh_\\[20\\.8px\\] {\n    line-height: 20.8px;\n}\n\n  .vui-fs_\\[0\\.875rem\\] {\n    font-size: 0.875rem;\n}\n\n  .vui-ff_\\[Manrope\\] {\n    font-family: Manrope;\n}\n\n  .vui-fw_\\[400\\] {\n    font-weight: 400;\n}\n\n  .vui-lh_\\[21px\\] {\n    line-height: 21px;\n}\n\n  .vui-li-t_revert {\n    list-style-type: revert;\n}\n\n  .vui-mb_\\[16px\\] {\n    margin-bottom: 16px;\n}\n\n  .vui-mb_0 {\n    margin-bottom: var(--vui-spacing-0);\n}\n\n  .vui-font-style_italic {\n    font-style: italic;\n}\n\n  .vui-bd-c_gray\\.60 {\n    border-color: var(--vui-colors-gray-60);\n}\n\n  .vui-bg-c_\\[black\\/80\\] {\n    --mix-backgroundColor: color-mix(in srgb, black 80%, transparent);\n    background-color: var(--mix-backgroundColor, black);\n}\n\n  .vui-bg-c_background {\n    background-color: var(--vui-colors-background);\n}\n\n  .vui-cg_\\[8px\\] {\n    column-gap: 8px;\n}\n\n  .vui-ai_start {\n    align-items: start;\n}\n\n  .vui-as_start {\n    align-self: start;\n}\n\n  .vui-grid-tr_\\[1fr_auto_1fr\\] {\n    grid-template-rows: 1fr auto 1fr;\n}\n\n  .vui-fs_\\[inherit\\] {\n    font-size: inherit;\n}\n\n  .vui-bg-c_\\[inherit\\] {\n    background-color: inherit;\n}\n\n  .vui-grid-tc_\\[24px_auto\\] {\n    grid-template-columns: 24px auto;\n}\n\n  .vui-justify-self_center {\n    justify-self: center;\n}\n\n  .vui-justify-self_start {\n    justify-self: start;\n}\n\n  .vui-mt_0 {\n    margin-top: var(--vui-spacing-0);\n}\n\n  .vui-outline-style_solid {\n    outline-style: solid;\n}\n\n  .vui-ring-c_accent\\.tertiary {\n    outline-color: var(--vui-colors-accent-tertiary);\n}\n\n  .vui-ring-w_0 {\n    outline-width: 0;\n}\n\n  .vui-grid-tc_\\[1fr_auto\\] {\n    grid-template-columns: 1fr auto;\n}\n\n  .vui-mb_\\[calc\\(var\\(--slider-control-size\\)_\\/_2\\)\\] {\n    margin-bottom: calc(var(--slider-control-size) / 2);\n}\n\n  .vui-bg-c_teal\\.20 {\n    background-color: var(--vui-colors-teal-20);\n}\n\n  .vui-bg-c_\\[currentColor\\] {\n    background-color: currentColor;\n}\n\n  .vui-top_\\[50\\%\\] {\n    top: 50%;\n}\n\n  .vui-left_\\[50\\%\\] {\n    left: 50%;\n}\n\n  .vui-bg-c_alert\\.confirmation {\n    background-color: var(--vui-colors-alert-confirmation);\n}\n\n  .vui-bg-c_alert\\.error {\n    background-color: var(--vui-colors-alert-error);\n}\n\n  .vui-ml_auto {\n    margin-left: auto;\n}\n\n  .vui-flex-d_column-reverse {\n    flex-direction: column-reverse;\n}\n\n  .vui-top_\\[1rem\\] {\n    top: 1rem;\n}\n\n  .vui-left_\\[1rem\\] {\n    left: 1rem;\n}\n\n  .vui-right_\\[1rem\\] {\n    right: 1rem;\n}\n\n  .vui-bottom_\\[1rem\\] {\n    bottom: 1rem;\n}\n\n  .vui-ai_flex-end {\n    align-items: flex-end;\n}\n\n  .vui-jc_space-around {\n    justify-content: space-around;\n}\n\n  .vui-jc_space-evenly {\n    justify-content: space-evenly;\n}\n\n  .vui-bg-c_dark-teal\\.100 {\n    background-color: var(--vui-colors-dark-teal-100);\n}\n\n  .vui-bd-c_cream\\.100\\/60 {\n    --mix-borderColor: color-mix(in srgb, var(--vui-colors-cream-100) 60%, transparent);\n    border-color: var(--mix-borderColor, var(--vui-colors-cream-100));\n}\n\n  .vui-bg-c_teal\\.80 {\n    background-color: var(--vui-colors-teal-80);\n}\n\n  .vui-right_\\[calc\\(100\\%_-_0\\.5rem_-_1px\\)\\] {\n    right: calc(100% - 0.5rem - 1px);\n}\n\n  .vui-right_\\[calc\\(100\\%_-_0\\.625rem_-_1px\\)\\] {\n    right: calc(100% - 0.625rem - 1px);\n}\n\n  .vui-right_\\[calc\\(100\\%_-_0\\.875rem_-_2px\\)\\] {\n    right: calc(100% - 0.875rem - 2px);\n}\n\n  .vui-mt_\\[4px\\] {\n    margin-top: 4px;\n}\n\n  .vui-ring-w_\\[0px\\] {\n    outline-width: 0px;\n}\n\n  .vui-lh_\\[16px\\] {\n    line-height: 16px;\n}\n\n  .vui-lh_\\[22px\\] {\n    line-height: 22px;\n}\n\n  .vui-bd-w_\\[2px\\] {\n    border-width: 2px;\n}\n\n  .vui-lh_\\[1rem\\] {\n    line-height: 1rem;\n}\n\n  .vui-lh_\\[1\\.375rem\\] {\n    line-height: 1.375rem;\n}\n\n  .vui-lh_1\\.5rem {\n    line-height: 1.5rem;\n}\n\n  .disabled\\:vui-cursor_not-allowed:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    cursor: not-allowed;\n}\n\n  .disabled\\:vui-c_gray\\.60:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    color: var(--vui-colors-gray-60);\n}\n\n  .componentReadOnly\\:vui-cursor_default:is([data-readonly]) {\n    cursor: default;\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:vui-c_gray\\.40 {\n    color: var(--vui-colors-gray-40);\n}\n\n  .group:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]) .groupInvalid\\:vui-c_alert\\.error {\n    color: var(--vui-colors-alert-error);\n}\n\n  .group:is([aria-selected=true], [data-selected], [data-state=\"selected\"]) .groupSelected\\:vui-c_cream\\.100 {\n    color: var(--vui-colors-cream-100);\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:vui-c_cream\\.100 {\n    color: var(--vui-colors-cream-100);\n}\n\n  .group:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]) .groupInvalid\\:vui-c_cream\\.100 {\n    color: var(--vui-colors-cream-100);\n}\n\n  .group:is([aria-selected=true], [data-selected], [data-state=\"selected\"]) .groupSelected\\:vui-c_dark-teal\\.100 {\n    color: var(--vui-colors-dark-teal-100);\n}\n\n  .group:is([aria-selected=true], [data-selected], [data-state=\"selected\"]) .groupSelected\\:vui-c_teal\\.100 {\n    color: var(--vui-colors-teal-100);\n}\n\n  .disabled\\:vui-c_text\\.primary:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    color: var(--vui-colors-text-primary);\n}\n\n  .dark\\:vui---chip-color_\\{colors\\.background\\}.dark,.dark .dark\\:vui---chip-color_\\{colors\\.background\\},[data-color-mode=dark] .dark\\:vui---chip-color_\\{colors\\.background\\} {\n    --chip-color: var(--vui-colors-background);\n}\n\n  .\\[\\&\\[data-href\\]\\]\\:vui-cursor_pointer[data-href] {\n    cursor: pointer;\n}\n\n  .\\[\\&\\[data-href\\]\\]\\:vui-td_underline[data-href] {\n    text-decoration: underline;\n}\n\n  .dark\\:vui-c_text\\.primary.dark,.dark .dark\\:vui-c_text\\.primary,[data-color-mode=dark] .dark\\:vui-c_text\\.primary {\n    color: var(--vui-colors-text-primary);\n}\n\n  .dark\\:vui-c_extra-dark-teal\\.100.dark,.dark .dark\\:vui-c_extra-dark-teal\\.100,[data-color-mode=dark] .dark\\:vui-c_extra-dark-teal\\.100 {\n    color: var(--vui-colors-extra-dark-teal-100);\n}\n\n  .dark\\:vui---chip-color_\\{colors\\.accent\\.primary\\}.dark,.dark .dark\\:vui---chip-color_\\{colors\\.accent\\.primary\\},[data-color-mode=dark] .dark\\:vui---chip-color_\\{colors\\.accent\\.primary\\} {\n    --chip-color: var(--vui-colors-accent-primary);\n}\n\n  .dark\\:vui---chip-color_\\{colors\\.accent\\.secondary\\}.dark,.dark .dark\\:vui---chip-color_\\{colors\\.accent\\.secondary\\},[data-color-mode=dark] .dark\\:vui---chip-color_\\{colors\\.accent\\.secondary\\} {\n    --chip-color: var(--vui-colors-accent-secondary);\n}\n\n  .dark\\:vui-c_text\\.primary\\.reversed.dark,.dark .dark\\:vui-c_text\\.primary\\.reversed,[data-color-mode=dark] .dark\\:vui-c_text\\.primary\\.reversed {\n    color: var(--vui-colors-text-primary-reversed);\n}\n\n  .dark\\:vui---chip-color_\\{colors\\.accent\\.tertiary\\}.dark,.dark .dark\\:vui---chip-color_\\{colors\\.accent\\.tertiary\\},[data-color-mode=dark] .dark\\:vui---chip-color_\\{colors\\.accent\\.tertiary\\} {\n    --chip-color: var(--vui-colors-accent-tertiary);\n}\n\n  .dark\\:vui-c_accent\\.secondary.dark,.dark .dark\\:vui-c_accent\\.secondary,[data-color-mode=dark] .dark\\:vui-c_accent\\.secondary {\n    color: var(--vui-colors-accent-secondary);\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:vui-c_dark-teal\\.100 {\n    color: var(--vui-colors-dark-teal-100);\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:vui-stk_gray\\.80 {\n    stroke: var(--vui-colors-gray-80);\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:vui-c_gray\\.80 {\n    color: var(--vui-colors-gray-80);\n}\n\n  .\\[\\&_ul\\]\\:vui-p_0 ul {\n    padding: var(--vui-spacing-0);\n}\n\n  .\\[\\&_ul\\]\\:vui-m_0 ul {\n    margin: var(--vui-spacing-0);\n}\n\n  .\\[\\&_a\\]\\:vui-td_none a {\n    text-decoration: none;\n}\n\n  .\\[\\&_label\\]\\:vui-c_\\[inherit\\] label {\n    color: inherit;\n}\n\n  .\\[\\&_a\\]\\:vui-c_green\\.100 a {\n    color: var(--vui-colors-green-100);\n}\n\n  .\\[\\&_a\\]\\:vui-c_accent\\.primary a {\n    color: var(--vui-colors-accent-primary);\n}\n\n  .\\[\\&_ul\\]\\:vui-d_flex ul {\n    display: flex;\n}\n\n  .\\[\\&_ul\\]\\:vui-gap_\\[32px\\] ul {\n    gap: 32px;\n}\n\n  .\\[\\&_li\\:\\:marker\\]\\:vui-c_cream\\.10 li::marker {\n    color: var(--vui-colors-cream-10);\n}\n\n  .\\[\\&_li\\:\\:marker\\]\\:vui-c_extra-dark-teal\\.10 li::marker {\n    color: var(--vui-colors-extra-dark-teal-10);\n}\n\n  .disabled\\:vui-op_0\\.6:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    opacity: 0.6;\n}\n\n  .dark\\:vui-c_accent\\.primary.dark,.dark .dark\\:vui-c_accent\\.primary,[data-color-mode=dark] .dark\\:vui-c_accent\\.primary {\n    color: var(--vui-colors-accent-primary);\n}\n\n  .disabled\\:vui-c_gray\\.40:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    color: var(--vui-colors-gray-40);\n}\n\n  .dark\\:vui---spinner-color_\\[white\\].dark,.dark .dark\\:vui---spinner-color_\\[white\\],[data-color-mode=dark] .dark\\:vui---spinner-color_\\[white\\] {\n    --spinner-color: white;\n}\n\n  .dark\\:vui---spinner-color_colors\\.accent\\.primary.dark,.dark .dark\\:vui---spinner-color_colors\\.accent\\.primary,[data-color-mode=dark] .dark\\:vui---spinner-color_colors\\.accent\\.primary {\n    --spinner-color: var(--vui-colors-accent-primary);\n}\n\n  .dark\\:vui---spinner-color_colors\\.accent\\.secondary.dark,.dark .dark\\:vui---spinner-color_colors\\.accent\\.secondary,[data-color-mode=dark] .dark\\:vui---spinner-color_colors\\.accent\\.secondary {\n    --spinner-color: var(--vui-colors-accent-secondary);\n}\n\n  .dark\\:vui---spinner-color_colors\\.accent\\.tertiary.dark,.dark .dark\\:vui---spinner-color_colors\\.accent\\.tertiary,[data-color-mode=dark] .dark\\:vui---spinner-color_colors\\.accent\\.tertiary {\n    --spinner-color: var(--vui-colors-accent-tertiary);\n}\n\n  .\\[\\&\\[src\\*\\=\\\"\\#thumbnail\\\"\\]\\]\\:vui-w_\\[64px\\][src*=\"#thumbnail\"] {\n    width: 64px;\n}\n\n  .\\[\\&_th\\,_\\&_td\\]\\:vui-bd_1px_solid th,.\\[\\&_th\\,_\\&_td\\]\\:vui-bd_1px_solid td {\n    border: 1px solid;\n}\n\n  .\\[\\&_th\\,_\\&_td\\]\\:vui-ta_left th,.\\[\\&_th\\,_\\&_td\\]\\:vui-ta_left td {\n    text-align: left;\n}\n\n  .\\[\\&_th\\,_\\&_td\\]\\:vui-p_\\[8px\\] th,.\\[\\&_th\\,_\\&_td\\]\\:vui-p_\\[8px\\] td {\n    padding: 8px;\n}\n\n  .before\\:vui-d_block::before {\n    display: block;\n}\n\n  .before\\:vui-asp_1::before {\n    aspect-ratio: 1;\n}\n\n  .before\\:vui-bdr_full::before {\n    border-radius: var(--vui-radii-full);\n}\n\n  .before\\:vui-w_\\[0\\.25rem\\]::before {\n    width: 0.25rem;\n}\n\n  .before\\:vui-w_\\[0\\.375rem\\]::before {\n    width: 0.375rem;\n}\n\n  .before\\:vui-w_\\[0\\.5rem\\]::before {\n    width: 0.5rem;\n}\n\n  .\\[\\&_\\[data-empty-icon\\=\\\"true\\\"\\]\\]\\:vui-d_none [data-empty-icon=\"true\"] {\n    display: none;\n}\n\n  .disabled\\:vui-c_gray\\.80:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    color: var(--vui-colors-gray-80);\n}\n\n  .group:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]) .groupInvalid\\:vui-c_error-red\\.100 {\n    color: var(--vui-colors-error-red-100);\n}\n\n  .group:is([open], [data-open]) .groupOpen\\:vui-trf_rotate\\(180deg\\) {\n    transform: rotate(180deg);\n}\n\n  .\\[\\&_svg\\]\\:vui-w_\\[100\\%\\] svg {\n    width: 100%;\n}\n\n  .\\[\\&_svg\\]\\:vui-h_\\[100\\%\\] svg {\n    height: 100%;\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:vui-pointer-events_none {\n    pointer-events: none;\n}\n\n  .disabled\\:vui-c_\\[inherit\\]:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    color: inherit;\n}\n\n  .dragging\\:vui-c_\\[inherit\\]:is([data-dragging]) {\n    color: inherit;\n}\n\n  .dragging\\:vui-c_accent\\.tertiary:is([data-dragging]) {\n    color: var(--vui-colors-accent-tertiary);\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:vui-c_\\[white\\] {\n    color: white;\n}\n\n  .group:is([data-readonly]) .groupComponentReadOnly\\:vui---switch-hover-thumb-color_\\{colors\\.teal\\.80\\} {\n    --switch-hover-thumb-color: var(--vui-colors-teal-80);\n}\n\n  .\\[\\&\\[data-orientation\\=\\\"horizontal\\\"\\]\\]\\:vui-bd-b_\\[1px_solid_gray\\][data-orientation=\"horizontal\"] {\n    border-bottom: 1px solid gray;\n}\n\n  .\\[\\&\\[data-orientation\\=vertical\\]\\]\\:vui-bd-e_\\[1px_solid_gray\\][data-orientation=vertical] {\n    border-inline-end: 1px solid gray;\n}\n\n  .\\[\\&_svg\\]\\:vui-c_dark-teal\\.100 svg {\n    color: var(--vui-colors-dark-teal-100);\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:vui-c_accent\\.primary[data-selected] {\n    color: var(--vui-colors-accent-primary);\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:vui-cursor_pointer[data-selected] {\n    cursor: pointer;\n}\n\n  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-cursor_pointer[data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-cursor_pointer) {\n    cursor: pointer;\n}\n\n  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"horizontal\\\"\\]_\\&\\)\\]\\:vui-cursor_pointer:not([data-selected]):is([data-orientation=\"horizontal\"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"horizontal\\\"\\]_\\&\\)\\]\\:vui-cursor_pointer) {\n    cursor: pointer;\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:vui-c_gray\\.60[data-disabled] {\n    color: var(--vui-colors-gray-60);\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:vui-cursor_not-allowed[data-disabled] {\n    cursor: not-allowed;\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:vui-bd-b_3px_solid_transparent[data-disabled] {\n    border-bottom: 3px solid transparent;\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:vui-bd-e_3px_solid_transparent[data-disabled] {\n    border-inline-end: 3px solid transparent;\n}\n\n  .\\[\\&\\[data-entering\\]\\]\\:vui-anim_fadeIn_250ms_ease-out_forwards[data-entering] {\n    animation: fadeIn 250ms ease-out forwards;\n}\n\n  .\\[\\&\\[data-exiting\\]\\]\\:vui-anim_fadeOut_250ms_ease-out_forwards[data-exiting] {\n    animation: fadeOut 250ms ease-out forwards;\n}\n\n  .\\[\\&\\[data-placement\\=\\\"left\\\"\\]_svg\\]\\:vui-trf_rotate\\(-90deg\\)[data-placement=\"left\"] svg {\n    transform: rotate(-90deg);\n}\n\n  .\\[\\&\\[data-placement\\=\\\"right\\\"\\]_svg\\]\\:vui-trf_rotate\\(90deg\\)[data-placement=\"right\"] svg {\n    transform: rotate(90deg);\n}\n\n  .\\[\\&\\[data-placement\\=\\\"bottom\\\"\\]_svg\\]\\:vui-trf_rotate\\(180deg\\)[data-placement=\"bottom\"] svg {\n    transform: rotate(180deg);\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:vui-c_\\[\\#343434\\] {\n    color: #343434;\n}\n\n  .invalid\\:vui-bd_\\[1px_solid\\]:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]) {\n    border: 1px solid;\n}\n\n  .placeholder\\:vui-c_gray\\.50::placeholder,.placeholder\\:vui-c_gray\\.50[data-placeholder] {\n    color: var(--vui-colors-gray-50);\n}\n\n  .after\\:vui-white-space_pre-wrap::after {\n    white-space: pre-wrap;\n}\n\n  .after\\:vui-vis_hidden::after {\n    visibility: hidden;\n}\n\n  .after\\:vui-bd_\\[none\\]::after {\n    border: none;\n}\n\n  .after\\:vui-p_0::after {\n    padding: var(--vui-spacing-0);\n}\n\n  .after\\:vui-grid-area_1_\\/_1_\\/_2_\\/_2::after {\n    grid-area: 1 / 1 / 2 / 2;\n}\n\n  .after\\:vui-p_\\[4px_8px\\]::after {\n    padding: 4px 8px;\n}\n\n  .disabled\\:vui-bg-c_gray\\.20:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-gray-20);\n}\n\n  .disabled\\:vui-bd-c_gray\\.40:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    border-color: var(--vui-colors-gray-40);\n}\n\n  .disabled\\:vui-bd-c_gray\\.10:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    border-color: var(--vui-colors-gray-10);\n}\n\n  .group:is([aria-selected=true], [data-selected], [data-state=\"selected\"]) .groupSelected\\:vui-bg-c_\\[currentColor\\] {\n    background-color: currentColor;\n}\n\n  .group:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]) .groupInvalid\\:vui-bd-c_\\[currentColor\\] {\n    border-color: currentColor;\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:vui-bd-c_green\\.100[data-selected] {\n    border-color: var(--vui-colors-green-100);\n}\n\n  .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_var\\(--chip-color\\)\\)\\].dark,.dark .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_var\\(--chip-color\\)\\)\\],[data-color-mode=dark] .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_var\\(--chip-color\\)\\)\\] {\n    border-color: color-mix(in srgb, var(--vui-colors-cream-100) 20%, var(--chip-color));\n}\n\n  .dark\\:vui-bg-c_cream\\.100.dark,.dark .dark\\:vui-bg-c_cream\\.100,[data-color-mode=dark] .dark\\:vui-bg-c_cream\\.100 {\n    background-color: var(--vui-colors-cream-100);\n}\n\n  .dark\\:vui-bg-c_background.dark,.dark .dark\\:vui-bg-c_background,[data-color-mode=dark] .dark\\:vui-bg-c_background {\n    background-color: var(--vui-colors-background);\n}\n\n  .dark\\:vui-bd-c_background.dark,.dark .dark\\:vui-bd-c_background,[data-color-mode=dark] .dark\\:vui-bd-c_background {\n    border-color: var(--vui-colors-background);\n}\n\n  .dark\\:vui-bg-c_\\[transparent\\].dark,.dark .dark\\:vui-bg-c_\\[transparent\\],[data-color-mode=dark] .dark\\:vui-bg-c_\\[transparent\\] {\n    background-color: transparent;\n}\n\n  .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_\\{colors\\.background\\}\\)\\].dark,.dark .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_\\{colors\\.background\\}\\)\\],[data-color-mode=dark] .dark\\:vui-bd-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.cream\\.100\\}_20\\%\\,_\\{colors\\.background\\}\\)\\] {\n    border-color: color-mix(in srgb, var(--vui-colors-cream-100) 20%, var(--vui-colors-background));\n}\n\n  .\\[\\&_ul\\]\\:vui-li-t_none ul {\n    list-style-type: none;\n}\n\n  .\\[\\&_label\\]\\:vui-fs_\\[20px\\] label {\n    font-size: 20px;\n}\n\n  .\\[\\&_span\\]\\:vui-mr_\\[32px\\] span {\n    margin-right: 32px;\n}\n\n  .\\[\\&_th\\,_\\&_td\\]\\:vui-bd-c_gray\\.60 th,.\\[\\&_th\\,_\\&_td\\]\\:vui-bd-c_gray\\.60 td {\n    border-color: var(--vui-colors-gray-60);\n}\n\n  .before\\:vui-content_\\\"\\\"::before {\n    content: \"\";\n}\n\n  .group:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]) .groupInvalid\\:vui-bd-c_error-red\\.100 {\n    border-color: var(--vui-colors-error-red-100);\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:vui-bg-c_gray\\.20 {\n    background-color: var(--vui-colors-gray-20);\n}\n\n  .group:is([aria-selected=true], [data-selected], [data-state=\"selected\"]) .groupSelected\\:vui-right_\\[1px\\] {\n    right: 1px;\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:vui-bg-c_gray\\.40 {\n    background-color: var(--vui-colors-gray-40);\n}\n\n  .group:is([aria-selected=true], [data-selected], [data-state=\"selected\"]) .groupSelected\\:vui-right_\\[2px\\] {\n    right: 2px;\n}\n\n  .\\[\\&\\[data-orientation\\=horizontal\\]\\]\\:vui-flex-d_column[data-orientation=horizontal] {\n    flex-direction: column;\n}\n\n  .\\[\\&\\[data-orientation\\=vertical\\]\\]\\:vui-flex-d_row[data-orientation=vertical] {\n    flex-direction: row;\n}\n\n  .\\[\\&\\[data-orientation\\=vertical\\]\\]\\:vui-flex-d_column[data-orientation=vertical] {\n    flex-direction: column;\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:vui-bd-t-c_\\[transparent\\][data-selected] {\n    border-top-color: transparent;\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:vui-bd-l-c_\\[transparent\\][data-selected] {\n    border-left-color: transparent;\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:vui-bd-r-c_\\[transparent\\][data-selected] {\n    border-right-color: transparent;\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:vui-bd-b-c_accent\\.primary[data-selected] {\n    border-bottom-color: var(--vui-colors-accent-primary);\n}\n\n  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-e-c_accent\\.primary[data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-e-c_accent\\.primary) {\n    border-inline-end-color: var(--vui-colors-accent-primary);\n}\n\n  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\][data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\]) {\n    border-bottom-color: transparent;\n}\n\n  .\\[\\&\\[data-placement\\=\\\"top\\\"\\]_svg\\]\\:vui-mt_\\[-1px\\][data-placement=\"top\"] svg {\n    margin-top: -1px;\n}\n\n  .\\[\\&\\[data-placement\\=\\\"left\\\"\\]_svg\\]\\:vui-ml_\\[-4px\\][data-placement=\"left\"] svg {\n    margin-left: -4px;\n}\n\n  .\\[\\&\\[data-placement\\=\\\"right\\\"\\]_svg\\]\\:vui-mr_\\[-4px\\][data-placement=\"right\"] svg {\n    margin-right: -4px;\n}\n\n  .\\[\\&\\[data-placement\\=\\\"bottom\\\"\\]_svg\\]\\:vui-mb_\\[-1px\\][data-placement=\"bottom\"] svg {\n    margin-bottom: -1px;\n}\n\n  .invalid\\:vui-bd-c_error-red\\.100:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]) {\n    border-color: var(--vui-colors-error-red-100);\n}\n\n  .after\\:vui-content_attr\\(data-replicated-value\\)_\\\"_\\\"::after {\n    content: attr(data-replicated-value) \" \";\n}\n\n  .disabled\\:vui-bg-c_\\[inherit\\]:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: inherit;\n}\n\n  .group:focus-within .groupFocusWithin\\:vui-ring-w_2px {\n    outline-width: 2px;\n}\n\n  .focus\\:vui-ring_2px_solid:is(:focus, [data-focus], [data-focused=true]) {\n    outline: 2px solid;\n}\n\n  .hoverOrFocus\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.dark-teal\\.100\\}_50\\%\\,_white\\)_transparent\\]:is(:hover, [data-hover], [data-hovered]),.hoverOrFocus\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_\\{colors\\.dark-teal\\.100\\}_50\\%\\,_white\\)_transparent\\]:is(:focus, [data-focus], [data-focused=true]) {\n    scrollbar-color: color-mix(in srgb, var(--vui-colors-dark-teal-100) 50%, white) transparent;\n}\n\n  .focus\\:vui-ring-c_\\[currentColor\\]:is(:focus, [data-focus], [data-focused=true]) {\n    outline-color: currentColor;\n}\n\n  .focusVisible\\:vui-ring-w_2px:is(:focus-visible, [data-focus-visible]) {\n    outline-width: 2px;\n}\n\n  .group:is(:focus-visible, [data-focus-visible]) .groupFocusVisible\\:vui-ring-w_2px {\n    outline-width: 2px;\n}\n\n  .peer:is(:focus-visible, [data-focus-visible]) ~ .peerFocusVisible\\:vui-ring-w_2px {\n    outline-width: 2px;\n}\n\n  .hover\\:vui-c_\\[inherit\\]:is(:hover, [data-hover], [data-hovered]) {\n    color: inherit;\n}\n\n  .hover\\:vui-c_accent\\.primary:is(:hover, [data-hover], [data-hovered]) {\n    color: var(--vui-colors-accent-primary);\n}\n\n  .hover\\:vui-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]) {\n    color: var(--vui-colors-accent-secondary);\n}\n\n  .hover\\:vui-c_accent\\.tertiary:is(:hover, [data-hover], [data-hovered]) {\n    color: var(--vui-colors-accent-tertiary);\n}\n\n  .hover\\:vui-c_teal\\.100:is(:hover, [data-hover], [data-hovered]) {\n    color: var(--vui-colors-teal-100);\n}\n\n  .hover\\:vui-c_cream\\.100:is(:hover, [data-hover], [data-hovered]) {\n    color: var(--vui-colors-cream-100);\n}\n\n  .hover\\:vui-cursor_pointer:is(:hover, [data-hover], [data-hovered]) {\n    cursor: pointer;\n}\n\n  .group:is(:hover, [data-hover], [data-hovered]) .groupHover\\:vui-bd-c_teal\\.100 {\n    border-color: var(--vui-colors-teal-100);\n}\n\n  .hover\\:vui-bg-c_dark-teal\\.10:is(:hover, [data-hover], [data-hovered]) {\n    background-color: var(--vui-colors-dark-teal-10);\n}\n\n  .hover\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]) {\n    background-color: var(--vui-colors-cream-10);\n}\n\n  .hover\\:vui-bg-c_extra-dark-teal\\.10:is(:hover, [data-hover], [data-hovered]) {\n    background-color: var(--vui-colors-extra-dark-teal-10);\n}\n\n  .group:is(:hover, [data-hover], [data-hovered]) .groupHover\\:vui-bd-c_cream\\.100 {\n    border-color: var(--vui-colors-cream-100);\n}\n\n  .group:is(:hover, [data-hover], [data-hovered]) .groupHover\\:vui-bg-c_var\\(--switch-hover-thumb-color\\,_\\{colors\\.teal\\.100\\}\\) {\n    background-color: var(--switch-hover-thumb-color, var(--vui-colors-teal-100));\n}\n\n  .group:is(:hover, [data-hover], [data-hovered]) .groupHover\\:vui-bg-c_var\\(--switch-hover-thumb-color\\,_\\{colors\\.cream\\.100\\}\\) {\n    background-color: var(--switch-hover-thumb-color, var(--vui-colors-cream-100));\n}\n\n  .hover\\:vui-bd-b-c_accent\\.primary:is(:hover, [data-hover], [data-hovered]) {\n    border-bottom-color: var(--vui-colors-accent-primary);\n}\n\n  .active\\:vui-bg-c_cream\\.100:is(:active, [data-active], [data-state=\"active\"]) {\n    background-color: var(--vui-colors-cream-100);\n}\n\n  .dark\\:disabled\\:vui-c_text\\.primary\\.reversed.dark:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),.dark .dark\\:disabled\\:vui-c_text\\.primary\\.reversed:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),[data-color-mode=dark] .dark\\:disabled\\:vui-c_text\\.primary\\.reversed:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    color: var(--vui-colors-text-primary-reversed);\n}\n\n  .dark\\:disabled\\:vui-cursor_not-allowed.dark:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),.dark .dark\\:disabled\\:vui-cursor_not-allowed:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),[data-color-mode=dark] .dark\\:disabled\\:vui-cursor_not-allowed:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    cursor: not-allowed;\n}\n\n  .\\[\\&_ul\\]\\:\\[\\&_li\\:first-child\\]\\:vui-li-s_\\[none\\] ul li:first-child {\n    list-style: none;\n}\n\n  .group:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]) .groupInvalid\\:dark\\:vui-c_error-red\\.60.dark,.group:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]) .dark .groupInvalid\\:dark\\:vui-c_error-red\\.60,.group:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]) [data-color-mode=dark] .groupInvalid\\:dark\\:vui-c_error-red\\.60 {\n    color: var(--vui-colors-error-red-60);\n}\n\n  .dark\\:disabled\\:vui-c_gray\\.80.dark:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),.dark .dark\\:disabled\\:vui-c_gray\\.80:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),[data-color-mode=dark] .dark\\:disabled\\:vui-c_gray\\.80:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    color: var(--vui-colors-gray-80);\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:\\[\\&\\]\\:vui---switch-hover-thumb-color_\\{colors\\.gray\\.40\\} {\n    --switch-hover-thumb-color: var(--vui-colors-gray-40);\n}\n\n  .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-cursor_pointer.dark[data-selected],.dark .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-cursor_pointer[data-selected],[data-color-mode=dark] .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-cursor_pointer[data-selected] {\n    cursor: pointer;\n}\n\n  .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-c_accent\\.secondary.dark[data-selected],.dark .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-c_accent\\.secondary[data-selected],[data-color-mode=dark] .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-c_accent\\.secondary[data-selected] {\n    color: var(--vui-colors-accent-secondary);\n}\n\n  .dark\\:hover\\:vui-cursor_pointer.dark:is(:hover, [data-hover], [data-hovered]),.dark .dark\\:hover\\:vui-cursor_pointer:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .dark\\:hover\\:vui-cursor_pointer:is(:hover, [data-hover], [data-hovered]) {\n    cursor: pointer;\n}\n\n  .dark\\:\\[\\&_svg\\]\\:vui-c_cream\\.100.dark svg,.dark .dark\\:\\[\\&_svg\\]\\:vui-c_cream\\.100 svg,[data-color-mode=dark] .dark\\:\\[\\&_svg\\]\\:vui-c_cream\\.100 svg {\n    color: var(--vui-colors-cream-100);\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:\\[\\&_svg\\]\\:vui-c_accent\\.primary[data-selected] svg {\n    color: var(--vui-colors-accent-primary);\n}\n\n  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer[data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer).dark,.dark .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer[data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer),[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer[data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-cursor_pointer) {\n    cursor: pointer;\n}\n\n  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:vui-cursor_pointer:not([data-selected]):is([data-orientation=\"vertical\"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:vui-cursor_pointer):is(:hover, [data-hover], [data-hovered]) {\n    cursor: pointer;\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&_svg\\]\\:vui-c_\\[gray\\.60\\][data-disabled] svg {\n    color: var(--vui-colors-gray-60);\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:hover\\:vui-cursor_not-allowed[data-disabled]:is(:hover, [data-hover], [data-hovered]) {\n    cursor: not-allowed;\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-cursor_not-allowed[data-disabled][data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-cursor_not-allowed[data-disabled]) {\n    cursor: not-allowed;\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"horizontal\\\"\\]_\\&\\)\\]\\:vui-cursor_not-allowed[data-disabled]:not([data-selected]):is([data-orientation=\"horizontal\"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"horizontal\\\"\\]_\\&\\)\\]\\:vui-cursor_not-allowed[data-disabled]) {\n    cursor: not-allowed;\n}\n\n  .invalid\\:placeholder\\:vui-c_error-red\\.100:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"])::placeholder,.invalid\\:placeholder\\:vui-c_error-red\\.100:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"])[data-placeholder] {\n    color: var(--vui-colors-error-red-100);\n}\n\n  .dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\].dark::placeholder,.dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\].dark[data-placeholder],.dark .dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\]::placeholder,.dark .dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\][data-placeholder],[data-color-mode=dark] .dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\]::placeholder,[data-color-mode=dark] .dark\\:placeholder\\:vui-c_\\[calc\\(text\\.primary\\/50\\)\\][data-placeholder] {\n    color: calc(text.primary/50);\n}\n\n  .group:is([aria-selected=true], [data-selected], [data-state=\"selected\"]) .groupSelected\\:\\[\\&\\]\\:vui-bd-c_\\[transparent\\] {\n    border-color: transparent;\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:\\[\\&\\]\\:vui-bd-c_\\[currentColor\\] {\n    border-color: currentColor;\n}\n\n  .dark\\:disabled\\:vui-bg-c_gray\\.20.dark:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),.dark .dark\\:disabled\\:vui-bg-c_gray\\.20:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),[data-color-mode=dark] .dark\\:disabled\\:vui-bg-c_gray\\.20:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-gray-20);\n}\n\n  .dark\\:disabled\\:vui-bd-c_gray\\.40.dark:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),.dark .dark\\:disabled\\:vui-bd-c_gray\\.40:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),[data-color-mode=dark] .dark\\:disabled\\:vui-bd-c_gray\\.40:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    border-color: var(--vui-colors-gray-40);\n}\n\n  .group:is([aria-selected=true], [data-selected], [data-state=\"selected\"]) .groupSelected\\:before\\:vui-bg-c_\\[white\\]::before {\n    background-color: white;\n}\n\n  .group:is(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) .groupDisabled\\:before\\:vui-bg-c_\\[white\\]::before {\n    background-color: white;\n}\n\n  .group:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]) .groupInvalid\\:before\\:vui-bg-c_\\[white\\]::before {\n    background-color: white;\n}\n\n  .group:is([aria-selected=true], [data-selected], [data-state=\"selected\"]) .groupSelected\\:before\\:vui-bg-c_dark-teal\\.100::before {\n    background-color: var(--vui-colors-dark-teal-100);\n}\n\n  .group:is([aria-selected=true], [data-selected], [data-state=\"selected\"]) .groupSelected\\:\\[\\&\\]\\:vui-bd-c_\\[currentColor\\] {\n    border-color: currentColor;\n}\n\n  .group:is([aria-selected=true], [data-selected], [data-state=\"selected\"]) .groupSelected\\:\\[\\&\\]\\:vui-bg-c_\\[currentColor\\] {\n    background-color: currentColor;\n}\n\n  .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-bd-c_accent\\.secondary.dark[data-selected],.dark .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-bd-c_accent\\.secondary[data-selected],[data-color-mode=dark] .dark\\:\\[\\&\\[data-selected\\]\\]\\:vui-bd-c_accent\\.secondary[data-selected] {\n    border-color: var(--vui-colors-accent-secondary);\n}\n\n  .dark\\:hover\\:vui-bd-e-c_accent\\.secondary.dark:is(:hover, [data-hover], [data-hovered]),.dark .dark\\:hover\\:vui-bd-e-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .dark\\:hover\\:vui-bd-e-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]) {\n    border-inline-end-color: var(--vui-colors-accent-secondary);\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-t-c_\\[transparent\\][data-selected].dark,.dark .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-t-c_\\[transparent\\][data-selected],[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-t-c_\\[transparent\\][data-selected] {\n    border-top-color: transparent;\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-l-c_\\[transparent\\][data-selected].dark,.dark .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-l-c_\\[transparent\\][data-selected],[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-l-c_\\[transparent\\][data-selected] {\n    border-left-color: transparent;\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-r-c_\\[transparent\\][data-selected].dark,.dark .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-r-c_\\[transparent\\][data-selected],[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-r-c_\\[transparent\\][data-selected] {\n    border-right-color: transparent;\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_accent\\.secondary[data-selected].dark,.dark .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_accent\\.secondary[data-selected],[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_accent\\.secondary[data-selected] {\n    border-bottom-color: var(--vui-colors-accent-secondary);\n}\n\n  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary[data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary).dark,.dark .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary[data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary),[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary[data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-e-c_accent\\.secondary) {\n    border-inline-end-color: var(--vui-colors-accent-secondary);\n}\n\n  .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\][data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\]).dark,.dark .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\][data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\]),[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\][data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:dark\\:vui-bd-b-c_\\[transparent\\]) {\n    border-bottom-color: transparent;\n}\n\n  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-e-c_accent\\.primary:not([data-selected]):is([data-orientation=\"vertical\"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-e-c_accent\\.primary):is(:hover, [data-hover], [data-hovered]) {\n    border-inline-end-color: var(--vui-colors-accent-primary);\n}\n\n  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-b-c_\\[transparent\\]:not([data-selected]):is([data-orientation=\"vertical\"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-b-c_\\[transparent\\]):is(:hover, [data-hover], [data-hovered]) {\n    border-bottom-color: transparent;\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:dark\\:vui-bd-c_\\[transparent\\][data-disabled].dark,.dark .\\[\\&\\[data-disabled\\]\\]\\:dark\\:vui-bd-c_\\[transparent\\][data-disabled],[data-color-mode=dark] .\\[\\&\\[data-disabled\\]\\]\\:dark\\:vui-bd-c_\\[transparent\\][data-disabled] {\n    border-color: transparent;\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:hover\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered]) {\n    border-bottom-color: transparent;\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:vui-bd-b-c_gray\\.30[data-disabled][data-selected] {\n    border-bottom-color: var(--vui-colors-gray-30);\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-e-c_gray\\.30[data-disabled][data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-e-c_gray\\.30[data-disabled]) {\n    border-inline-end-color: var(--vui-colors-gray-30);\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\][data-disabled][data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\][data-disabled]) {\n    border-bottom-color: transparent;\n}\n\n  .hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:hover, [data-hover], [data-hovered]).dark,.dark .hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:hover, [data-hover], [data-hovered]),.hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:focus, [data-focus], [data-focused=true]).dark,.dark .hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:focus, [data-focus], [data-focused=true]),[data-color-mode=dark] .hoverOrFocus\\:dark\\:vui-scr-bar-c_\\[color-mix\\(in_srgb\\,_background_50\\%\\,_white\\)_transparent\\]:is(:focus, [data-focus], [data-focused=true]) {\n    scrollbar-color: color-mix(in srgb, background 50%, white) transparent;\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_pink\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-pink-10);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_green\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-green-10);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_purple\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-purple-10);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_warning-orange\\.20:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-warning-orange-20);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_error-red\\.20:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-error-red-20);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_info-blue\\.20:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-info-blue-20);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_success-green\\.20:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-success-green-20);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_teal\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-teal-10);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_dark-teal\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-dark-teal-10);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-cream-10);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_pink\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-pink-80);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_green\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-green-80);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_purple\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-purple-80);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_info-blue\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-info-blue-80);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_success-green\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-success-green-80);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_warning-orange\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-warning-orange-80);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_error-red\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-error-red-80);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_cream\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-cream-80);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_teal\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-teal-80);\n}\n\n  .hover\\:notDisabled\\:vui-bg-c_dark-teal\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-dark-teal-80);\n}\n\n  .hover\\:notDisabled\\:vui-bd-c_green\\.100:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    border-color: var(--vui-colors-green-100);\n}\n\n  .hover\\:notDisabled\\:vui-td-c_\\[inherit\\]:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    text-decoration-color: inherit;\n}\n\n  .hover\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]).dark,.dark .hover\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .hover\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]) {\n    background-color: var(--vui-colors-cream-10);\n}\n\n  .hover\\:dark\\:vui-bg-c_extra-dark-teal\\.10:is(:hover, [data-hover], [data-hovered]).dark,.dark .hover\\:dark\\:vui-bg-c_extra-dark-teal\\.10:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .hover\\:dark\\:vui-bg-c_extra-dark-teal\\.10:is(:hover, [data-hover], [data-hovered]) {\n    background-color: var(--vui-colors-extra-dark-teal-10);\n}\n\n  .hover\\:dark\\:vui-bd-b-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]).dark,.dark .hover\\:dark\\:vui-bd-b-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .hover\\:dark\\:vui-bd-b-c_accent\\.secondary:is(:hover, [data-hover], [data-hovered]) {\n    border-bottom-color: var(--vui-colors-accent-secondary);\n}\n\n  .hover\\:dark\\:vui-bd-r-c_\\[transparent\\]:is(:hover, [data-hover], [data-hovered]).dark,.dark .hover\\:dark\\:vui-bd-r-c_\\[transparent\\]:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .hover\\:dark\\:vui-bd-r-c_\\[transparent\\]:is(:hover, [data-hover], [data-hovered]) {\n    border-right-color: transparent;\n}\n\n  .active\\:dark\\:vui-bg-c_extra-dark-teal\\.100:is(:active, [data-active], [data-state=\"active\"]).dark,.dark .active\\:dark\\:vui-bg-c_extra-dark-teal\\.100:is(:active, [data-active], [data-state=\"active\"]),[data-color-mode=dark] .active\\:dark\\:vui-bg-c_extra-dark-teal\\.100:is(:active, [data-active], [data-state=\"active\"]) {\n    background-color: var(--vui-colors-extra-dark-teal-100);\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_accent\\.secondary[data-selected].dark svg,.dark .\\[\\&\\[data-selected\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_accent\\.secondary[data-selected] svg,[data-color-mode=dark] .\\[\\&\\[data-selected\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_accent\\.secondary[data-selected] svg {\n    color: var(--vui-colors-accent-secondary);\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_\\[gray\\.60\\][data-disabled].dark svg,.dark .\\[\\&\\[data-disabled\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_\\[gray\\.60\\][data-disabled] svg,[data-color-mode=dark] .\\[\\&\\[data-disabled\\]\\]\\:dark\\:\\[\\&_svg\\]\\:vui-c_\\[gray\\.60\\][data-disabled] svg,.\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-c_gray\\.60[data-disabled][data-selected].dark,.dark .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-c_gray\\.60[data-disabled][data-selected],[data-color-mode=dark] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-c_gray\\.60[data-disabled][data-selected] {\n    color: var(--vui-colors-gray-60);\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:vui-cursor_not-allowed[data-disabled]:not([data-selected]):is([data-orientation=\"vertical\"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:vui-cursor_not-allowed[data-disabled]):is(:hover, [data-hover], [data-hovered]) {\n    cursor: not-allowed;\n}\n\n  .invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]).dark::placeholder,.invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"]).dark[data-placeholder],.dark .invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"])::placeholder,.dark .invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"])[data-placeholder],[data-color-mode=dark] .invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"])::placeholder,[data-color-mode=dark] .invalid\\:dark\\:placeholder\\:vui-c_error-red\\.60:is([aria-invalid=true], [data-invalid], [data-state=\"invalid\"])[data-placeholder] {\n    color: var(--vui-colors-error-red-60);\n}\n\n  .\\[\\&\\[aria-selected\\=false\\]\\]\\:hover\\:notDisabled\\:vui-bd-c_green\\.40[aria-selected=false]:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    border-color: var(--vui-colors-green-40);\n}\n\n  .\\[\\&\\[data-selected\\]\\]\\:hover\\:notDisabled\\:vui-bd-c_green\\.40[data-selected]:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    border-color: var(--vui-colors-green-40);\n}\n\n  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary:not([data-selected]):is([data-orientation=\"vertical\"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary):is(:hover, [data-hover], [data-hovered]).dark,.dark .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary:not([data-selected]):is([data-orientation=\"vertical\"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary):is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary:not([data-selected]):is([data-orientation=\"vertical\"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-e-c_accent\\.secondary):is(:hover, [data-hover], [data-hovered]) {\n    border-inline-end-color: var(--vui-colors-accent-secondary);\n}\n\n  .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]:not([data-selected]):is([data-orientation=\"vertical\"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]):is(:hover, [data-hover], [data-hovered]).dark,.dark .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]:not([data-selected]):is([data-orientation=\"vertical\"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]):is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]:not([data-selected]):is([data-orientation=\"vertical\"] .\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\]):is(:hover, [data-hover], [data-hovered]) {\n    border-bottom-color: transparent;\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered]).dark,.dark .\\[\\&\\[data-disabled\\]\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered]),[data-color-mode=dark] .\\[\\&\\[data-disabled\\]\\]\\:hover\\:dark\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered]) {\n    border-bottom-color: transparent;\n}\n\n  :is(.\\[\\&\\[data-disabled\\]\\]\\:hover\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-e-c_gray\\.30[data-disabled]:is(:hover, [data-hover], [data-hovered]))[data-selected]:is([data-orientation=\"vertical\"] :is(.\\[\\&\\[data-disabled\\]\\]\\:hover\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-e-c_gray\\.30[data-disabled]:is(:hover, [data-hover], [data-hovered]))) {\n    border-inline-end-color: var(--vui-colors-gray-30);\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:hover\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered])[data-selected]:is([data-orientation=\"vertical\"] .\\[\\&\\[data-disabled\\]\\]\\:hover\\:\\[\\&\\[data-selected\\]\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:vui-bd-b-c_\\[transparent\\][data-disabled]:is(:hover, [data-hover], [data-hovered])) {\n    border-bottom-color: transparent;\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_gray\\.30[data-disabled][data-selected].dark,.dark .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_gray\\.30[data-disabled][data-selected],[data-color-mode=dark] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\[data-selected\\]\\]\\:dark\\:vui-bd-b-c_gray\\.30[data-disabled][data-selected] {\n    border-bottom-color: var(--vui-colors-gray-30);\n}\n\n  .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-c_\\[transparent\\][data-disabled]:not([data-selected]):is([data-orientation=\"vertical\"] .\\[\\&\\[data-disabled\\]\\]\\:\\[\\&\\:not\\(\\[data-selected\\]\\)\\:is\\(\\[data-orientation\\=\\\"vertical\\\"\\]_\\&\\)\\]\\:hover\\:vui-bd-c_\\[transparent\\][data-disabled]):is(:hover, [data-hover], [data-hovered]) {\n    border-color: transparent;\n}\n\n  .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]).dark,.dark .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),[data-color-mode=dark] .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-cream-10);\n}\n\n  .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]).dark,.dark .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),[data-color-mode=dark] .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.10:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-dark-teal-10);\n}\n\n  .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]).dark,.dark .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),[data-color-mode=dark] .hover\\:notDisabled\\:dark\\:vui-bg-c_cream\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-cream-80);\n}\n\n  .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]).dark,.dark .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]),[data-color-mode=dark] .hover\\:notDisabled\\:dark\\:vui-bg-c_dark-teal\\.80:is(:hover, [data-hover], [data-hovered]):not(:disabled, [disabled], [data-disabled], [data-state=\"disabled\"]) {\n    background-color: var(--vui-colors-dark-teal-80);\n}\n\n  @media screen and (min-width: 37.5rem) {\n    .sm\\:vui-w_\\[100\\%\\] {\n      width: 100%;\n}\n    .sm\\:vui-h_\\[100\\%\\] {\n      height: 100%;\n}\n}\n\n  @media screen and (min-width: 37.5rem) and (max-width: 56.2475rem) {\n    .smOnly\\:vui-bdr_\\[8px\\] {\n      border-radius: 8px;\n}\n    .smOnly\\:vui-p_\\[16px\\] {\n      padding: 16px;\n}\n    .smOnly\\:vui-p_\\[16px_24px\\] {\n      padding: 16px 24px;\n}\n}\n\n  @media screen and (min-width: 56.25rem) {\n    .md\\:vui-w_\\[320px\\] {\n      width: 320px;\n}\n    .md\\:vui-h_\\[100\\%\\] {\n      height: 100%;\n}\n    .md\\:vui-w_\\[100\\%\\] {\n      width: 100%;\n}\n    .md\\:vui-h_\\[320px\\] {\n      height: 320px;\n}\n    .md\\:vui-d_grid {\n      display: grid;\n}\n    .md\\:vui-gap_\\[16px\\] {\n      gap: 16px;\n}\n    .md\\:vui-grid-tc_repeat\\(2\\,_1fr\\) {\n      grid-template-columns: repeat(2, 1fr);\n}\n}\n\n  @media screen and (min-width: 75rem) {\n    .lg\\:vui-w_\\[320px\\] {\n      width: 320px;\n}\n    .lg\\:vui-h_\\[100\\%\\] {\n      height: 100%;\n}\n    .lg\\:vui-w_\\[100\\%\\] {\n      width: 100%;\n}\n    .lg\\:vui-h_\\[320px\\] {\n      height: 320px;\n}\n    .lg\\:vui-gap_\\[16px\\] {\n      gap: 16px;\n}\n    .lg\\:vui-grid-tc_\\[repeat\\(4\\,_1fr\\)\\] {\n      grid-template-columns: repeat(4, 1fr);\n}\n    .lg\\:vui-jc_space-between {\n      justify-content: space-between;\n}\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
